// TODO: CURRENTUS: Test it on env with markers on map
import {
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    OnDestroy,
    OnInit,
    ViewChild,
    HostListener,
    ElementRef,
    ViewEncapsulation,
    ViewChildren,
    QueryList,
    NgZone,
} from '@angular/core';
import { MatLegacySnackBar as MatSnackBar } from '@angular/material/legacy-snack-bar';
import { MatLegacyDialog as MatDialog, MatLegacyDialogConfig as MatDialogConfig, MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';
import { MatMenuTrigger } from '@angular/material/menu';
import { ActivatedRoute, ParamMap, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { UsersService } from 'app/pages/admin/users.service';
import { MatLegacyTabChangeEvent as MatTabChangeEvent } from '@angular/material/legacy-tabs';
import { transform } from 'ol/proj';
import { DomOperationUtilsService } from '../shared/utils/dom-operation-utils.service';
import { UiUtilsService } from '../shared/utils/ui-utils.service';
import { fitMapPopup, getVisibleLayerFeatures, MapPopupBounds } from '../shared/utils/map-popup.util';
import { keepMapLayersOnTop, MONITOR_FOREGROUND_CLASS_NAME } from '../shared/utils/map-layer-order.util';
import { StatusCodeService } from '../shared/services/status-code.service';
import { SignalRService } from '../shared/services/signalr.service';
import { SignalRMessage } from 'app/shared/models/signalr-message';
import { Observable, combineLatest, Subject, Subscription, BehaviorSubject, from, of, forkJoin, firstValueFrom } from 'rxjs';
import OLMap from 'ol/Map';
import View from 'ol/View';
import Feature, { FeatureLike } from 'ol/Feature';
import { createStyleFunction } from 'ol-esri-style';
import Geolocation from 'ol/Geolocation';
import { Attribution, Control, OverviewMap, ScaleLine, defaults as defaultControls } from 'ol/control';
import { Units } from 'ol/control/ScaleLine';
import Point from 'ol/geom/Point';
import { Layer, Group as LayerGroup, Tile as TileLayer, Vector as VectorLayer, VectorImage as VectorImageLayer, Image as ImageLayer } from 'ol/layer';
import { Cluster, XYZ, Vector as VectorSource, TileWMS, TileArcGISRest, Source, TileJSON, ImageArcGISRest } from 'ol/source';
import Draw from 'ol/interaction/Draw';
import GeoJSON from 'ol/format/GeoJSON';
import { bbox as bboxStrategy } from 'ol/loadingstrategy';
import { BasemapNames, GISService, LayerSettings, LegendInfo, LegendType } from 'app/shared/services/gis-service';
import {
    AppQueryParams,
    Customer,
    DialogQueryParams,
    GetAllRainGaugesParams,
    SubscriptionLevel
} from 'app/shared/models/customer';
import {
    BaseMapListItem,
    gisUserSettings,
    mapLayerList,
    featureSelList,
    userSettingLayerDetails,
    ServiceTypes,
    GisServiceList,
    ArcGISUserToken,
    GetArcGISUserTokenRequest,
    ArcGISFeatureLayer,
    ArcGISInternalLayer,
    ArcGISOrganizationContent,
    ArcGISFeatureService,
    ArcGISWebMap,
    ArcGISMapService,
    ESRI_VECTOR_LAYER_EXTENT_PROPERTY,
    ESRI_INCHES_PER_METER,
    ESRI_DOTS_PER_INCH,
} from 'app/shared/models/gis-service-list';
import {
    ArcGISRenderer,
    ArcGISSymbol,
    ArcGISDrawingInfo,
    ArcGISTreeNode,
    ArcGISLayerData,
    StyleFunction,
    AssetItem,
    AssetsSelectionEvent,
    ArcGISVisualVariable,
    ArcGISUniqueValueInfo,
    ArcGISClassBreakInfo,
    CIMSymbolLayer,
    CIMSymbolReference,
    ArcGISSelectionState,
    LayerTreeState,
    SelectedAsset,
    ServiceTokenContext,
    ESRI_SYMBOL_TYPES,
    ESRI_GEOMETRY_TYPES,
    ESRI_RENDERER_TYPES,
    ESRI_LINE_STYLES,
    ESRI_FILL_STYLES,
    ESRI_MARKER_STYLES,
    CIM_LAYER_TYPES,
    ArcGISFeature,
    ArcGISGeometry,
    ArcGISIdentifyParams,
    ArcGISIdentifyResult,
} from 'app/shared/models/arcgis-types';
import { ARCGIS_CONSTANTS, normalizePortalUrl } from 'app/shared/constants/arcgis-constants';
import { Polygon, Geometry, LineString } from 'ol/geom';
import { Circle as GeomCircle } from 'ol/geom';
import {
    measureStyle,
    monitorLegendOptions,
    generateCompositeLocationPopupTemplate,
    generateLocationsClusterPopupTemplate,
    generateLinePointPolygonPopupTemplate,
    monitorLocation,
    highlightLineOrPoint,
    monitorStyleFilter,
    pickSingleMonitorPopupTemplate,
    darkThemeColors,
    lightThemeColors,
    resolveMonitorSymbolType
} from 'app/shared/constant/mapStyle.constant';
import { apply } from 'ol-mapbox-style';
import { ChecklistDatabase, LocationLayerListComponent } from './location-layer-list/location-layer-list.component';
import { locationFeaturePropertyListComponent, feat_TodoItemNode, FeatureSelectionData, FeatureSelectionItem } from './location-feature-property-list/location-feature-property-list.component';
import { Config } from 'app/shared/services/config';
import { OLMAPPROJECTION, UnitOfMeasureType, RAIN_GAUGE } from 'app/shared/constant';
import { DragBox, Select, DoubleClickZoom } from 'ol/interaction';
import { platformModifierKeyOnly } from 'ol/events/condition';
import { debounceTime, filter, first, map, skip, startWith, tap } from 'rxjs/operators';
import { FormControl } from '@angular/forms';
import { LocationStepsGPSComponent } from './location-steps-gps/location-steps-gps.component';
import { fromLonLat } from 'ol/proj';
import * as turf from '@turf/turf';
import type { Feature as GeoJSONFeature, Polygon as GeoJSONPolygon, Point as GeoJSONPoint } from 'geojson';
import type { Extent } from 'ol/extent';
import TileState from 'ol/TileState';
import { CustomerDetailLocationService } from 'app/shared/services/customer-detail-location.service';
import { APIDataLocationsGetLocations, CustomerLocationDetail } from 'app/shared/models/customer-location-detail';
import {
    CompositeLocComponent,
    CompositeLocComponentInput,
    CompositeLocEditInput,
} from 'app/shared/components/map/composite-loc/composite-loc.component';
import GeometryType from 'ol/geom/GeometryType';
import flatMap from 'lodash/flatMap';
import BaseLayer from 'ol/layer/Base';
import EsriJSON from 'ol/format/EsriJSON';
import { DomSanitizer } from '@angular/platform-browser';
import { fromCircle } from 'ol/geom/Polygon';
import { Style, Fill, Stroke, RegularShape, Icon, Text } from 'ol/style';
import { Circle as StyleCircle } from 'ol/style';
import Heatmap from 'ol/layer/Heatmap';
import IconAnchorUnits from 'ol/style/IconAnchorUnits';
import { isEmpty, getCenter } from 'ol/extent';
import { GIS_USER_EXPIRES_UTC, GIS_USER_TOKEN, ARCGIS_USERNAME, ARCGIS_USER_FULLNAME, ARCGIS_USER_ORG_ID, MainComponent } from 'app/main';
import { LocationDashboardService } from 'app/shared/services/location-dashboard.service';
import { LocationGroupService } from 'app/shared/services/location-group.service';
import { ScheduleCollectionService } from 'app/shared/services/schedule-collection.service';
import { AlarmService } from 'app/shared/services/alarm.service';
import { AuthService } from 'app/shared/services/auth.service';
import { MapService } from 'app/shared/services/map.service';
import { LocationService } from 'app/shared/services/location.service';
import { BlockagePredictionService } from 'app/shared/services/blockage-prediction.service';
import { BatteryStatusService } from 'app/shared/services/battery-status.service';
import { EventService } from 'app/shared/services/event.service'
import { AutoScrubSummaryService } from 'app/shared/services/auto-scrub-summary.service';
import { CustomerService } from 'app/shared/services/customer.service';
import { DateutilService } from 'app/shared/services/dateutil.service';
import {
    activeInactiveLocationQueryParam,
    customerLocationGroupQueryParam,
    customerQueryParam,
    WIDGET_PARAM,
} from 'app/shared/models/customer';
import { LocationEntitiesData, LocationListArgs } from 'app/shared/models/locations-entities-data';
import { CumulativeRainRequest, LocationDetails, LocationDetailsModel } from 'app/shared/models/location-details';
import { LocationArgs, Locations, LocationStatus } from 'app/shared/models/locations';
import { AlarmsTotal, GetAlarmsArgs } from 'app/shared/models/alarms';
import { AlarmLiteResponseItem } from 'app/shared/models/active-alarm';
import { CollectionHistory, GetCollectHistoryArgs } from 'app/shared/models/collection-history';
import { AnomaliesCount } from 'app/shared/models/AnomaliesCount';
import { BatteryTotalCount } from 'app/shared/models/battery-total-count';
import { WidgetsPermission } from 'app/shared/models/widgets-permission';
import { AutoDetectDetectCountArgs } from 'app/shared/models/auto-scrub-details';
import { BatteryStatusEnum, BatteryStatusReportArgs } from 'app/shared/models/battery-status';
import { AlarmStatusChange } from 'app/shared/models/alarm-status-change';
import { MapBrowserEvent, Overlay } from 'ol';
import { LocationGisQuickLookComponent } from './location-gis-quick-look/location-gis-quick-look.component';
import { MatLegacyButton as MatButton } from '@angular/material/legacy-button';
import Projection from 'ol/proj/Projection';
import { AddEventDialogComponent } from 'app/pages/add-event-dialog/add-event-dialog.component';
import { EventModel, EventRain, EventTypes } from 'app/shared/models/event';
import { UiService } from 'app/shared/services/ui.service';
import { LayerNameOpts, MapAutocompleteItem, MapAutocompleteItemType, MonitorSymbolType } from 'app/shared/models/map-type';
import html2canvas from 'html2canvas';
import { EventRangeFilters, EventWidgetComponent } from 'app/pages/event-widget/event-widget.component';
import { IStormYearsColor, MapRain, MapRainColors, StormYearsColors, configureBasemapTileLayer, createBasemapTileLoadFunction, SAFE_MAX_ZOOM_LEVEL } from 'app/shared/models/map-view';
import { IN_TO_MM_FACTOR, MM_TO_MM_FACTOR } from 'app/shared/models/units';
import { CumulativeRainInfo } from 'app/pages/cumulative-rain-widget/cumulative-rain-widget.component';
import { LocationCardService } from 'app/shared/components/location-card/services/location-card.service';
import { UserPreferencesDateQuickSpan } from 'app/shared/models/user-settings';
import { DateService } from 'app/shared/services/date.service';
import { AdminBillingMetricsComponent } from 'app/pages/admin/admin-usage/admin-billing-metrics/admin-billing-metrics.component';
import { ComponentType } from '@angular/cdk/portal';
import { AdminCostAllocationComponent } from 'app/pages/admin/admin-usage/admin-cost-allocation/admin-cost-allocation.component';
import { EventsKey } from 'ol/events';
import { unByKey } from 'ol/Observable';
import { AlarmWidgetComponent } from 'app/pages/alarm-widget/alarm-widget.component';
import { TurnOffWidgetsDialogComponent } from './turn-off-widgets-dialog/turn-off-widgets-dialog.component';
import { TrackBy } from 'app/shared/utils/track-by';
import { LocationCardContainerDialogComponent } from 'app/shared/components/location-card/components/location-card-container/location-card-container.component';
import { LocationCardData } from 'app/shared/components/location-card/models/location-card.model';
import { ArcGISUserService } from 'app/shared/services/arcgis-user-service';
import { ArcGISOptimizedFetcherService } from 'app/shared/services/arcgis-optimized-fetcher.service';
import { ArcGISLayerCacheService } from 'app/shared/services/arcgis-layer-cache.service';
import { ArcGISSelectionPersistenceService } from 'app/shared/services/arcgis-selection-persistence.service';
import { ArcGISTokenManagerService } from 'app/shared/services/arcgis-token-manager.service';
import { ArcgisAssetsDropdownComponent } from './arcgis-assets-dropdown/arcgis-assets-dropdown.component';
import { ConfirmationDialogComponent } from 'app/shared/components/confirmation-dialog/confirmation-dialog.component';
import { IComponentModalResult } from 'app/shared/models/modal';

declare module 'ol/layer/BaseTile' {
    export interface Options {
        name: string;
    }
}
declare module 'ol/layer/Group' {
    export interface Options {
        name: string;
    }
}
declare module 'ol/layer/BaseVector' {
    export interface Options {
        name: string;
    }
}
declare module 'ol/layer/Base' {
    export interface Options {
        name: string;
    }
}

const MONITOR_LAYER_NAME = "Monitor";
const MAP_POPUP_HIDE_DELAY = 150;
const FEATURE_COLLECTION = 'FeatureCollection';
const esrijsonFormat = new EsriJSON();

enum TABS {
    WIDGET = 0,
    LAYERS = 1,
    TOOLS = 2,
}

const AUTO_REVIEW_REVIEW_REQUIRED = 'Review Required';
const AUTO_REVIEW_MISSING_DATA = 'Missing Data';

interface LayersParameterJson {
    zoomStatus: number;
}


interface ArrowMarkerConfig {
    style: string;
    placement: string;
    color: string;
    size: number;
}

interface StyleRendererResult {
    type: 'style';
    style: Style | Style[] | StyleFunction;
}

interface HeatmapRendererResult {
    type: 'heatmap';
    layer: Heatmap;
}

type RendererResult = StyleRendererResult | HeatmapRendererResult;

@Component({
    selector: 'app-location-dashboard',
    templateUrl: './home-map-dashboard.component.html',
    styleUrls: ['./home-map-dashboard.component.scss'],
})
export class HomeMapDashboardComponent implements OnInit, OnDestroy {
    @ViewChild('selectionlist') public featSelList: locationFeaturePropertyListComponent;
    @ViewChild('selectMenuTrigger') public selectMenuTrigger: MatButton;
    @ViewChild('measureMenuTrigger') public measureMenuTrigger: MatButton;
    @ViewChildren(AlarmWidgetComponent) public alarmWidgetComponent: QueryList<AlarmWidgetComponent>;
    // #46043 Get Start and end date from widget, ViewChildren because it is behind ngIf
    @ViewChildren('eventWidget') public eventWidgetList: QueryList<EventWidgetComponent>;
    // Once ngIf will proceed, map can be processed once reference to layerList is set, Bug #21292
    private layerList: LocationLayerListComponent;
    @ViewChild('layerlist') set content(content: LocationLayerListComponent) {
        if (content && !this.layerList) {
            this.layerList = content;
            this.initMap();
        }
    }

    @ViewChild('gisQuickLook') public gisQuickLook: LocationGisQuickLookComponent;
    @ViewChild('assetsMenuTrigger') assetsMenuTrigger: MatMenuTrigger;
    @ViewChild(ArcgisAssetsDropdownComponent) arcgisAssetsDropdown: ArcgisAssetsDropdownComponent;

    @ViewChild('popup') public popup: ElementRef<HTMLDivElement>;
    @ViewChild(EventWidgetComponent) private eventsWidget: EventWidgetComponent;

    @HostListener('window:beforeprint', ['$event']) public onBeforePrint(event?) {
        // Printing takes a screenshot of the screen to render
        // Since openLayers likes to just cut off instead of giving accurate printing, force an image to print
        this.createPrintMap();
    }

    @HostListener('document:click', ['$event']) public onDocumentClick(event: MouseEvent) {
        if (this.showArcgisAssetsOverlay) {
            this.closeArcgisAssetsOverlay();
        }
    }

    // Widget options
    public widgetOptions = WIDGET_PARAM;
    public currentWidget: WIDGET_PARAM = this.widgetOptions.ALL;
    public openedWidgetData;

    // Map options
    public olMap: OLMap;
    public overviewMapControl: OverviewMap;
    public olView: View;
    public baseLayers: LayerGroup;
    public SubscriptionLevel = SubscriptionLevel;
    public activeBaseMapId: string = null;
    public baseMapOptions: BaseMapListItem[];

    public geometryOptions = GeometryType;

    public activeMonitor: string = null;
    public assignedRainGauge = new Array<Locations>();
    public allRainLocations = new Array<Locations>();
    public locations: Array<Locations>;
    public filteredLocations: Locations[];
    public initialMapExtent: Extent;
    public customerHasChanged: boolean;
    public AdsMonitorLayerSource: VectorSource;
    public AdsMonitorLayerSourceCL: Cluster;
    public AdsMonitorLayer: VectorLayer;
    // public AdsMonitorLayerSourceOV: VectorSource;
    // public AdsMonitorLayerSourceCLOV: Cluster;
    public layerViewParam = '';
    public monitorLayerUrl: string;
    public customerID: number;
    public locationGroupID = 0;
    public projection = OLMAPPROJECTION;

    public prismLayers;
    public prismLayersGroup;
    public manHoleLayer;
    public manholeLayerSource;
    public pipeLayer;
    public pipeLayerSource;
    public basinLayer;
    public basinLayerSource;
    public prismLayerList: LayerSettings[] = [];
    public prismLayerGroupList: mapLayerList[] = [];
    public mapLayerLists: mapLayerList[] = [];
    public monitorSelList: featureSelList[] = [];
    public manholeSelList: featureSelList[] = [];
    public PipelineSelList: featureSelList[] = [];
    public basinSelList: featureSelList[] = [];
    public featureSelList: featureSelList[] = [];
    public selectionListing: FeatureSelectionData = {};
    public arcLayers: Record<string, BaseLayer> = {};
    private arrowMarkers = new WeakMap<Style, ArrowMarkerConfig>();
    public checkedLayersList: Set<number>;
    public alarmStateFinder = {};
    public monitorFeatureNamesSet: Set<string>;
    public monitorFeatureCollection: GeoJSONFeature[] = [];
    public foundSavedLayerExtents = false;
    public esriTileSource: TileArcGISRest;
    public esriTileLayer: TileLayer;
    public layerNameToEsriLayerId: { [index: string]: number };
    public defaultOpacity = 1;
    /**
     * OL map Measure variables
     */
    public propertyItemList = [];
    public prevPropertyItemList = [];

    public measureLayer: VectorLayer;
    public measureDraw: Draw | null = null;
    public measureSketch: Feature;
    public measurementUnit = 'us';
    private measureDoubleClickZoom: DoubleClickZoom | null = null;
    private measureSelectionEnabled: boolean | null = null;
    private measureRestoreTimeout: ReturnType<typeof setTimeout> | null = null;

    public dateFormat: string;
    public timeFormat: string;
    /*
     * select Interaction
     */
    public SelectionLayer: VectorLayer;
    public SelectionLayerSource: VectorSource;
    public HighlightLayer: VectorLayer;
    public HighlightLayerSource: VectorSource;
    public enableSelection = false;
    public selectInteraction: Select;
    public selectBoxInteraction: DragBox;
    public selectDrawInteraction: Draw;
    public selectedFeatures;
    public customerLocations = new Array<CustomerLocationDetail>();
    private compositeLocationDialog: MatDialogRef<CompositeLocComponent, IComponentModalResult> | null = null;
    /*
     * Scale Control
     */
    public scaleLinecontrol: ScaleLine;

    /**
     *Base Map Constant
     */

    public gisUserSetting: gisUserSettings;

    /*
     * GeoLocation Constant
     */

    public geolocation = new Geolocation({
        trackingOptions: {
            enableHighAccuracy: true,
        },
        tracking: true,
        projection: this.projection,
    });

    public accuracyFeature: Feature;
    public positionFeature: Feature;
    public subscriptionLevel: number;

    /**
     * Location Search Constant
     */
    //locationoptions : locationSearchOption[];
    // public locationoptions = [];
    public searchBarLocation: Observable<MapAutocompleteItem[]>;
    searchControl: FormControl = new FormControl();
    /**
     * sidebar
     */
    public sidebaropen = true;
    public sidebaropen2 = false;
    public layersParameterJson: LayersParameterJson | null = null;
    // public userSettingLayerDetailList: userSettingLayerDetails[];

    public activeLayersTab: number;

    public alarmLoadingState: boolean;
    public batteryLoadingState: boolean;
    public eventsLoadingState: boolean;
    public bpLoadingState: boolean;
    public bpLoadingLocations = false;
    public autoReviewLoadingState: boolean;
    public collectionLoadingState: boolean;
    public cumulativeRainLoadingState: boolean;
    public mapLoadingState: boolean;

    public customerLocationsLoaded = false;
    public updateAlarmTable = false;

    public batteryTotalCount: BatteryTotalCount;
    public autoReviewCount: AnomaliesCount;
    public blockagePredictionCount: number;
    public activeAlarmCount: number;

    public failedCollection: number;
    public upcomingScheduleCollection: string;
    public showMap = true;

    public showAlarmSearch = false;
    public showBlockagePredictionSearch = false;
    public showAutoReviwSearch = false;
    public showBatteryStatusSearch = false;
    public showCollectionSearch = false;
    public showEventSearch = false;
    public showCumulativeRainSearch = false;
    public toggleState = true;
    private subscriptions = new Array<Subscription>();
    public events: EventModel[] = [];
    public last30daysEventsCount: number;
    /*
     * @widgetsPermission varibale is used to map api data.
     */
    public widgetsPermission: WidgetsPermission;
    public widgetsPermissionBp: boolean;
    public widgetsPermissionAutoReview: boolean;
    /* as this is required to place widget tool in side bar*/
    public betaFlagBlockagePermission: boolean;
    public betaFlagAutoReviewPermission: boolean;

    /**
     * Represents the state of active and inactive locations
     * True will represent the both (active and inactive) locations
     * False will represent only active locations
     */
    public includeInactiveLocations = false;

    public availablePageHint = false;

    public anamoliesRefreshSuccessMsg: string;
    public anamoliesRefreshFailedMsg: string;
    public dismissBtn: string;
    public collectionTileLoadingState: boolean;

    public customerIDold = 0;
    public isLoading: boolean;
    private viewableLocationsIds: number[] = [];
    public isAutoReviewEnabled = false;
    public isAlarmMaintenance = false;

    public popupOverlay: Overlay;
    private mapHoverRequestId = 0;
    private popupHideTimeout: number | null = null;
    private popupResizeObserver: ResizeObserver | null = null;
    private readonly onMapPopupViewportChange = (): void => {
        this.hideMapTooltip();
    };
    private readonly onMapPopupScroll = (event: Event): void => {
        const target = event.target;
        if (
            target === document ||
            target === window ||
            (target instanceof Node && this.olMap && target.contains(this.olMap.getViewport()))
        ) {
            this.hideMapTooltip();
        }
    };
    saveSubject: Subject<void>;
    originalLocationsIds: number[];
    locationEntityData: LocationEntitiesData;
    featureclick: featureSelList[];
    locationId: number | null = null;

    private isDestroyed = false;

    public reloadBatteryLocations$ = new Subject<boolean>();
    // #23323 associative array - [locationId][locationGroupID]
    private locationGroups: number[][];

    private currentCustomerId = new BehaviorSubject(0);

    // #23600 hold state to enable/disable buttons
    public isAnyLayerSelected = false;
    public currentlyDisplayedLocationIds$ = new BehaviorSubject<number[]>([]);
    public displayMapRains = {
        overrideTooltip: false,
        customLegend: false,
        whiteLocations$: new BehaviorSubject<boolean>(false),
        rains$: new BehaviorSubject<MapRain[]>(null)
    }

    public rainLegend = {
        MapRainColors: MapRainColors,
        unitFactor: 1,
        unitPrecisionString: '1.2-2',
        unitTitle: ''
    }
    public stormYearsLegend = {
        StormYearsColors: StormYearsColors
    }


    private monitorsRefreshedSubject = new Subject<number>();

    public cumulativeRainInfo: CumulativeRainInfo;
    public cumulativeRainCachedInfo: CumulativeRainInfo;
    public cumulativeRainCachedQuickSpan: UserPreferencesDateQuickSpan;

    public attributionText: string;

    public routeQueryParams$: Subscription;
    private olSubscriptions: EventsKey[] = [];
    private monitorLayerOrderSubscription: EventsKey | null = null;

    private widgetConfig$: BehaviorSubject<{[key: number]: {enabled: boolean; changed: boolean}}> = new BehaviorSubject(null);
    public widgetConfig: {[key: number]: boolean} = {};
    public isUserAuthenticated: boolean = false;
    public userToken: ArcGISUserToken;
    public token: string = '';
    public customerGISServicesList: GisServiceList[];
    public arcgisFeatureLayers: ArcGISFeatureService[] = [];
    public arcgisWebMaps: ArcGISWebMap[] = [];
    public arcgisMapServices: ArcGISMapService[] = [];
    public arcgisOrganizationContent: ArcGISOrganizationContent = null;
    public arcgisOrganizationName: string = '';
    public activeAssetLayerId: number = null;
    public showAssetsDropdown: boolean = false;
    public arcgisLayerTreeNodes: Map<string, ArcGISTreeNode> = new Map();
    public arcgisMapLayers: Map<string, VectorLayer | VectorImageLayer> = new Map();
    public arcgisImageLayers: Map<string, ImageLayer> = new Map();
    private arcgisAssetLayers: Map<number, VectorLayer | Heatmap> = new Map();
    private arcgisAssetSources: Map<number, VectorSource> = new Map();
    private layerVisibilityTimeout: ReturnType<typeof setTimeout> | null = null;
    private removedArcGISLayers: (VectorLayer | VectorImageLayer)[] = [];
    private symbolCache: Map<string, ArcGISSymbol> = new Map();
    private arcgisLayerStyleCache: Map<string, Map<string, Style | Style[]>> = new Map();
    private geometryTypesLoaded: Set<string> = new Set();
    private selectionRestorationSubscription: Subscription | null = null;
    private inFlightLayerPlots = new Set<string>();

    public showArcgisAssetsOverlay = false;
    public arcgisAssetsOverlayPosition = { top: 0, left: 0 };
    public arcgisAssetsSearchTerm = '';
    public filteredArcgisAssets: (ArcGISFeatureService | ArcGISWebMap)[] = [];
    public selectedArcgisAssetsMap = new Map<string, AssetItem>();
    public get hasFilteredArcgisAssets() { return this.filteredArcgisAssets && this.filteredArcgisAssets.length > 0; }

    private updateSelectedArcgisAssetsMap(updateFn: (map: Map<string, AssetItem>) => void): void {
        const newMap = new Map(this.selectedArcgisAssetsMap);
        updateFn(newMap);
        this.selectedArcgisAssetsMap = newMap;
    }

    public trackByBaseMapId = TrackBy.byUniqueKey<BaseMapListItem>()('baseMapId');
    public trackByAssetLayerId = TrackBy.byUniqueKey<ArcGISFeatureLayer>()('id');
    public trackByFeatureAutocomplete = TrackBy.byKeyWithFallback<MapAutocompleteItem>('id', 'name');
    public trackByValue = TrackBy.byValue();
    public trackByColor = TrackBy.byUniqueKey<IStormYearsColor>()('color');

    constructor(
        private activatedRoute: ActivatedRoute,
        private locationDashboardService: LocationDashboardService,
        public usersService: UsersService,
        private locationGroupService: LocationGroupService,
        private batteryStatusService: BatteryStatusService,
        private autoScrubSummaryService: AutoScrubSummaryService,
        private snackBar: MatSnackBar,
        private cdr: ChangeDetectorRef,
        private scheduleCollectionService: ScheduleCollectionService,
        private alarmService: AlarmService,
        private blockagePredictionService: BlockagePredictionService,
        private dateutilService: DateutilService,
        private dateService: DateService,
        private statusCodeService: StatusCodeService,
        private uiUtilsService: UiUtilsService,
        public domOperationUtilsService: DomOperationUtilsService,
        public translate: TranslateService,
        public signalRService: SignalRService,
        private router: Router,
        private authService: AuthService,
        public gisService: GISService,
        private dialog: MatDialog,
        private mapService: MapService,
        private locationService: LocationService,
        private customerLocationService: CustomerDetailLocationService,
        private _sanitizer: DomSanitizer,
        private mainComponent: MainComponent,
        private eventService: EventService,
        public uiService: UiService,
        private layersDatabase: ChecklistDatabase,
        private customerService: CustomerService,
        private locationCardService: LocationCardService,
        private arcgisUserService: ArcGISUserService,
        private arcgisFetcher: ArcGISOptimizedFetcherService,
        private arcgisLayerCache: ArcGISLayerCacheService,
        private arcgisSelectionPersistence: ArcGISSelectionPersistenceService,
        private arcgisTokenManager: ArcGISTokenManagerService,
        private ngZone: NgZone
    ) {
        this.routeQueryParams$ = activatedRoute.queryParams.subscribe((params: AppQueryParams) => {
            switch(params.dialog) {
                case DialogQueryParams.CostAllocation:
                    this.openPopupDialog(AdminCostAllocationComponent);
                    break;
                case DialogQueryParams.Usage:
                    this.openPopupDialog(AdminBillingMetricsComponent);
                    break;
                default:
                    break;
            }
          });
    }

    public openPopupDialog(dialogClass: ComponentType<AdminCostAllocationComponent | AdminBillingMetricsComponent>) {
        this.dialog.open(dialogClass, {
            panelClass: 'no-padding-nor-overflow-relative-dialog',
            backdropClass: 'cdk-overlay-light-backdrop'
        });
    }

    public ngOnInit() {
        this.domOperationUtilsService.isHomePageWidgetToggled = true;
        this.domOperationUtilsService.homePageSelectedWidget = this.widgetOptions.ALL;
        this.subscriptions.push(
            this.locationService.locationChange.pipe(debounceTime(400)).subscribe((x) => {
                this.onLocationChange(x);
            }),
        );

        // #42467 If widget is turned off, don't request data
        this.usersService.userSettingsWidgetConfig().subscribe((config) => {
            const widgetConfigUpdateInfo: { [key: number]: {enabled: boolean; changed: boolean}} = {};

            if(config) {
                for(const [i,v] of Object.entries(config)) {
                    widgetConfigUpdateInfo[i] = {
                        enabled: v,
                        changed: this.widgetConfig[i] !== v
                    };
                }
            }
            this.widgetConfig = config ?? {};
            this.widgetConfig$.next(widgetConfigUpdateInfo);
        })

        this.subscriptions.push(
            combineLatest([
                this.usersService.isAutoReviewAllowed,
                this.usersService.isBlockagePredictionAllowed,
                this.usersService.isAlarmMaintenanceAllowed
            ]).subscribe(([isAR, isBP, isAlarmMaintenance]) => {
                this.isAutoReviewEnabled = isAR.value;
                this.widgetsPermissionAutoReview = isAR.value;
                this.betaFlagAutoReviewPermission = isAR.isbeta;

                this.widgetsPermissionBp = isBP.value;
                this.betaFlagBlockagePermission = isBP.isbeta;

                this.isAlarmMaintenance = isAlarmMaintenance;
            }),
        );

        this.subscriptions.push(
            this.domOperationUtilsService.homeDashboardChangeOverlay.subscribe((v: -1 | 1) => {
                let newTabValue = this.domOperationUtilsService.selectedGisTab.getValue() + v;
                if (newTabValue > 3) {
                    newTabValue = 0;
                } else if (newTabValue < 0) {
                    newTabValue = 2;
                } else {
                    newTabValue = newTabValue;
                }

                this.checkToPopulateDemoMonitorData(newTabValue);
                this.activeLayersTab = newTabValue === 3 ? 2 : newTabValue;
                this.domOperationUtilsService.selectedGisTab.next(newTabValue);
            }),
        );
        this.currentWidget = this.widgetOptions.ALL;
        this.translate.get('LOCATION_DASHBOARD.ANAMOLIES_REFRESH_SUCCESS').subscribe((res: string) => {
            this.anamoliesRefreshSuccessMsg = res;
        });
        this.translate.get('LOCATION_DASHBOARD.ANAMOLIES_REFRESH_FAILED').subscribe((res: string) => {
            this.anamoliesRefreshFailedMsg = res;
        });
        this.translate.get('COMMON.DISMISS_TEXT').subscribe((res: string) => {
            this.dismissBtn = res;
        });
        //  subscribe to customer change
        const queryParamsSubs = this.activatedRoute.queryParamMap
            .subscribe((params: ParamMap) => {
                // get updated customer id
                const currentCustomerID = Number(params.get(customerQueryParam));
                const locationGroupID = Number(params.get(customerLocationGroupQueryParam));
                const includeInactiveLocations = Boolean(Number(params.get(activeInactiveLocationQueryParam)));

                if (!currentCustomerID) return;

                // #23462 check if there is any reason to reload locations
                const refreshLocations =
                    currentCustomerID !== this.customerID
                    || locationGroupID !== this.locationGroupID && locationGroupID !== null && locationGroupID !== undefined
                    || (this.customerID > 0 && includeInactiveLocations !== this.includeInactiveLocations);

                if (this.AdsMonitorLayerSource && refreshLocations) {
                    this.AdsMonitorLayerSource.clear();
                }

                this.customerID = currentCustomerID;

                const getProjectDetailsSubscription = this.customerService.getProjectDetails(this.customerID).subscribe(
                    (res) => {
                        this.subscriptionLevel = res.subscriptionLevel;
                        this.uiUtilsService.safeChangeDetection(this.cdr);
                    }
                );
                this.subscriptions.push(getProjectDetailsSubscription);

                this.currentCustomerId.next(this.customerID);
                if (currentCustomerID != undefined && currentCustomerID != 0) {
                    localStorage.setItem('CustomerId', currentCustomerID.toString());
                    this.loadGisUserSettings();
                }

                const unitsSub = this.customerService.getCustomerUnits(this.customerID).subscribe(() => {
                    if(this.customerService.customer.unitsType === UnitOfMeasureType.METRIC) {
                        this.rainLegend.unitTitle = 'mm';
                        this.rainLegend.unitFactor = IN_TO_MM_FACTOR;
                        this.rainLegend.unitPrecisionString = '1.1-1';
                    } else {
                        this.rainLegend.unitTitle = 'in';
                        this.rainLegend.unitFactor = MM_TO_MM_FACTOR;
                        this.rainLegend.unitPrecisionString = '1.2-2';
                    }
                },
                () => {},
                () => {
                    unitsSub.unsubscribe();
                });

                if (currentCustomerID !== this.customerIDold && currentCustomerID > 0) {
                    this.gisService.layerToFeaturesRelation.clear();
                    this.checkAndHideWidgetsOnCustomerChange();
                    this.customerIDold = currentCustomerID;
                    this.customerID = currentCustomerID;
                    this.currentCustomerId.next(this.customerID);
                    this.locationGroupID = locationGroupID || 0;
                    this.includeInactiveLocations = includeInactiveLocations;
                    this.customerHasChanged = true;
                    this.onCustomerChange();
                } else if (locationGroupID !== this.locationGroupID && this.customerID > 0) {
                    this.gisService.layerToFeaturesRelation.clear();
                    this.locationGroupID = locationGroupID;
                    this.customerHasChanged = false;
                    this.onCustomerChange();
                } else if (includeInactiveLocations !== this.includeInactiveLocations && this.customerID > 0) {
                    this.gisService.layerToFeaturesRelation.clear();
                    this.includeInactiveLocations = includeInactiveLocations;
                    this.customerHasChanged = false;
                    this.onCustomerChange();
                }

                this.searchControl.setValue('');
                this.searchControl.updateValueAndValidity({ onlySelf: true, emitEvent: true });

                // #23323 fetch location groups and store them in associative array
                this.subscriptions.push(
                    this.locationGroupService.getLocationGroups(this.customerID).subscribe((res) => {
                        if (res.locationGroups) {
                            this.locationGroups = [];
                            for (const g of res.locationGroups) {
                                for (const l of g.locations) {
                                    if (!this.locationGroups[l.locationID]) {
                                        this.locationGroups[l.locationID] = [];
                                    }
                                    this.locationGroups[l.locationID].push(g.locationGroupID);
                                }
                            }
                        }
                    })
                )


                // TODO: On startup This causes second OWS call being made, however it won't work without logic inside
                // #23462 reload locations only if there is a reason for it
                if (refreshLocations) {
                    this.currentlyDisplayedLocationIds$.next([]);
                    this.displayMapRains.overrideTooltip = false;
                    this.displayMapRains.customLegend = false;
                    this.displayMapRains.whiteLocations$.next(false);
                    this.displayMapRains.rains$.next(null);
                    this.updateLocationsList();
                }

                this.uiUtilsService.safeChangeDetection(this.cdr);
            });

        const arcgisTokenSub = this.arcgisUserService.arcGISUserTokenChanged.subscribe((token: ArcGISUserToken) => {
            if (!!token) {
                this.arcgisLayerCache.startNewSession();
                this.arcgisUserService.organizationContentChanged.next(null);

                sessionStorage.setItem(GIS_USER_TOKEN, token.userToken?.trim());
                const expiresUtc = new Date(token.tokenExpiresUtc).toISOString();
                sessionStorage.setItem(GIS_USER_EXPIRES_UTC, expiresUtc);

                this.gisService.setArcGisCustomerId(this.customerID);

                this.loadArcGISFeatureLayers();
                this.setupSelectionRestoration();
            } else {
                sessionStorage.removeItem(GIS_USER_TOKEN);
                sessionStorage.removeItem(GIS_USER_EXPIRES_UTC);
                sessionStorage.removeItem(ARCGIS_USERNAME);
                sessionStorage.removeItem(ARCGIS_USER_FULLNAME);
                sessionStorage.removeItem(ARCGIS_USER_ORG_ID);

                if (this.selectionRestorationSubscription) {
                    this.selectionRestorationSubscription.unsubscribe();
                    this.selectionRestorationSubscription = null;
                }

                this.cleanupAllArcGISContent();
            }

            this.userToken = token;
            this.token = token?.userToken;
        });
        this.subscriptions.push(arcgisTokenSub);

        const gisServicesSubs = this.arcgisUserService.gisServicesListChanged.subscribe(async (servicesList: GisServiceList[]) => {
            this.isUserAuthenticated = false;
            this.customerGISServicesList = servicesList;

            if (this.customerGISServicesList && this.customerGISServicesList.find(s => s.serviceType === ServiceTypes.IDENTITY) !== undefined) {
                this.isUserAuthenticated = true;
                if (sessionStorage.getItem(GIS_USER_TOKEN) == null || new Date(sessionStorage.getItem(GIS_USER_EXPIRES_UTC)).getTime() < Date.now()) {
                    const identityService = this.customerGISServicesList.find(s => s.serviceType === ServiceTypes.IDENTITY);
                    const enterpriseUrl: string | null = identityService?.url ? normalizePortalUrl(identityService.url) : null;
                    const req: GetArcGISUserTokenRequest = {
                        arcGISEnterpriseDomainUrl: enterpriseUrl,
                        arcGISEnterpriseAppId: enterpriseUrl ? identityService?.appId ?? null : null,
                        customerId: enterpriseUrl ? this.customerID : undefined,
                    };
                    this.arcgisUserService.getUserCredToken(req);
                }
            } else {
                this.isUserAuthenticated = false;
                const tokenRes = await firstValueFrom(this.gisService.getGisToken());
                this.token = tokenRes.access_token;
            }
            this.loadBasemaps();
        });

        this.updateMonitorLayerOnEdit();
        this.subscriptions.push(queryParamsSubs, gisServicesSubs);
        // await this.loadGisUserSettings();

        const arcgisOrgContentSub = this.arcgisUserService.organizationContentChanged.subscribe(
            (content: ArcGISOrganizationContent) => {
                if (content) {
                    this.arcgisOrganizationContent = content;
                    this.arcgisOrganizationName = content.organizationName || '';

                    this.arcgisFeatureLayers = content.featureServices || [];
                    this.arcgisWebMaps = content.webMaps || [];
                    this.arcgisMapServices = content.mapServices || [];
                } else {
                    this.cleanupAllArcGISContent();
                }
            }
        );
        this.subscriptions.push(arcgisOrgContentSub);

        //  subscribe to location group change
        const locationGroupSubscription = this.locationGroupService.locationGroupEdited.subscribe(
            (locationGroupEdited: number) => {
                if (locationGroupEdited !== 0 && locationGroupEdited === this.locationGroupID) {
                    this.onCustomerChange();
                }
            },
        );
        this.subscriptions.push(locationGroupSubscription);

        //  subscribe to customer date format change
        const dateFormatSubscription = this.dateutilService.dateFormat.subscribe((newDateFormat) => {
            this.dateFormat = newDateFormat;
            this.hideFilters();
        });
        this.subscriptions.push(dateFormatSubscription);

        //  subscribe to customer time format change
        const timeFormatSubscription = this.dateutilService.timeFormat.subscribe((newTimeFormat) => {
            this.timeFormat = newTimeFormat;
            this.hideFilters();
        });

        this.subscriptions.push(timeFormatSubscription);

        //  subscribe to receive new active alarms and update markers
        const alarmSubscription = this.alarmService.currentActiveAlarms.subscribe((activeAlarms) => {
            if (this.currentWidget !== this.widgetOptions.ALARM) {
                this.updateActiveAlarmingLocations(activeAlarms);
                return;
            }

            this.updateAlarmTable = true;
            this.uiUtilsService.safeChangeDetection(this.cdr);

            this.alarmStatusChange({ isAlarmStatusChanged: true, toggleState: false });
        });
        this.subscriptions.push(alarmSubscription);

        this.domOperationUtilsService.showpageHint.subscribe((result: boolean) => {
            this.availablePageHint = result;

            if (!result && this.featSelList && this.featSelList.isDemoDataPopulated) {
                this.featSelList.feat_dataSource.data = this.featSelList.prevTreeValues;
                this.propertyItemList = this.prevPropertyItemList;
                this.featSelList.isDemoDataPopulated = false;
            }

            if (result && this.currentWidget === this.widgetOptions.EVENT) {
                this.domOperationUtilsService.scrollToTop('#eventWidget');
            }
            this.uiUtilsService.safeChangeDetection(this.cdr);
        });

        const alarmAccSub = this.signalRService.alarmAcc.subscribe(async (res) => {
            if (res.cid === this.customerID) {
                this.updateMapAndAlarms();
            }
        });
        this.subscriptions.push(alarmAccSub);

        const alarmSub = this.signalRService.alarmReceived.subscribe((res) => {
            if (res.cid === this.customerID) {
                this.updateMapAndAlarms();
            }
        });
        this.subscriptions.push(alarmSub);

        const returnToNormalSub = this.signalRService.returnToNormal.subscribe((res) => {
            if (res.cid === this.customerID) {
                this.updateMapAndAlarms();
            }
        });
        this.subscriptions.push(returnToNormalSub);

        const collectSub = this.signalRService.collectComplete.subscribe((data: SignalRMessage) => {
            if (data && data.cid === this.customerID && (!data.userId || data.userId === this.authService.userID)) {
                this.getFailedCollectsTotal();
            }
        });

        this.subscriptions.push(collectSub);
    }

    private initMap() {
        /////////// olmap adding

        this.addOlMap();
        this.searchBarLocation = this.searchControl.valueChanges.pipe(
            startWith(''),
            map((value) => this.locationFilter(value)),
        );

        this.updateMapSize();
        this.saveSubject = new Subject<void>();
        this.saveSubject.pipe(debounceTime(3500)).subscribe(() => {
            this.saveGisUserSettings();
        });
    }

    name = 'Angular 4';
    y = 100;
    grabber = false;

    @HostListener('window:resize', ['$event'])
    onResize(event) {
        this.updateMapSize();
    }

    public ngOnDestroy(): void {
        this.isDestroyed = true;
        this.hideMapTooltip();
        this.popupResizeObserver?.disconnect();
        window.removeEventListener('scroll', this.onMapPopupScroll, true);
        window.visualViewport?.removeEventListener('resize', this.onMapPopupViewportChange);
        window.visualViewport?.removeEventListener('scroll', this.onMapPopupViewportChange);

        if (this.mapService.addEditLocationDialog) {
            this.mapService.addEditLocationDialog.close();
            this.mapService.addEditLocationDialog = null;
        }
        this.routeQueryParams$.unsubscribe();
        this.subscriptions.forEach((subscription) => subscription.unsubscribe());
        this.subscriptions = [];

        this.olSubscriptions.forEach(subscription => unByKey(subscription));
        this.olSubscriptions = [];
        if (this.monitorLayerOrderSubscription) {
            unByKey(this.monitorLayerOrderSubscription);
            this.monitorLayerOrderSubscription = null;
        }

        if (this.olMap) {
            const layers = this.olMap.getLayers().getArray();
            layers.forEach(layer => {
                const layerName = layer.get('name');
                if (layerName && layerName.startsWith(LayerNameOpts.arcgisAssets)) {
                    this.olMap.removeLayer(layer);
                }
            });
        }
    }

    private getAllLocations() {
        this.customerLocationService.getLocationSummary(this.customerID, this.includeInactiveLocations).subscribe((locationData: APIDataLocationsGetLocations) => {
            this.customerLocations = locationData.listCutomerLocations;

            this.updateSelectedLocationStatuses();
        });
    }

    private updateSelectedLocationStatuses() {
        if (!this.selectionListing || !this.selectionListing[MONITOR_LAYER_NAME] || !this.customerLocations || !this.customerLocations.length) {
            return;
        }

        const selectedLocations = this.selectionListing[MONITOR_LAYER_NAME]?.child?.map(v => v.feature) || [];

        const customerLocationsMap = new Map<number, CustomerLocationDetail>();
        this.customerLocations.forEach(location => {
            customerLocationsMap.set(location.locationId, location);
        });

        selectedLocations.forEach((location) => {
            if (customerLocationsMap.has(location.get('LocationID'))) {
                const customerLocation = customerLocationsMap.get(location.get('LocationID'));

                location.set('Status', customerLocation.status);
            }
        });

        this.featSelList.feat_loaddata(this.selectionListing);
    }

    public onLocationChange(locationId: number) {
        const location = this.customerLocations.find((v) => v.locationId === locationId);
        this.editLocation(location);
        this.zoomToSelectedLID(locationId);
    }

    private updateLocationsList() {
        const activeInactiveHandler = this.statusCodeService.activeInactiveHandler.getValue();

        const params: LocationListArgs = {
            cid: this.customerID,
            LocationGroupId: this.locationGroupID,
            IncludeInactiveLocations: activeInactiveHandler,
        };

        this.locationService.getLocationData(params).subscribe((response: LocationEntitiesData) => {
            if (!response || !response.l) {
                return;
            }
            this.locationEntityData = response;
            const locationIds = response.l.map((v) => v.lid);

            this.originalLocationsIds = locationIds;
            this.viewableLocationsIds = locationIds;

            if (this.AdsMonitorLayerSource) {
                this.loadMonitorLocations(false);
            }
        });
    }

    public editLocation(location: CustomerLocationDetail) {
        this.isLoading = true;
        this.setupRainGaugeLocations();
        this.uiUtilsService.safeChangeDetection(this.cdr);
        // condition added to to open Triton+ popup if series matches
        if (location && location.locationTypeID === 1) {
            combineLatest(
                this.gisService.gisUserSettingsSubject$,
                this.mapService.getMarkerLocationDetails(location.locationId, this.customerID),
            )
                .pipe(first())
                .subscribe(
                    ([userSettings, result]) => {
                        if (result) {
                            this.isLoading = false;
                            this.uiUtilsService.safeChangeDetection(this.cdr);
                            const locationDetails: LocationDetails = {
                                series: result.series,
                                serialNumber: result.serialNumber,
                                status: result.status,
                                modem: result.modem,
                                description: result.description,
                                manholeAddress: result.manholeAddress,
                                coordinate: { latitude: result.latitude, longitude: result.longitude, elevation: 1 },
                                locationID: result.locationID,
                                locationName: result.locationName,
                                assignedRainGaugeLocationId: result.assignedRainGaugeLocationId,
                                installationHeight: result.height,
                                installationWidth: result.width,
                                installationType: result.installationType,
                                installationId: result.installationID,
                                depthUnit: result.depthUnit,
                                flowUnit: result.flowUnit,
                                locationType: result.components ? 3 : 1,
                                components: result.components,
                                installationShape: result.installationShape,
                                ipaddress: result.connectionString,
                                range: result.range,
                                capacity: result.capacity,
                                width: result.width,
                                installationShapeTypeID: result.installationShapeTypeID,
                                manholedepth: result.manholeDepth,
                                length: result.length,
                                breadth: result.breadth,
                                coefficient: result.coefficient,
                                assignedRainGaugeLocationName: result.assignedRainGaugeLocationName,
                                entries: result.entries,
                                lastCollectedDate: '',
                            };

                            const dialogOptions: MatDialogConfig = {
                                disableClose: true,
                                data: {
                                    isFromCustomerEditor: false,
                                    rainGaugeLocations: this.allRainLocations,
                                    customerId: this.customerID,
                                    editMode: true,
                                    locationDetails: locationDetails,
                                    enableSelectOnMap: true
                                },
                                hasBackdrop: false,
                            };

                            if (this.gisService.locationCardPosition) {
                                dialogOptions.position = this.locationCardService.checkLocationCardPosition(true, this.gisService.locationCardPosition);
                            } else if (
                                userSettings &&
                                userSettings.locationPositionX &&
                                userSettings.locationPositionY
                            ) {
                                dialogOptions.position = this.locationCardService.getLocationCardPosition(true, userSettings);
                            }

                            if (this.mapService.addEditLocationDialog) {
                                this.mapService.addEditLocationDialog.close();
                            }

                            this.mapService.addEditLocationDialog = this.dialog.open(
                                LocationCardContainerDialogComponent,
                                dialogOptions,
                            );
                            this.mapService.addEditLocationDialog
                                .afterClosed()
                                .pipe(first())
                                .subscribe((result: boolean) => {
                                    this.mapService.addEditLocationDialog = null;
                                    this.zoomToInital();
                                    if (result) {
                                        this.getAllLocations();
                                        this.monitorLocationUpdate();
                                        this.reloadBatteryLocations$.next(true);
                                    }
                                });
                        }
                    },
                    (error) => {
                        this.isLoading = false;
                    },
                );
            return;
        }
        if (location.locationTypeID === 3) {
            this.customerLocationService.getLocationSummary(this.customerID, this.includeInactiveLocations).subscribe((items: APIDataLocationsGetLocations) => {
                let locations = new Array<CustomerLocationDetail>();
                if (items) {
                    locations = items.listCutomerLocations;
                }
                combineLatest(
                    this.gisService.gisUserSettingsSubject$,
                    this.mapService.getMarkerLocationDetails(location.locationId, this.customerID),
                ).subscribe(
                    ([userSettings, result]) => {
                        if (result) {
                            this.isLoading = false;
                            this.uiUtilsService.safeChangeDetection(this.cdr);
                            const locationDetails: LocationDetails = {
                                locationID: result.locationID,
                                locationName: result.locationName,
                                description: result.description,
                                manholeAddress: result.manholeAddress,
                                coordinate: { latitude: result.latitude, longitude: result.longitude, elevation: 1 },
                                status: result.status,
                                modem: result.modem,
                                series: result.series,
                                serialNumber: result.serialNumber,
                                ipaddress: result.ipaddress,
                                lastCollectedDate: undefined,
                                components: result.components,
                                enableSelectOnMap: true
                            };

                            const data: CompositeLocEditInput = {
                                customerId: this.customerID,
                                locationDetails,
                                locations,
                                enableSelectOnMap: true,
                            };
                            const dialogOptions: MatDialogConfig<CompositeLocComponentInput> = {
                                disableClose: true,
                                data,
                                hasBackdrop: false,
                            };

                            if (this.gisService.locationCardPosition) {
                                dialogOptions.position = this.locationCardService.checkLocationCardPosition(false, this.gisService.locationCardPosition);
                            } else if (
                                userSettings &&
                                userSettings.locationPositionX &&
                                userSettings.locationPositionY
                            ) {
                                dialogOptions.position = this.locationCardService.getLocationCardPosition(false, userSettings);
                            }

                            if (this.compositeLocationDialog) {
                                this.compositeLocationDialog.close();
                            }
                            this.compositeLocationDialog = this.dialog.open<
                                CompositeLocComponent,
                                CompositeLocComponentInput,
                                IComponentModalResult
                            >(CompositeLocComponent, dialogOptions);

                            this.compositeLocationDialog.afterClosed().subscribe((result) => {
                                if (result && result.success) {
                                    // this.locationIdEdited = location.locationId;
                                    this.getAllLocations();
                                    this.uiUtilsService.safeChangeDetection(this.cdr);
                                }
                            });
                        }
                    },
                    (error) => {
                        this.isLoading = false;
                    },
                );
            });
        } else {
            this.isLoading = false;
            // #48735 We do not handle locationType = 2
        }

        this.isLoading = false;
    }

    private onMapClick(event: MapBrowserEvent<UIEvent>) {
        const transformed = transform(event.coordinate, 'EPSG:3857', 'EPSG:4326');
        const [lon, lat] = transformed;
        const normalizedLon = ((lon % 360) + 540) % 360 - 180;

        this.gisService.coordinatePickerFromMap.next({ lon: normalizedLon, lat });
    }

    public addOlMap() {
        const currentCustomer = this.gisUserSetting.customerSettings.find((x) => x.cid === this.customerID);
        if (
            currentCustomer &&
            currentCustomer.lastViewedExtents &&
            Array.isArray(currentCustomer.lastViewedExtents) &&
            currentCustomer.lastViewedExtents.length === 3
        ) {
            const lastViewedExtents = currentCustomer.lastViewedExtents;
            this.olView = new View({
                projection: this.projection,
                zoom: lastViewedExtents[0],
                center: [lastViewedExtents[1], lastViewedExtents[2]],
                minZoom: 3,
                maxZoom: 23,
            });
            this.foundSavedLayerExtents = true;
        } else {
            this.olView = new View({
                projection: this.projection,
                center: [0, 0],
                zoom: 4,
                minZoom: 3,
                maxZoom: 23,
            });
        }

        ////Measure Layer Defining
        this.measureLayer = new VectorLayer({
            name: LayerNameOpts.measurement + 'TEST', // TODO AMP: fix this name?
            source: new VectorSource({
                // crossOrigin: "Anonymous"
            }),
            style: (feature) => {
                return measureStyle(feature, this.measurementUnit);
            },
        });

        ////// Base Map Layers

        this.olMap = new OLMap({
            target: 'olmap',
            controls: defaultControls({
                attribution: true,
                zoom: false,
            }).extend([
                new Control({
                    element: document.querySelector('.map-attribution')
                })
            ]),
            layers: [],
            view: this.olView,
        });

        this.popupOverlay = new Overlay({
            element: this.popup.nativeElement,
            offset: [9, 9],
        });
        this.olMap.addOverlay(this.popupOverlay);

        const pointermoveKey = this.olMap.on('pointermove', (event: MapBrowserEvent<UIEvent>): void => {
            if (this.isDestroyed || event.dragging || this.isMapViewMoving()) {
                this.hideMapTooltip();
                return;
            }

            const target = event.originalEvent.target;
            if (target instanceof Node && this.popup.nativeElement.contains(target)) {
                this.onMapPopupPointerEnter();
                return;
            }

            const requestId = ++this.mapHoverRequestId;
            let featureFound = false;

            const applyHandlerToLayer = (isMonitor: boolean): void => {
                if (!this.olMap) {
                    return;
                }

                try {
                    this.olMap.forEachFeatureAtPixel(
                        event.pixel,
                        (feature, layer): Feature<Geometry> | undefined => {
                            if (feature instanceof Feature && !this.isMeasurementFeature(feature, layer)) {
                                featureFound = true;
                                this.cancelMapTooltipHide();
                                void this.handleMapHover(feature, event, requestId).catch((error: unknown): void => {
                                    if (requestId === this.mapHoverRequestId) {
                                        this.hideMapTooltip();
                                    }
                                    console.debug('Map hover error:', error);
                                });
                                return feature;
                            }
                            return undefined;
                        },
                        {
                            layerFilter: (layer) => {
                                if (!layer) {
                                    return false;
                                }

                                try {
                                    const isVectorType = layer instanceof VectorLayer || layer instanceof VectorImageLayer;
                                    const isMonitorLayer = isMonitor ? layer.get('name') === MONITOR_LAYER_NAME : true;
                                    return isVectorType && isMonitorLayer;
                                } catch (e) {
                                    return false;
                                }
                            },
                            hitTolerance: 6,
                        },
                    );
                } catch (error) {
                    console.debug('Feature detection error:', error);
                }
            };

            applyHandlerToLayer(true);

            if (!featureFound) {
                applyHandlerToLayer(false);
            }
            if (!featureFound && this.popupHideTimeout === null) {
                this.popupHideTimeout = window.setTimeout((): void => {
                    this.hideMapTooltip();
                }, MAP_POPUP_HIDE_DELAY);
            }
        });
        this.olSubscriptions.push(pointermoveKey);

        const mapSizeKey = this.olMap.on('change:size', (): void => {
            this.hideMapTooltip();
        });
        this.olSubscriptions.push(mapSizeKey);

        if (typeof ResizeObserver !== 'undefined') {
            this.popupResizeObserver?.disconnect();
            this.popupResizeObserver = new ResizeObserver((): void => {
                this.hideMapTooltip();
            });
            this.popupResizeObserver.observe(this.olMap.getViewport());
        }
        window.addEventListener('scroll', this.onMapPopupScroll, true);
        window.visualViewport?.addEventListener('resize', this.onMapPopupViewportChange);
        window.visualViewport?.addEventListener('scroll', this.onMapPopupViewportChange);

        const movestartKey = this.olMap.on('movestart', () => {
            this.hideMapTooltip();
            this.removedArcGISLayers = [];
            this.arcgisMapLayers.forEach((layer, key) => {
                this.olMap.removeLayer(layer);
                this.removedArcGISLayers.push(layer);
            });

            this.olMap.render();
        });
        this.olSubscriptions.push(movestartKey);

        const moveendKey = this.olMap.on('moveend', () => {
            const currentZoom = this.olMap.getView().getZoom();
            const currentCenter = this.olMap.getView().getCenter();
            const currentCustomer = this.gisUserSetting.customerSettings.find((x) => x.cid === this.customerID);
            currentCustomer.lastViewedExtents = [currentZoom, currentCenter[0], currentCenter[1]];
            this.saveSubject.next();

            if (this.layerVisibilityTimeout) {
                clearTimeout(this.layerVisibilityTimeout);
            }
            this.layerVisibilityTimeout = setTimeout(() => {
                this.removedArcGISLayers.forEach(layer => {
                    this.olMap.addLayer(layer);
                });
                this.olMap.render();
                this.removedArcGISLayers = [];
            }, 1000);
        });
        this.olSubscriptions.push(moveendKey);

        this.gisService.getCustomerSettings(this.customerID).subscribe((res: Customer) => {
            const measurementUnit = res?.unitsType === 2 ? 'metric' : 'us';
            this.scaleLinecontrol = new ScaleLine({
                target: 'scaleline',
                units: measurementUnit,
                bar: true,
                steps: 4,
                text: true,
                minWidth: 100,
            });
            this.olMap.addControl(this.scaleLinecontrol);
        });

        this.loadBasemaps();
        this.selectInteraction = new Select({
            layers: [this.SelectionLayer]
        });
        this.olMap.addInteraction(this.selectInteraction);
        this.selectedFeatures = this.selectInteraction.getFeatures();
        this.selectedFeatures.on(['add', 'remove'], () => {
            const selectedFeature = this.selectedFeatures;
            if (selectedFeature.length >= 1) {
                // checking single feature or cluster
                //this.onPopupCallback('show', selectedFeature[0]);
            }
        });
        /*
        var select = new Select();
        this.olMap.addInteraction(select);
        var dragBox = new DragBox({
          condition: platformModifierKeyOnly,
        });

        this.olMap.addInteraction(dragBox);


        var selectedFeatures = select.getFeatures();
        dragBox.on('boxstart', function () {
          selectedFeatures.clear();
        });
        dragBox.on('boxend', function () {
         var extent = dragBox.getGeometry().getExtent();
          this.AdsMonitorLayerSource.forEachFeatureIntersectingExtent(extent, function (feature) {
            selectedFeatures.push(feature);
          });
        });*/

        this.olMap.on('click', async (evt) => {
            this.onMapClick(evt);
            const newfeatures = {};
            if (this.enableSelection) {
                this.clearSelection();
                let featureFound = false;
                this.olMap.forEachFeatureAtPixel(evt.pixel, (feature, layer) => {
                    if (!layer || this.isMeasurementFeature(feature, layer)) return;
                    const layername = layer.get('name');
                    const currentLayersAtrributes = this.getCurrentLayersAtrributes();
                    if (
                        currentLayersAtrributes[layername] &&
                        !(
                            currentLayersAtrributes[layername] &&
                            currentLayersAtrributes[layername].selection === true &&
                            currentLayersAtrributes[layername].checked === true
                        )
                    ) {
                        return;
                    }

                    if (newfeatures[layername]) {
                        if (feature.get('features')) {
                            feature.get('features').forEach((feat: Feature<Geometry>) => {
                                this.addingToSelection(feat, layername);
                                featureFound = true;
                            });
                        } else {
                            this.addingToSelection(feature as Feature<Geometry>, layername);
                            featureFound = true;
                        }
                    } else {
                        if (feature.get('features')) {
                            feature.get('features').forEach((feat: Feature<Geometry>) => {
                                this.addingToSelection(feat, layername);
                                featureFound = true;
                            });
                        } else if (layername !== 'selectionlayer') {
                            this.addingToSelection(feature as Feature<Geometry>, layername);
                            featureFound = true;
                        }
                    }
                });

                const identifyFound = await this.identifyArcGISImageLayerFeatures(evt.coordinate);
                featureFound = featureFound || identifyFound;

                this.featSelList.feat_loaddata(this.selectionListing);

                if (featureFound) {
                    this.activeLayersTab = TABS.TOOLS;
                    this.domOperationUtilsService.selectedGisTab.next(this.activeLayersTab);
                }
            }
        });
        this.enableSelection = true;
    }

    private isMeasurementFeature(feature: FeatureLike, layer: BaseLayer | null): boolean {
        return (
            layer?.get('name') === LayerNameOpts.measurement || feature.get('_layername') === LayerNameOpts.measurement
        );
    }

    private isMapViewMoving(): boolean {
        const view = this.olMap.getView();
        return view.getAnimating() || view.getInteracting();
    }

    private getMapClusterFeatures(feature: Feature<Geometry>): Feature<Geometry>[] | null {
        const features: unknown = feature.get('features');
        return Array.isArray(features)
            ? features.filter((item: unknown): item is Feature<Geometry> => item instanceof Feature)
            : null;
    }

    private async handleMapHover(
        feature: Feature<Geometry>,
        event: MapBrowserEvent<UIEvent>,
        requestId: number,
    ): Promise<void> {
        const monitorFeatures = await getVisibleLayerFeatures(this.AdsMonitorLayer, event.pixel);
        if (this.isDestroyed || requestId !== this.mapHoverRequestId) {
            return;
        }
        if (this.isMapViewMoving()) {
            this.hideMapTooltip();
            return;
        }

        const isDarkTheme = this.statusCodeService.userInfoThemeBS.getValue();
        const type = feature.getGeometry()?.getType();
        const locTypeId: unknown = feature.get('LocationTypeID');
        const monitorLayerFeatures = monitorFeatures.length ? this.getMapClusterFeatures(monitorFeatures[0]) : null;
        const rainEvents: EventRain[] | null = this.displayMapRains.overrideTooltip
            ? (this.displayMapRains.rains$
                  .getValue()
                  ?.filter((rain: MapRain): rain is EventRain => typeof rain.rtype === 'number') ?? null)
            : null;
        let template: string | null = null;
        let features = this.getMapClusterFeatures(feature);
        if (!features && feature.get('LocationID')) {
            features = [feature];
        }

        const isStandardGeometry =
            type === 'Point' ||
            type === 'MultiPoint' ||
            type === 'LineString' ||
            type === 'MultiLineString' ||
            type === 'Polygon' ||
            type === 'MultiPolygon';
        if (isStandardGeometry && !features && !monitorFeatures.length) {
            template = generateLinePointPolygonPopupTemplate(feature);
        } else if (locTypeId === 3 || (features && features.length === 1 && features[0].get('LocationTypeID') === 3)) {
            const name: unknown = feature.get('Name') || features?.[0]?.get('Name');
            const status: unknown = feature.get('IsActiveLocation') ?? features?.[0]?.get('IsActiveLocation');
            template = generateCompositeLocationPopupTemplate(typeof name === 'string' ? name : '', status ? 1 : 0);
        } else if (this.displayMapRains.overrideTooltip && monitorLayerFeatures && monitorLayerFeatures.length > 1) {
            template = generateLocationsClusterPopupTemplate(monitorLayerFeatures, isDarkTheme, rainEvents);
        } else if (
            this.displayMapRains.overrideTooltip &&
            monitorLayerFeatures &&
            monitorLayerFeatures.length === 1 &&
            monitorLayerFeatures[0].get('LocationTypeID') !== 3
        ) {
            template = pickSingleMonitorPopupTemplate(monitorLayerFeatures[0], isDarkTheme, rainEvents);
        } else if (
            this.displayMapRains.overrideTooltip &&
            monitorLayerFeatures &&
            monitorLayerFeatures.length === 1 &&
            monitorLayerFeatures[0].get('LocationTypeID') === 3
        ) {
            const name: unknown = monitorLayerFeatures[0].get('Name');
            template = generateCompositeLocationPopupTemplate(
                typeof name === 'string' ? name : '',
                monitorLayerFeatures[0].get('IsActiveLocation') ? 1 : 0,
            );
        } else if (features && features.length === 1) {
            template = pickSingleMonitorPopupTemplate(features[0], isDarkTheme, rainEvents);
        } else if (features && features.length > 1) {
            template = generateLocationsClusterPopupTemplate(features, isDarkTheme, rainEvents);
        }

        this.popup.nativeElement.innerHTML = template ?? '';
        this.popup.nativeElement.scrollTop = 0;
        this.popup.nativeElement.scrollLeft = 0;
        this.handleTooltipResult(!template, event);
    }

    private checkToPopulateDemoMonitorData(pageIndex: number) {
        if (!this.featSelList || (pageIndex !== 3 && !this.featSelList.isDemoDataPopulated)) {
            return;
        }

        const mockData: feat_TodoItemNode[] = [
            {
                item: MONITOR_LAYER_NAME,
                feature: null,
                layername: '',
                alarmstatus: 0,
                children: [
                    {
                        item: 'DEMO_MONITOR',
                        feature: null,
                        layername: MONITOR_LAYER_NAME,
                        alarmstatus: 0,
                        children: []
                    },
                ],
            },
        ];

        const demoProps = [
            { name: 'CustomerID', value: 0 },
            { name: 'LocationID', value: 0 },
            { name: 'Name', value: 'DEMO MONITOR' },
            { name: 'LocationTypeID', value: 0 },
            { name: 'LocationDesc', value: null },
            { name: 'Latitude', value: 0 },
            { name: 'Longitude', value: 0 },
            { name: 'Elevation', value: 0 },
            { name: 'SerialNumber', value: null },
            { name: 'Status', value: 0 },
            { name: 'ManholeAddress', value: null },
            { name: 'ConnectionString', value: null },
            { name: 'IsActiveLocation', value: 1 },
            { name: 'LastCollectedDate', value: null },
            { name: 'DataCollectTaskID', value: 0 },
            { name: 'MapLabel', value: null },
            { name: 'MapLabelPosition', value: null },
            { name: 'ExportDataToFtp', value: false },
            { name: 'WasCreatedFromImport', value: true },
            { name: 'AssignedRgID', value: 0 },
            { name: 'RgAssignmentDate', value: null },
            { name: 'LocationIdentity', value: 0 },
            { name: 'ManholeDepth', value: 0 },
            { name: 'ExternalID', value: null },
            { name: 'ExternalSiteType', value: null },
            { name: 'ExternalVendorID', value: null },
            { name: 'QFinalEntityID', value: 3302 },
            { name: 'AlarmId', value: undefined },
            { name: 'AcknowledgedBy', value: 0 },
            { name: 'LocationGroupId', value: 0 },
            { name: 'monitorSeriesModelName', value: null },
            { name: 'monitorModel', value: null },
            { name: 'monitorSeries', value: null },
            { name: 'symbolType', value: null },
            { name: 'name', value: 'DEMO MONITOR' },
            { name: '_layername', value: MONITOR_LAYER_NAME },
        ];

        if (pageIndex === 3) {
            this.featSelList.prevTreeValues = [...this.featSelList.feat_dataSource.data];
            this.prevPropertyItemList = [...this.propertyItemList];
            this.propertyItemList = demoProps;
            this.featSelList.feat_dataSource.data = mockData;
            this.featSelList.feat_treeControl.expandAll();
            this.featSelList.isDemoDataPopulated = true;
        } else if (this.featSelList.isDemoDataPopulated) {
            this.featSelList.isDemoDataPopulated = false;
            this.propertyItemList = this.prevPropertyItemList;
            this.featSelList.feat_dataSource.data = this.featSelList.prevTreeValues;
        }
    }

    private cancelMapTooltipHide(): void {
        if (this.popupHideTimeout !== null) {
            window.clearTimeout(this.popupHideTimeout);
            this.popupHideTimeout = null;
        }
    }

    public onMapPopupPointerEnter(): void {
        this.mapHoverRequestId++;
        this.cancelMapTooltipHide();
    }

    public hideMapTooltip(): void {
        this.mapHoverRequestId++;
        this.cancelMapTooltipHide();
        if (this.popup) {
            this.popup.nativeElement.innerHTML = '';
            this.popup.nativeElement.hidden = true;
        }
        this.popupOverlay?.setPosition(undefined);
    }

    private handleTooltipResult(hide: boolean, event: MapBrowserEvent<UIEvent>): void {
        if (hide) {
            this.hideMapTooltip();
            return;
        }

        const visualViewport = window.visualViewport;
        const viewportLeft = visualViewport?.offsetLeft ?? 0;
        const viewportTop = visualViewport?.offsetTop ?? 0;
        const viewportBounds: MapPopupBounds = {
            left: viewportLeft,
            top: viewportTop,
            right: viewportLeft + (visualViewport?.width ?? document.documentElement.clientWidth),
            bottom: viewportTop + (visualViewport?.height ?? document.documentElement.clientHeight),
        };
        const popup = this.popup.nativeElement;
        popup.hidden = false;
        this.popupOverlay.setPosition(event.coordinate);

        const offset = fitMapPopup(
            popup,
            { x: event.pixel[0], y: event.pixel[1] },
            this.olMap.getViewport().getBoundingClientRect(),
            viewportBounds,
        );
        if (offset) {
            this.popupOverlay.setOffset(offset);
        } else {
            this.hideMapTooltip();
        }
    }

    private async loadArcGISFeatureLayers(): Promise<void> {
        await this.arcgisUserService.loadAllFeatureLayers();
    }

    private async loadBasemaps() {
        //TODO: update this call to get list of layers based on user's token and not enterprise-server list of layers
        this.gisService.getGISBasemap().pipe(first())
            .subscribe((basemaps) => {
                if (!this.activeBaseMapId) {
                    // Ensure active base map is set; otherwise default to first map
                    this.activeBaseMapId = basemaps[0].baseMapId;
                }

                const baseMapLayers: TileLayer[] = [];
                this.baseMapOptions = basemaps;

                this.baseMapOptions.forEach((map) => {
                    if (map.url.includes('{token}')) {
                        map.url = map.url.replace('{token}', this.token);
                    }
                });

                const basemapTileLoadFunction = createBasemapTileLoadFunction(this.olMap, () => {
                    this.snackBar.open(this.translate.instant('HOME.MAP.ZOOM_OUT_NO_TILES'), this.dismissBtn, { duration: 5000 });
                });

                // include default layers
                this.baseMapOptions.filter(v => !v.url.includes('token')).forEach(map => {
                    baseMapLayers.push(
                        new TileLayer({
                            name: map.name,
                            visible: map.baseMapId === this.activeBaseMapId,
                            source: new XYZ({
                                url: map.url,
                                crossOrigin: 'Anonymous',
                                tileLoadFunction: basemapTileLoadFunction,
                            }),
                        }),
                    );
                });

                const activeMap = this.baseMapOptions.find(v => v.baseMapId === this.activeBaseMapId);

                if (activeMap && activeMap.url.includes('token')) {
                    this.applyDynamicBasemap(activeMap.url, activeMap.name);
                }

                this.baseLayers = new LayerGroup({
                    name: LayerNameOpts.basemap,
                    layers: baseMapLayers,
                });
                this.olMap.addLayer(this.baseLayers);

                this.setMapAttributionText();
                this.generateOverviewMap();

                const hasMonitorLayer: boolean = this.olMap.getLayers().getArray().some(l => l.get('name') === LayerNameOpts.monitor);
                if (!hasMonitorLayer) {
                    this.maplayersLoad();
                }
            });
    }

    private applyDynamicBasemap(url: string, name: string, retryCount: number = 0) {
        const MAX_RETRIES = 3;
        const layerAddSubscription = this.olMap.getLayers().on('add', (event) => {
            const addedLayer = event.element;

            if (addedLayer.get('name') === undefined && addedLayer instanceof TileLayer) {
                this.olSubscriptions.push(...configureBasemapTileLayer(addedLayer));
            }
        });
        this.olSubscriptions.push(layerAddSubscription);

        // since apply will add a layer dynamically, and does not provide any success event handler we need to listen to Add layer event to set its name
        apply(this.olMap, url)
            .then((data: OLMap) => {
                const isStale = this.baseMapOptions.some(v => v.name === name && v.baseMapId !== this.activeBaseMapId);
                if (isStale) {
                    this.removeOrphanedBasemapLayers();
                    return;
                }

                data.getLayers().getArray()
                    .filter(v => v.get('name') === undefined && !(v instanceof LayerGroup))
                    .forEach((v) => {
                        if (v instanceof TileLayer) {
                            this.olSubscriptions.push(...configureBasemapTileLayer(v));
                        }

                        v.set('name', name);
                    });

                this.removeOrphanedBasemapLayers();

                const mapBox = this.olMap.get('mapbox-style');
                const sources = mapBox.sources;
                const sourceKeys = Object.keys(sources);

                let attribution: string = '';

                for (const key of sourceKeys) {
                    const source = sources[key];
                    const srcAttribution = source.attribution;

                    if (srcAttribution) {
                        attribution += srcAttribution;
                    }
                }

                if (attribution) {
                    this.attributionText = attribution;
                }

            })
            .catch((err) => {
                if (retryCount < MAX_RETRIES) {
                    this.gisService.getGisToken().subscribe((res) => this.applyDynamicBasemap(this.replaceToken(url, res.access_token), name, retryCount + 1));
                } else {
                    console.error(`Failed to load basemap after ${MAX_RETRIES} retries:`, err);
                }
            })
            .finally(() => {
                unByKey(layerAddSubscription);
            });
    }

    private removeOrphanedBasemapLayers(): void {
        const allLayers = [...this.olMap.getLayers().getArray()];
        for (const layer of allLayers) {
            const layerName = layer.get('name');
            if (!layerName) {
                this.olMap.removeLayer(layer);
                continue;
            }
            if (layer instanceof LayerGroup && layer !== this.baseLayers) {
                this.olMap.removeLayer(layer);
            }
        }
    }

    private replaceToken(url: string, newToken: string) {
        const regex = /token=([^&]*)/;
        return url.replace(regex, `token=${newToken}`);
    }

    private setMapAttributionText() {
        if (!this.activeBaseMapId || !this.baseMapOptions || !this.baseMapOptions.length) {
            return;
        }

        const basemap = this.baseMapOptions.find(v => v.baseMapId === this.activeBaseMapId);

        if (!basemap) {
            return;
        }

        switch(basemap.name) {
            case BasemapNames.topographic: {
                this.attributionText = this.translate.instant('HOME.MAP.ATTRIBUTIONS.TOPOGRAPHIC');
                break;
            }
            case BasemapNames.imagery: {
                this.attributionText = this.translate.instant('HOME.MAP.ATTRIBUTIONS.IMAGERY');

                break;
            }
            case BasemapNames.esri: {
                this.attributionText = this.translate.instant('HOME.MAP.ATTRIBUTIONS.ESRI');

                break;
            }
            case BasemapNames.esriImage: {
                this.attributionText = this.translate.instant('HOME.MAP.ATTRIBUTIONS.ESRI_IMAGE');
                break;
            }
            case BasemapNames.osm: {
                this.attributionText = this.translate.instant('HOME.MAP.ATTRIBUTIONS.OSM');

                break;
            }
            case BasemapNames.esriBasemap: {
                this.attributionText = this.translate.instant('HOME.MAP.ATTRIBUTIONS.ESRI_BASEMAP');

                break;
            }
            default: break;
        }
    }

    private checkForLocationViewablePermission(featureId: number) {
        return !!this.viewableLocationsIds.find((v) => v === Number(featureId));
    }

    private checkForActiveInactiveHandler(isActive: boolean): boolean {
        const activeInactiveHandler = this.statusCodeService.activeInactiveHandler.getValue();

        if (activeInactiveHandler) {
            return true; // display all locations is turned on
        }

        return isActive;
    }

    private checkForLocationGroup(locationgroupIds: number[]): boolean {
        if (this.locationGroupID === 0) {
            return true; // display all location groups is selected
        }

        return locationgroupIds && locationgroupIds.includes(this.locationGroupID);
    }

    private updatePropertyItemList(feature: Feature<Geometry>) {
        const locationIdItem = this.propertyItemList.find((v) => v.name === 'LocationID');

        if (Number(locationIdItem.value) !== Number(feature.get('LocationID'))) {
            return;
        }

        const featureSelection: featureSelList = {
            feature: feature,
            name: feature.get('name') || feature.get('Name') || '',
            layername: feature.get('_layername') || ''
        };
        this.featureselected([featureSelection]);
    }
    private addToMonitorLegend(legendType: MonitorSymbolType) {
        if (legendType === undefined || legendType === null) {
            legendType = MonitorSymbolType.Other;
        }
        const monitorLegendInfo = monitorLegendOptions().find((x) => x.type === legendType);
        const affectedLayer = this.mapLayerLists.find((x) => x.name === LayerNameOpts.monitor);
        if (affectedLayer.legendInfo.find((x) => x.type === legendType)) {
            return;
        }
        affectedLayer.legendInfo.push(monitorLegendInfo);
        affectedLayer.legendInfo.sort((left, right) =>
            left.label.localeCompare(right.label, undefined, { sensitivity: 'base' })
        );
    }

    tileLoadFn(tile, src) {
        const xhr = new XMLHttpRequest();
        xhr.responseType = 'blob';
        xhr.addEventListener('loadend', (response) => {
            const responsetaget = response['currentTarget'];
            const data = responsetaget['response'];
            if (data !== undefined) {
                tile.getImage().src = URL.createObjectURL(data);
            } else {
                tile.setState(TileState.ERROR);
            }
        });
        xhr.addEventListener('error', () => {
            tile.setState(TileState.ERROR);
        });
        xhr.open('GET', src);
        xhr.setRequestHeader('Authorization', 'Basic SURFWDprM1IqdjJMeHEjRkQ=');
        xhr.send();
    }

    private generateMonitorLayerUrl() {
        return Config.urls.geoserverUrl + `ows/${this.customerID}?IncludeInactiveLocations=${this.includeInactiveLocations}`
    }

    maplayersLoad() {
        const geoWFSurl = this.generateMonitorLayerUrl();
        this.AdsMonitorLayerSource = new VectorSource({
            format: new GeoJSON(),
            url: (extent) => {
                return geoWFSurl;
            },
        });

        this.AdsMonitorLayerSource.setLoader((p0, p1, projection: Projection) => {
            const xhr = new XMLHttpRequest();
            xhr.responseType = 'json';
            xhr.addEventListener('loadend', (response) => {
                const responsetaget = response['currentTarget'];
                const data = responsetaget['response'];
                if (!data) return;

                const uniqueData = [];
                for (const f of data.features) {
                    const featureId = f.properties.LocationID;
                    const name = f.properties.Name;
                    const isActive = f.properties.IsActiveLocation;
                    const locationGroupIds = this.locationGroups ? this.locationGroups[featureId] : [];
                    f.id = featureId;

                    if (
                        !this.monitorFeatureNamesSet.has(name)
                        && this.checkForActiveInactiveHandler(isActive)
                        && this.checkForLocationGroup(locationGroupIds)
                        && this.checkForLocationViewablePermission(featureId)
                    ) {
                        uniqueData.push(f);
                        this.monitorFeatureNamesSet.add(name);
                    }
                }
                data.features = uniqueData;

                const features = this.AdsMonitorLayerSource.getFormat().readFeatures(data, {
                    featureProjection: projection,
                });

                this.AdsMonitorLayerSource.addFeatures(features as Feature[]);
            });
            // xhr.addEventListener('error', () => {
            // });
            const url = this.generateMonitorLayerUrl();
            xhr.open('GET', url);
            const token = sessionStorage.getItem('adsToken');
            if (token) {
                xhr.setRequestHeader('Authorization', 'Bearer ' + token);
            }
            xhr.send();
        });
        this.monitorFeatureNamesSet = new Set();
        this.AdsMonitorLayerSource.on('addfeature', (event) => {
            const feature = this.AdsMonitorLayerSource.getFeatureById(event.feature.getId());
            if (!feature) return;

            const legendSymbol = resolveMonitorSymbolType(feature.get('symbolType'), feature.get('monitorSeriesModelName'));
            this.addToMonitorLegend(legendSymbol);

            this.monitorFeatureNamesSet.add(event.feature.get('Name'));
            this.adjustFeatureAlarmsProperties(feature);

            const format = new GeoJSON();
            const feat1 = format.writeFeatureObject(feature);

            let found: Feature<Geometry> | null = null;
            this.SelectionLayerSource.forEachFeature((f) => {
                if (event.feature.get('LocationID') === f.get('LocationID')) {
                    found = f;
                }
            });
            if (found) {
                const layerName = found.get('_layername');
                this.SelectionLayerSource.removeFeature(found);
                this.addingToSelection(event.feature, layerName);
            }

            const isNullIsland = feat1.geometry &&
                feat1.geometry.type === 'Point' &&
                feat1.geometry.coordinates[0] === 0 &&
                feat1.geometry.coordinates[1] === 0;

            if (!isNullIsland) {
                this.monitorFeatureCollection.push(feat1);
                const filteredFeatures = this.monitorFeatureCollection.filter(x => x.properties?.Latitude || x.properties?.Longitude);

                const bbox = turf.bbox({
                    type: FEATURE_COLLECTION,
                    features: filteredFeatures,
                });
                this.initialMapExtent = [bbox[0], bbox[1], bbox[2], bbox[3]];

                this.monitorsRefreshedSubject.next(filteredFeatures.length);
                if (!this.foundSavedLayerExtents) {
                    this.zoomToInital();
                }
            }

            if (this.propertyItemList && this.propertyItemList.length) {
                this.updatePropertyItemList(feature);
            }
        });

        this.AdsMonitorLayerSourceCL = new Cluster({
            distance: 20,
            source: this.AdsMonitorLayerSource,
        });

        this.AdsMonitorLayer = new VectorLayer({
            name: LayerNameOpts.monitor,
            className: MONITOR_FOREGROUND_CLASS_NAME,
            source: this.AdsMonitorLayerSourceCL,
            style: monitorStyleFilter(
                this.currentlyDisplayedLocationIds$,
                this.displayMapRains.rains$,
                this.gisService.gisUserSettingsSubject$,
                this.pickMapMonitorColor.bind(this),
                this.displayMapRains.whiteLocations$,
                this.statusCodeService.userInfoThemeBS
            ),
        });
        // this.AdsMonitorLayerSourceOV = new VectorSource({
        //     format: new GeoJSON(),
        //     url: (extent) => {
        //         return Config.urls.geoserverUrl + '/ows?service=WFS&version=1.0.0&request=GetFeature' +
        //             '&typename=' + ADS_MONITOR_LAYER + '&outputFormat=application/json&srsname=' + this.projection + '&viewparams=customerId:' + this.customerID + this.layerViewParam +
        //             '&bbox=' + ADS_LAYER_BBOX; //extent.join(',');
        //     },
        //     strategy: bboxStrategy,
        // });

        // this.AdsMonitorLayerSourceCLOV = new Cluster({
        //     distance: 20,
        //     source: this.AdsMonitorLayerSource,
        // });

        const userSavedLayerInfo = this.gisService.getSavedLayerSettings(this.customerID, this.gisUserSetting, LayerNameOpts.monitor);
        if (userSavedLayerInfo) {
            this.mapLayerLists.unshift({
                name: userSavedLayerInfo.name,
                checked: userSavedLayerInfo.isVisible,
                child: [],
                selection: userSavedLayerInfo.isSelectable,
                legendInfo: [],
                opacity: this.defaultOpacity,
            });

            // #40626 Toggle Monitor layer visiblity
            this.AdsMonitorLayer.setVisible(userSavedLayerInfo.isVisible)
        } else {
            this.mapLayerLists.unshift({
                name: LayerNameOpts.monitor,
                checked: true,
                child: [],
                selection: true,
                legendInfo: [],
                opacity: this.defaultOpacity,
            });
        }
        this.updateAnyLayerSelectedStatus();

        ////Measure Layer Defining
        this.measureLayer = new VectorLayer({
            name: LayerNameOpts.measurement,
            source: new VectorSource(),
            style: (feature) => {
                return measureStyle(feature, this.measurementUnit);
            },
        });

        ///// selection Layer Defining
        this.SelectionLayerSource = new VectorSource();
        this.SelectionLayer = new VectorLayer({
            name: LayerNameOpts.selectionlayer,
            className: MONITOR_FOREGROUND_CLASS_NAME,
            source: this.SelectionLayerSource,
        });

        // highlithed layer defining
        this.HighlightLayerSource = new VectorSource();
        this.HighlightLayer = new VectorLayer({
            name: LayerNameOpts.selectionlayer,
            className: MONITOR_FOREGROUND_CLASS_NAME,
            source: this.HighlightLayerSource,
        });
        /*
         *
         */
        this.positionFeature = new Feature();
        //this.positionFeature.setStyle(positionFeatureStyle);
        this.accuracyFeature = new Feature();
        //this.accuracyFeature.setStyle(accuracyFeatureStyle);
        const loctionLayer = new VectorLayer({
            name: LayerNameOpts.locations,
            source: new VectorSource({
                features: [this.accuracyFeature, this.positionFeature],
            }),
        });

        this.AdsMonitorLayer.setZIndex(2000);
        this.SelectionLayer.setZIndex(2001);
        this.HighlightLayer.setZIndex(2010);
        this.olMap.addLayer(this.AdsMonitorLayer);
        this.olMap.addLayer(this.measureLayer);
        this.olMap.addLayer(this.SelectionLayer);
        this.olMap.addLayer(this.HighlightLayer);
        if (this.monitorLayerOrderSubscription) {
            unByKey(this.monitorLayerOrderSubscription);
        }
        this.monitorLayerOrderSubscription = keepMapLayersOnTop(this.olMap.getLayerGroup(), [
            this.AdsMonitorLayer,
            this.SelectionLayer,
            this.HighlightLayer,
        ]);

        this.generateOverviewMap();
        this.layerList.loaddata(this.mapLayerLists);
        this.loadMonitorLocations();
        //this.prismLayerLoad();
        //this.layerList.loaddata(this.mapLayerLists);
    }

    private pickMapMonitorColor(feature: Feature): string {
        const { currentWidget: curr, widgetOptions: opts } = this;
        const isDarkTheme = this.statusCodeService.userInfoThemeBS.getValue();

        const properties = feature.getProperties();

        if (properties.Status === LocationStatus.Inactive) {
            return isDarkTheme ? darkThemeColors.grey : lightThemeColors.grey;
        }

        if (curr === opts.ALARM || curr === opts.ALL) {
            return this.getMonitorColorOnAlarm(feature, isDarkTheme);
        } else if (curr === opts.BATTERY) {
            return this.getMonitorColorOnBattery(feature, isDarkTheme);
        } else if (curr === opts.DATA_COMMUNICATION) {
            return this.getMonitorColorOnDataComm(feature, isDarkTheme);
        } else if (curr === opts.BLOCKAGE_PREDICT) {
            return this.getMonitorColorOnBlockage(feature, isDarkTheme);
        } else if (curr === opts.AUTO_REVIEW) {
            return this.getMonitorColorOnAutoReview(feature, isDarkTheme);
        } else {
            return this.getMonitorColorOnAlarm(feature, isDarkTheme);
        }
    }

    private getMonitorColorByStatus(feature: Feature, isDarkTheme: boolean) {
        const properties = feature.getProperties();

        let color = isDarkTheme ? darkThemeColors.green : lightThemeColors.green;

        if (properties.Status === LocationStatus.Inactive || properties.Status === LocationStatus.InactiveRemoved) {
            color = isDarkTheme ? darkThemeColors.grey : lightThemeColors.grey;
        } else if (properties.Status === LocationStatus.Maintenance) {
            color = isDarkTheme ? darkThemeColors.maintenance : lightThemeColors.maintenance;
        }

        return color;
    }

    private getMonitorColorOnAlarm(feature: Feature, isDarkTheme: boolean): string {
        const properties = feature.getProperties();
        if (properties.AlarmId) {
            if (properties.AcknowledgedBy) {
                return isDarkTheme ? darkThemeColors.orange : lightThemeColors.orange;
            } else {
                return isDarkTheme ? darkThemeColors.red : lightThemeColors.red;
            }
        }

        return this.getMonitorColorByStatus(feature, isDarkTheme);
    }

    private getMonitorColorOnBattery(feature: Feature, isDarkTheme: boolean): string {
        const properties = feature.getProperties();

        if (!this.openedWidgetData) {
            return isDarkTheme ? darkThemeColors.green : lightThemeColors.green;
        }

        const fromData = this.openedWidgetData.find(v => v.locationID === properties.LocationID);

        if (!fromData || fromData.status === BatteryStatusEnum.Good) {
            return isDarkTheme ? darkThemeColors.green : lightThemeColors.green;
        }

        if (fromData.status === BatteryStatusEnum.Low) {
            return isDarkTheme ? darkThemeColors.orange : lightThemeColors.orange;
        }

        return isDarkTheme ? darkThemeColors.red : lightThemeColors.red;
    }

    private getMonitorColorOnDataComm(feature: Feature, isDarkTheme: boolean): string {
        const properties = feature.getProperties();

        if (!this.openedWidgetData) {
            return isDarkTheme ? darkThemeColors.green : lightThemeColors.green;
        }

        const locationExists = this.openedWidgetData.find(v => v.locationid === properties.LocationID);

        if (locationExists) {
            return isDarkTheme ? darkThemeColors.orange : lightThemeColors.orange;
        }

        return isDarkTheme ? darkThemeColors.green : lightThemeColors.green;
    }

    private getMonitorColorOnBlockage(feature: Feature, isDarkTheme: boolean): string {
        const properties = feature.getProperties();

        if (!this.openedWidgetData) {
            return isDarkTheme ? darkThemeColors.green : lightThemeColors.green;
        }

        const fromData = this.openedWidgetData.find(v => v.locationId === properties.LocationID);

        if (!fromData || fromData.blockStatus === 1) {
            return isDarkTheme ? darkThemeColors.green : lightThemeColors.green;
        } else if (fromData.blockStatus === 2) {
            return isDarkTheme ? darkThemeColors.orange : lightThemeColors.orange;
        } else {
            return isDarkTheme ? darkThemeColors.red : lightThemeColors.red;
        }
    }

    private getMonitorColorOnAutoReview(feature: Feature, isDarkTheme: boolean) {
        const properties = feature.getProperties();

        if (!this.openedWidgetData) {
            return isDarkTheme ? darkThemeColors.green : lightThemeColors.green;
        }

        const fromData = this.openedWidgetData.find(v => v.locationId === properties.LocationID);

        if (!fromData) {
            return isDarkTheme ? darkThemeColors.green : lightThemeColors.green;
        }

        if (fromData.status && fromData.status.text === AUTO_REVIEW_REVIEW_REQUIRED) {
            return isDarkTheme ? darkThemeColors.red : lightThemeColors.red;
        } else if (fromData.status && fromData.status.text === AUTO_REVIEW_MISSING_DATA) {
            return isDarkTheme ? darkThemeColors.orange : lightThemeColors.orange;
        }

        return isDarkTheme ? darkThemeColors.green : lightThemeColors.green;
    }

    public setWidgetData(data) {
        this.openedWidgetData = data;
        this.monitorLocationUpdate();
    }

    private removeAllLayers() {
        const layers = [...this.olMap.getLayers().getArray()];
        layers.forEach((lyr) => {
            const layerName = lyr.get('name');
            if (
                layerName !== LayerNameOpts.basemap &&
                layerName !== LayerNameOpts.selectionlayer &&
                layerName !== LayerNameOpts.locations &&
                layerName !== LayerNameOpts.monitor &&
                layerName !== LayerNameOpts.measurement
            ) {
                this.olMap.removeLayer(lyr);
            }
        });
    }

    setMapList() {
        let networkfound = false;
        let netcnt = 0;
        this.mapLayerLists.forEach((ent) => {
            if (ent.name == 'Network') {
                if (this.prismLayerList.length > 0) {
                    ent.child = this.prismLayerList as mapLayerList[];
                    networkfound = true;
                } else {
                    this.mapLayerLists.splice(netcnt, 1);
                }
            }
            netcnt++;
        });
        if (this.prismLayerList.length > 0 && !networkfound) {
            this.mapLayerLists.push({
                name: 'Network',
                checked: true,
                child: this.prismLayerList as mapLayerList[],
                selection: false,
                showLegend: false,
                legendInfo: [],
                opacity: 1,
            });
        }
        this.updateAnyLayerSelectedStatus();
        this.layerList.loaddata(this.mapLayerLists);
    }

    async prismLayerLoad() {
        this.prismLayerList = [];
        this.prismLayerGroupList = [];
        this.setMapList();
        //this.prismLayersGroup.setLayers([]);
        this.removeAllLayers();
        const services = await this.gisService.getGISServicesList(this.customerID).toPromise();

        this.checkedLayersList = new Set();
        this.layerNameToEsriLayerId = {};

        this.refreshBasemapOnCustomerChange();
        await this.gisService.layerLoad(
            services,
            this.gisUserSetting,
            this.customerID,
            () => !this.isDestroyed,
            {
                checkedLayersList: this.checkedLayersList,
                layerNameToEsriLayerId: this.layerNameToEsriLayerId,
                olMap: this.olMap,
                prismLayerList: this.prismLayerList,
                esriTileSource: this.esriTileSource,
                esriTileLayer: this.esriTileLayer
            },
            {
                defaultOpacity: this.defaultOpacity
            }
        );

        this.setMapList();
    }

    tileloading(tile, src) {
        const xhr = new XMLHttpRequest();
        xhr.responseType = 'blob';
        xhr.addEventListener('loadend', (response) => {
            const responsetaget = response['currentTarget'];
            const data = responsetaget['response'];
            if (data !== undefined) {
                tile.getImage().src = URL.createObjectURL(data);
            } else {
                tile.setState(TileState.ERROR);
            }
        });
        xhr.addEventListener('error', () => {
            tile.setState(TileState.ERROR);
        });
        xhr.open('GET', src);
        xhr.setRequestHeader('Authorization', 'Basic SURFWDprM1IqdjJMeHEjRkQ=');
        xhr.send();
    }

    private generateOverviewMap() {
        if (!this.baseMapOptions) {
            return;
        }
        let activeBaseLayer = this.baseMapOptions.find((x) => x.baseMapId === this.activeBaseMapId);
        if (!activeBaseLayer) {
            activeBaseLayer = this.baseMapOptions[0];
        }

        let baseLayer: TileLayer;
        if (!activeBaseLayer.url.includes('token')) {
            baseLayer = new TileLayer({
                name: 'OverviewMap - ' + LayerNameOpts.basemap,
                source: new XYZ({
                    url: activeBaseLayer.url,
                    crossOrigin: 'Anonymous',
                }),
            });
        }

        const overviewMonitorLayer = new VectorLayer({
            name: 'OverviewMap - ' + LayerNameOpts.monitor,
            source: this.AdsMonitorLayerSourceCL,
            style: monitorStyleFilter(
                this.currentlyDisplayedLocationIds$,
                this.displayMapRains.rains$,
                this.gisService.gisUserSettingsSubject$,
                this.pickMapMonitorColor.bind(this),
                this.displayMapRains.whiteLocations$,
                this.statusCodeService.userInfoThemeBS
            ),
        });

        if (this.overviewMapControl) {
            this.olMap.removeControl(this.overviewMapControl);
        }


        const layers: Layer<Source>[] = [overviewMonitorLayer];

        if (baseLayer) {
            layers.push(baseLayer);
        }

        this.overviewMapControl = new OverviewMap({
            layers,
            collapseLabel: '\u2199',
            label: '\u2197',
            collapsible: true
        });
        this.olMap.addControl(this.overviewMapControl);
    }

    // Method will recall monitor symbol style function
    monitorLocationUpdate(shouldClearSelection = true) {
        if (shouldClearSelection) {
            this.clearSelection();
        }
        // const extent = '';
        let otherparam = '';
        if (!this.includeInactiveLocations) {
            otherparam = otherparam + ' and IsActiveLocation = 1';
        }
        if (this.locationGroupID != 0) {
            otherparam = otherparam + ' and LocationGroupId = ' + this.locationGroupID;
        }
        // if (this.activewidget != '') {
        //     if (this.activewidget == '0') {
        //         otherparam = otherparam + ' and AcknowledgedBy = 1';
        //     }
        // }
        this.layerViewParam = ';LocationgroupID:' + otherparam;
        // const param = '&viewparams=customerId:' + this.customerID + this.layerViewParam;
        this.monitorFeatureNamesSet = new Set();
        if (this.customerHasChanged !== true) {
            // location group or widget has changed
            // this.foundSavedLayerExtents = false
            this.monitorFeatureCollection = [];
        }
        this.monitorFeatureNamesSet = new Set();
        this.AdsMonitorLayerSource?.refresh();
        // this.AdsMonitorLayerSourceOV.refresh();

        this.uiUtilsService.safeChangeDetection(this.cdr);
    }

    loadMonitorLocations(shouldClearSelection = true) {
        this.monitorLocationUpdate(shouldClearSelection);

        if (this.customerHasChanged) {
            this.removeAllLayers();
            this.monitorFeatureCollection = [];
            this.customerHasChanged = false;
            const currentCustomer = this.gisUserSetting.customerSettings.find((x) => x.cid === this.customerID);

            if (
                currentCustomer &&
                Array.isArray(currentCustomer.lastViewedExtents) &&
                currentCustomer.lastViewedExtents.length === 3
            ) {
                const lastViewedExtents = currentCustomer.lastViewedExtents;
                this.olMap.getView().setCenter([lastViewedExtents[1], lastViewedExtents[2]]);
                this.olMap.getView().setZoom(lastViewedExtents[0]);
                this.foundSavedLayerExtents = true;
            } else {
                this.foundSavedLayerExtents = false;
            }

            this.gisService.getCustomerSettings(this.customerID).subscribe((res: Customer) => {
                const measurementUnit = res?.unitsType === 2 ? 'metric' : 'us';
                this.scaleLinecontrol.setUnits(measurementUnit as Units);
            });

            this.prismLayerLoad();
        }
        this.gisService.getCustomerSettings(this.customerID).subscribe((res: Customer) => {
            if (res) {
                this.measurementUnit = res.unitsType === 2 ? 'metric' : 'us';
            }
        });
        /*setTimeout(() => {
            this.zoomtoInital();
        },3000);*/
    }

    public async loadGisUserSettings() {
        const userSettings = await this.gisService.gisUserSettingsGet();

        if (userSettings !== null) {
            if (!userSettings.customerSettings || userSettings.customerSettings.length === 0) {
                userSettings.customerSettings = [
                    {
                        cid: this.customerID,
                        layers: [],
                        lastViewedExtents: [],
                        lastViewedLocationGroup: undefined,
                    },
                ];
            } else if (
                userSettings.customerSettings &&
                userSettings.customerSettings.findIndex((x) => x.cid === this.customerID) === -1
            ) {
                userSettings.customerSettings.push({
                    cid: this.customerID,
                    layers: [],
                    lastViewedExtents: [],
                    lastViewedLocationGroup: undefined,
                });
            }
            this.gisUserSetting = userSettings;
            this.sidebaropen = userSettings.sidebarIsOn;
            this.sidebaropen2 = userSettings.sidebarIsOn2;
            this.activeBaseMapId = userSettings.baseMapId;
            // It has to be valid, so ngif will show and there will be access to layers. Bug #21292
            this.activeLayersTab = userSettings.activeLayersTabNo || 0;
            this.domOperationUtilsService.selectedGisTab.next(this.activeLayersTab);

            if (userSettings.layersParameterJson != undefined && userSettings.layersParameterJson !== '') {
                this.layersParameterJson = JSON.parse(userSettings.layersParameterJson) as LayersParameterJson;
                this.olMap.getView().setZoom(this.layersParameterJson.zoomStatus);
            }
            if (this.customerID) {
                this.mainComponent.customerChangeHandler(this.customerID);
            }
        } else {
            this.gisUserSetting = {
                id: 0,
                userId: 0,
                locationsIsActive: true,
                languageSelection: 'en-us',
                sidebarIsOn: true,
                sidebarIsOn2: true,
                baseMapId: this.baseMapOptions[0].baseMapId,
                isMapPanelOn: true,
                isLayersOn: true,
                isActive: true,
                selectedLocationGroupId: undefined,
                locationPositionX: '',
                locationPositionY: '',
                isLayersSelectable: true,
                activeLayersTabNo: 0,
                isSidebarPinOn: true,
                showLocationLabels: true,
                isSidebarPinOn2: true,
                layersParameterJson: '',
                lastViewedCustomerId: this.customerID,
                customerSettings: [
                    {
                        cid: this.customerID,
                        layers: [],
                        lastViewedExtents: [],
                        lastViewedLocationGroup: undefined,
                    },
                ],
            };
            this.saveSubject.next();
        }
        this.uiUtilsService.safeChangeDetection(this.cdr);
    }

    public saveGisUserSettings() {
        if (this.gisUserSetting === undefined) {
            return;
        }
        this.gisUserSetting.lastViewedCustomerId = this.customerID;
        this.gisUserSetting.locationsIsActive = this.includeInactiveLocations;

        if (this.layersParameterJson !== null) {
            this.layersParameterJson.zoomStatus = this.olMap.getView().getZoom();
        } else {
            this.layersParameterJson = {
                zoomStatus: this.olMap.getView().getZoom(),
            };
        }

        const affectedCustomer = this.gisUserSetting.customerSettings.find((x) => x.cid === this.customerID);
        if (affectedCustomer) {
            affectedCustomer.lastViewedLocationGroup = this.locationGroupID;
        }

        this.gisService.updateGisUserSettings(this.gisUserSetting).subscribe(() => { });
    }

    /**
     * Method for changing customer
     */
    public async onCustomerChange(): Promise<void> {
        if (this.gisQuickLook) {
            this.gisQuickLook.clearGis();
        }

        this.foundSavedLayerExtents = false;
        const monitorSymbols = this.mapLayerLists.find((x) => x.name === LayerNameOpts.monitor);
        if (monitorSymbols) monitorSymbols.legendInfo = [];

        this.customerLocationsLoaded = false;
        this.clearSelection();
        this.hideFilters();
        this.resetToggleState();
        this.getLocations();
        this.getAllLocations();
        this.getAlarmsTotal();
        this.getBatteryStatusTotal();
        this.getBlockagePredictionTotal();
        this.getAutoDetectTotal();
        this.getFailedCollectsTotal();
        this.getUpcomingCollects();
        this.getEventsTotal({fromEdit: false});
    }

    private refreshBasemapOnCustomerChange() {
        if (!this.baseLayers || !this.activeBaseMapId) {
            return;
        }

        const activeMap = this.baseMapOptions.find((x) => x.baseMapId === this.activeBaseMapId);

        // only token based basemaps need to be reset
        if (!activeMap.url.includes('token')) {
            return;
        }

        const allLayers = this.olMap.getLayers().getArray();
        const activeLayer = allLayers.find(v => v.get('name') === activeMap.name);

        if (activeLayer) {
            this.olMap.removeLayer(activeLayer);

        }

        setTimeout(() => {
            this.applyDynamicBasemap(activeMap.url, activeMap.name);
        }, 0);
    }

    /**
     * Method gets customer locations
     */
    public getLocations(visibleLocations?: Array<number>) {
        // set map loading state
        this.bpLoadingLocations = true;
        this.mapLoadingState = true;

        // ensure customer is set
        if (this.customerID == undefined || this.customerID < 1) {
            this.mapLoadingState = false;
            // this.cumulativeRainTotalLocations = 0;
            this.bpLoadingLocations = false;
            return;
        }

        // initialize location service parameter
        const locationArgs = <LocationArgs>{
            customerId: this.customerID,
            locationGroupId: this.locationGroupID,
            IncludeInactiveLocations: this.includeInactiveLocations,
        };

        this.assignedRainGauge = [];
        const activeInactiveHandler = this.statusCodeService.activeInactiveHandler.getValue();

        const rgParameters: GetAllRainGaugesParams = {
            CID: this.customerID,
            IncludeInactiveLocations: true,
            IType: RAIN_GAUGE,
            PageSize: 1000,
            StartPage: 1,
        };

        const getRainLocationsSubscription = this.customerService.getAllRainGauges(rgParameters).subscribe((rgs: Locations[]) => {
            this.allRainLocations = rgs;
        })

        // setup API call to retrieve fresh locations
        const usersServiceSubscription = this.usersService.getLocationsList(locationArgs).subscribe((data) => {
            if (data) {
                this.bpLoadingLocations = false;
                // store location id from usersService to map with locationDashboardService data
                const tempLocationArray = new Array<number>();
                data.forEach((x) => {
                    if (activeInactiveHandler) {
                        if (x.viewable) {
                            tempLocationArray.push(x.locationId);
                        }
                    } else {
                        if (
                            x.viewable &&
                            (x.status === LocationStatus.Active || x.status === LocationStatus.Maintenance)
                        ) {
                            tempLocationArray.push(x.locationId);
                        }
                    }
                });
                const locationsSubscription = this.locationDashboardService.getLocations(locationArgs).subscribe(
                    (result: Array<Locations>) => {
                        // ensure response
                        if (!result) {
                            return;
                        }
                        //  get the list of current active and acknowledged alarms
                        const alarmArgs = <GetAlarmsArgs>{
                            customerId: this.customerID,
                            Active: true,
                            Acknowledged: true,
                            IncludeInactiveLocations: this.includeInactiveLocations,
                        };

                        const alarmSubscription = this.alarmService.getAlarmsLite(alarmArgs).subscribe(
                            (alarms) => {
                                // set viewable locations
                                this.locations = Array<Locations>();
                                result.forEach((x) => {
                                    if (tempLocationArray.indexOf(x.locationId) > -1) {
                                        this.locations.push(x);
                                    }
                                });
                                this.setupRainGaugeLocations();
                                this.filteredLocations = this.locations.filter((x) => x.geographicLoc !== null);
                                // set customer loaded state
                                this.customerLocationsLoaded = true;

                                // ensure params
                                if (alarms) {
                                    this.updateActiveAlarmingLocations(alarms);
                                } else {
                                    this.updateActiveAlarmingLocations([]);
                                }

                                this.mapLoadingState = false;

                                // 33938 need to make sure that user settings are loaded before calling cumulative rain request
                                this.usersService.userSettings.pipe(filter(v => !!v), first()).subscribe(() => this.getCumulativeRainTotal());

                                this.showLocationMap(false);
                                this.showLocationMap(true);
                                this.uiUtilsService.safeChangeDetection(this.cdr);

                                if (!visibleLocations || visibleLocations.length < 1) {
                                    return;
                                }

                                this.onLocationsChange(visibleLocations);
                            },
                            (error) => {
                                this.mapLoadingState = false;
                                this.bpLoadingLocations = false;
                                this.uiUtilsService.safeChangeDetection(this.cdr);
                            },
                        );

                        this.subscriptions.push(alarmSubscription);
                    },
                    (error) => {
                        this.mapLoadingState = false;
                        this.bpLoadingLocations = false;
                        this.uiUtilsService.safeChangeDetection(this.cdr);
                    },
                );
                this.subscriptions.push(locationsSubscription);
            } else {
                this.bpLoadingLocations = false;
            }
        },
        () => {
            this.bpLoadingLocations = false;
        });
        this.subscriptions.push(usersServiceSubscription, getRainLocationsSubscription);
    }

    public checkAndHideWidgetsOnCustomerChange() {
        if (this.currentWidget !== this.widgetOptions.EVENT && this.currentWidget !== this.widgetOptions.CUMULATIVE_RAIN) {
            return;
        }

        this.subscriptions.push(
            this.usersService.isEventEditorOnCustomerAllowed.pipe(skip(1), first()).subscribe((data: { value: boolean }) => {
                if (!data || data.value === false && (this.currentWidget === this.widgetOptions.EVENT)) {
                    this.closeWidget();
                }
            })
        );

        this.subscriptions.push(
            this.usersService.isCumulativeRainAllowed.pipe(skip(1), first()).subscribe((data: { value: boolean }) => {
                if ((!data || data.value === false) && (this.currentWidget === this.widgetOptions.CUMULATIVE_RAIN)) {
                    this.closeWidget();
                }
            })
        );
    }

    private checkWidgetLoadCondition(widgetConfig: {[key: number]: {enabled: boolean; changed: boolean}}, widget: WIDGET_PARAM, loadingState: boolean) {
        return widgetConfig[widget]?.enabled && (loadingState || widgetConfig[widget]?.changed);
    }

    public getEventsTotal(filters: EventRangeFilters) {
        if (!this.usersService.isEventEditorOnCustomerAllowed.getValue()) {
            return;
        }

        this.eventsLoadingState = true;

        const subscriptionGetEvents = this.widgetConfig$.subscribe(widgetConfig => {
            if(this.checkWidgetLoadCondition(widgetConfig, WIDGET_PARAM.EVENT, this.eventsLoadingState)) {
                const filtersStartDate = filters.startDate ? filters.startDate : new Date(new Date().getFullYear(), new Date().getMonth() - 1, new Date().getDate(), 0, 0, 0);
                const filtersEndDate = filters.endDate ? filters.endDate : new Date(new Date().setHours(23, 59, 59, 999));

                const startStr = this.dateutilService.formatDateToUTC(filtersStartDate);
                const endStr = this.dateutilService.formatDateToUTC(filtersEndDate);

                const sub = this.eventService.getAllEvents(this.customerID, startStr, endStr).subscribe({
                    next: data => {
                        if (filters.fromEdit && this.eventsWidget) {
                            const events = data.map(v => ({ ...v, duration: this.eventService.getDuration(v) }));
                            this.eventsWidget.setDefaultDurations(events);

                            if (this.eventsWidget.gisEventGuid) {
                                const currentGISevent = events.find(v => v.guid === this.eventsWidget.gisEventGuid);
                                this.eventsWidget.gisEventGuid = null;
                                this.eventsWidget.setGISevent(currentGISevent);
                            }
                        }
                        this.events = data ? data : [];
                        // Sort earlier events first
                        this.events.sort((a, b) => (new Date(a.start).getTime() > new Date(b.start).getTime() ? -1 : 1));
                        // need to show events count for last 30 days
                        const start = new Date(new Date().getFullYear(), new Date().getMonth() - 1, new Date().getDate(), 0, 0, 0);
                        const end = new Date(new Date().setHours(23, 59, 59, 999));
                        this.last30daysEventsCount = this.events.filter(v => this.eventService.checkIfEventWithinDateRange(v, start, end)).length;
                        this.uiUtilsService.safeChangeDetection(this.cdr);
                        this.eventsLoadingState = false;
                        sub.unsubscribe();
                    },
                    error: () => {
                        this.eventsLoadingState = false;
                        sub.unsubscribe();
                    }
                });
            }
        });
        this.subscriptions.push(subscriptionGetEvents);
    }

    /**
     * Method sets the total number of critical and low batteries for the current customer ID and group ID
     */
    private getBatteryStatusTotal() {
        this.batteryLoadingState = true;
        this.batteryTotalCount = {
            criticalBatteryTotal: 0,
            lowBatteryTotal: 0,
            customerID: this.customerID,
        };

        const subscriptionGetBatteryStatusTotal = this.widgetConfig$.subscribe(widgetConfig => {
            if(this.checkWidgetLoadCondition(widgetConfig, WIDGET_PARAM.BATTERY, this.batteryLoadingState)) {

                const params = <BatteryStatusReportArgs>{
                    CustomerID: this.customerID,
                    LocationGroupID: this.locationGroupID,
                    IncludeInactiveLocations: this.includeInactiveLocations,
                };

                const sub = this.batteryStatusService.getBatteryStatusTotal(params)
                .subscribe({
                    next: (res: BatteryTotalCount) => {
                        if (res) {
                            this.batteryTotalCount.criticalBatteryTotal = res.criticalBatteryTotal;
                            this.batteryTotalCount.lowBatteryTotal = res.lowBatteryTotal;
                        }
                        this.batteryLoadingState = false;
                        this.uiUtilsService.safeChangeDetection(this.cdr);
                        sub.unsubscribe();
                    },
                    error: () => {
                        this.batteryLoadingState = false;
                        this.uiUtilsService.safeChangeDetection(this.cdr);
                        sub.unsubscribe();
                    },
                });
            }
        });

        this.subscriptions.push(subscriptionGetBatteryStatusTotal);
    }

    /**
     * Method sets the total number of critical alarms for the current customer ID and group ID
     */
    public getAlarmsTotal() {
        this.alarmLoadingState = true;
        this.activeAlarmCount = null;

        // #42467
        const subscriptionGetActiveAlarms =
            this.widgetConfig$.subscribe(widgetConfig => {
                if(this.checkWidgetLoadCondition(widgetConfig, WIDGET_PARAM.ALARM, this.alarmLoadingState)) {
                    const sub = this.alarmService
                    .getAlarmCount(this.customerID, this.locationGroupID)
                    .subscribe({
                        next: (res: AlarmsTotal) => {
                            this.activeAlarmCount = res.alarmstotal;
                            this.alarmLoadingState = false;
                            this.uiUtilsService.safeChangeDetection(this.cdr);
                            sub.unsubscribe();
                        },
                        error: () => {
                            this.alarmLoadingState = false;
                            this.uiUtilsService.safeChangeDetection(this.cdr);
                            sub.unsubscribe();
                        }},
                    );
                }
            });

        this.subscriptions.push(subscriptionGetActiveAlarms);
    }

    /**
     * Method sets the total number of auto-review items
     */
    private getAutoDetectTotal() {
        this.autoReviewLoadingState = true;
        this.autoReviewCount = null;

        const subscriptionGetAutoDetectCount = this.widgetConfig$.subscribe(widgetConfig => {
            if(this.checkWidgetLoadCondition(widgetConfig, WIDGET_PARAM.AUTO_REVIEW, this.autoReviewLoadingState)) {

                const startDate = new Date();
                startDate.setDate(startDate.getDate() - 1);
                const endDate = startDate;
                const sDate = [startDate.getMonth() + 1, startDate.getDate(), startDate.getFullYear()].join('-');
                let eDate = [endDate.getMonth() + 1, endDate.getDate(), endDate.getFullYear()].join('-');
                eDate += ' 23:59:59';

                const params = <AutoDetectDetectCountArgs>{
                    CustomerId: this.customerID,
                    LocationGroupId: this.locationGroupID,
                    startDate: sDate,
                    endDate: eDate,
                    AnomalyThreshold: 10,
                    IncludeInactiveLocations: this.includeInactiveLocations,
                };

                const sub = this.autoScrubSummaryService.getAutoDetectCount(params).subscribe(
                    (res: AnomaliesCount) => {
                        this.autoReviewCount = res;
                        this.autoReviewLoadingState = false;
                        this.uiUtilsService.safeChangeDetection(this.cdr);
                        sub.unsubscribe();
                    },
                    (error) => {
                        this.autoReviewLoadingState = false;
                        sub.unsubscribe();
                    },
                )
            }
        });

        this.subscriptions.push(subscriptionGetAutoDetectCount);
    }

    /**
     * Method sets the total number of failed collections
     */
    private getFailedCollectsTotal() {
        this.collectionTileLoadingState = true;
        this.failedCollection = 0;

        const subscriptionGetFailedCollection = this.widgetConfig$.subscribe(widgetConfig => {
            if(this.checkWidgetLoadCondition(widgetConfig, WIDGET_PARAM.DATA_COMMUNICATION, this.collectionTileLoadingState)) {

                const startDate = new Date();
                startDate.setDate(startDate.getDate() - 1);
                const endDate = startDate;
                const args = <GetCollectHistoryArgs>{
                    customerID: this.customerID,
                    LocationGroupID: this.locationGroupID,
                    StartTime: startDate,
                    EndTime: endDate,
                    Status: 3,
                    IncludeInactiveLocations: this.includeInactiveLocations,
                };
                const sub = this.scheduleCollectionService.getCollectionHistory(args).subscribe(
                    (result: Array<CollectionHistory>) => {
                        if (result) {
                            this.failedCollection = result.length;
                        }
                        this.collectionTileLoadingState = false;
                        this.uiUtilsService.safeChangeDetection(this.cdr);
                        sub.unsubscribe();
                    },
                    (error) => {
                        this.collectionTileLoadingState = false;
                        this.uiUtilsService.safeChangeDetection(this.cdr);
                        sub.unsubscribe();
                    },
                );
            }
        });

        this.subscriptions.push(subscriptionGetFailedCollection);
    }

    private cumulativeRainDisplayDataPlaceholder() {
        const quickSpanSetting = this.usersService.getQuickSpanCumulativeRainSetting();
        this.cumulativeRainInfo = {
            value: 0,
            description: `${this.translate.instant('HOME.CUMULATIVE_RAIN_TILE.ITEM_TEXT')} ${this.dateService.quickSpanDescriptionForQuickSpan(quickSpanSetting)}`
        }
    }
    private getCumulativeRainTotal() {
        if(!this.usersService.isCumulativeRainAllowed.getValue()) {
            this.cumulativeRainLoadingState = false;
            return;
        }

        const loadingDone = () => {
            this.cumulativeRainLoadingState = false;
        }

        this.cumulativeRainLoadingState = true;
        const subscriptionCumulativeRain = this.widgetConfig$.subscribe(widgetConfig => {
            if(this.checkWidgetLoadCondition(widgetConfig, WIDGET_PARAM.CUMULATIVE_RAIN, this.cumulativeRainLoadingState)) {

                if(this.cumulativeRainCachedInfo) {
                    const quickSpanSetting = this.usersService.getQuickSpanCumulativeRainSetting();

                    if(this.cumulativeRainCachedQuickSpan === quickSpanSetting) {
                        this.cumulativeRainInfo = this.cumulativeRainCachedInfo;
                        loadingDone();
                        return;
                    } else {
                        this.cumulativeRainCachedQuickSpan = null;
                        this.cumulativeRainCachedInfo = null;
                        this.cumulativeRainDisplayDataPlaceholder();
                        this.uiUtilsService.safeChangeDetection(this.cdr);
                    }
                }

                this.bpLoadingLocations = true;
                this.usersService.userSettings.subscribe((ignoreSettings) => {
                    this.cumulativeRainDisplayDataPlaceholder();
                    const dateRange = this.usersService.getQuickSpanCumulativeRainDateRange();
                    const rainSub = this.usersService.getRainLocations(
                        this.customerID,
                        this.includeInactiveLocations,
                        this.locationGroupID,
                        true
                    ).subscribe((rainLocationsRes) => {
                        if(rainLocationsRes) {
                            const rainLocations = rainLocationsRes.map(v => v.locationId);

                            this.bpLoadingLocations = false;
                            if(!rainLocations || !rainLocations.length) {
                                this.cumulativeRainInfo = null;
                            } else {
                                this.usersService.userSettings.getValue();

                                const quickSpanSetting = this.usersService.getQuickSpanCumulativeRainSetting();
                                this.cumulativeRainCachedQuickSpan = quickSpanSetting;
                                this.cumulativeRainInfo = {
                                    value: rainLocations.length,
                                    description: `${this.translate.instant('HOME.CUMULATIVE_RAIN_TILE.ITEM_TEXT')} ${this.dateService.quickSpanDescriptionForQuickSpan(quickSpanSetting)}`
                                }
                                this.cumulativeRainCachedInfo = this.cumulativeRainInfo;
                                loadingDone();
                            }
                        } else {
                            loadingDone()
                            this.cumulativeRainDisplayDataPlaceholder();
                        }
                    },
                    () => {
                        this.cumulativeRainDisplayDataPlaceholder();
                        loadingDone()
                    },
                    () => {
                        rainSub.unsubscribe();
                    });

                },
                () => { loadingDone() },
                () => { loadingDone() }
                ).unsubscribe();
            }
        });

        this.subscriptions.push(subscriptionCumulativeRain);
    }

    public onCumulativeRainInfo(info: CumulativeRainInfo) {
        this.cumulativeRainInfo = info;
    }

    /**
     * Method sets the upcoming collections
     */
    private getUpcomingCollects() {
        this.collectionLoadingState = true;
        this.upcomingScheduleCollection = null;
        // update the collection on tiles
        const subscriptionGetUpcomingCollection = this.scheduleCollectionService
            .getUpcomingCollection(this.customerID)
            .subscribe(
                (res: string) => {
                    this.upcomingScheduleCollection = res;
                    this.collectionLoadingState = false;
                    this.uiUtilsService.safeChangeDetection(this.cdr);
                },
                (error) => {
                    this.collectionLoadingState = false;
                    this.uiUtilsService.safeChangeDetection(this.cdr);
                },
            );

        this.subscriptions.push(subscriptionGetUpcomingCollection);
    }

    /**
     * Method sets the total number of blockage prediction items for current customer and group ID
     */
    private getBlockagePredictionTotal() {
        this.bpLoadingState = true;
        this.blockagePredictionCount = null;

        const subscriptionGetBlockagePRedictionCount = this.widgetConfig$.subscribe(widgetConfig => {
            if(this.checkWidgetLoadCondition(widgetConfig, WIDGET_PARAM.BLOCKAGE_PREDICT, this.bpLoadingState)) {

                const sub = this.blockagePredictionService
                    .getTileBlockagePredictionCount(this.customerID, this.locationGroupID)
                    .subscribe(
                        (res: number) => {
                            this.blockagePredictionCount = res;
                            this.bpLoadingState = false;
                            this.uiUtilsService.safeChangeDetection(this.cdr);
                            sub.unsubscribe();
                        },
                        (error) => {
                            this.bpLoadingState = false;
                            this.uiUtilsService.safeChangeDetection(this.cdr);
                            sub.unsubscribe();
                        },
                    );
                }
            });

        this.subscriptions.push(subscriptionGetBlockagePRedictionCount);
    }

    /**
     * Method updates the map with the locations whose IDs passed as argument
     * @param locationIds - locations to set the map to
     */
    public onLocationsChange(locationIds: number[]) {
        this.showLocationMap(false);

        if (!locationIds || locationIds.length === 0) {
            this.locations = this.filteredLocations;
            this.uiUtilsService.safeChangeDetection(this.cdr);
            this.showLocationMap(true);
            return;
        }
        const filteredMarkers = [];
        if (this.filteredLocations) {
            for (const locationId of locationIds) {
                const filteredMarker = this.filteredLocations.find((location) => location.locationId === locationId);
                if (filteredMarker) {
                    filteredMarkers.push(filteredMarker);
                }
            }
        }

        this.locations = filteredMarkers;
        this.locations.sort((a: Locations, b: Locations) => {
            const alocationName = a.locationName.toLowerCase();
            const blocationName = b.locationName.toLowerCase();

            if (alocationName < blocationName) {
                return -1;
            } else if (alocationName > blocationName) {
                return 1;
            } else {
                return 0;
            }
        });

        this.showLocationMap(true);
    }

    public alarmStatusChange(event: AlarmStatusChange) {
        this.updateMapAndAlarms(event.toggleState);
    }

    private updateMapAndAlarms(toggleMap?: boolean) {
        const args = <GetAlarmsArgs>{
            customerId: this.customerID,
            LocationGroupID: this.locationGroupID,
            Active: true,
            Acknowledged: true,
            IncludeInactiveLocations: this.includeInactiveLocations,
        };

        const alarmSub = this.alarmService.getAlarmsLite(args).subscribe(
            (response: Array<AlarmLiteResponseItem>) => {
                const activeAlarms = response || new Array<AlarmLiteResponseItem>();
                this.updateActiveAlarmingLocations(activeAlarms);
                // REMOVED AMP: don't want to remove locations from map which is what the below function does
                // this.onLocationsChange(activeAlarms.map(x => x.lid));
                this.updateAlarmTable = false;
                this.activeAlarmCount = activeAlarms.filter((alarm) => alarm.state === 0).length;
                this.uiUtilsService.safeChangeDetection(this.cdr);

                if (toggleMap !== undefined) {
                    this.showLocationMap(toggleMap);
                }

                // #23626 Update selected locations to match alarm status
                this.updateSelectedFeatures();
            },
            () => {
                this.updateAlarmTable = false;
            },
        );
        this.subscriptions.push(alarmSub);
    }

    private adjustFeatureAlarmsProperties(feature: Feature) {
        const featLid = feature.get('LocationID');

        if (featLid in this.alarmStateFinder) {
            if (feature.get('AlarmId')) {
                //alarmid already set
            } else {
                feature.set('AlarmId', true);
            }

            if (this.alarmStateFinder[featLid] == 1) {
                if (feature.get('AcknowledgedBy')) {
                    //AcknowledgedBy already set
                } else {
                    feature.set('AcknowledgedBy', true);
                }
            } else {
                feature.set('AcknowledgedBy', false);
            }
        } else {
            feature.set('AlarmId', undefined);
        }
    }

    private updateAlarmStateFinder(alarms: AlarmLiteResponseItem[]) {
        // 0 is unacknowledged, 1 is acknowledged, we need to set the worst alarm state, which is 0
        const getAlarmState = (oldState: 0 | 1, newState: 1 | 0) => {
            return (oldState === 0 || newState === 0) ? 0 : 1;
        }
        this.alarmStateFinder = alarms.reduce((acc, curr) => {
            if (curr.lid in acc) {
                acc[curr.lid] = getAlarmState(acc[curr.lid], curr.state);
            } else {
                acc[curr.lid] = curr.state;
            }

            return acc;
        }, {});

        if (this.AdsMonitorLayerSource == undefined) {
            return;
        }

        this.AdsMonitorLayerSource.forEachFeature((feature) => {
            this.adjustFeatureAlarmsProperties(feature);
        });
    }

    private updateActiveAlarmingLocations(alarms: Array<AlarmLiteResponseItem>) {
        this.updateAlarmStateFinder(alarms);

        this.showLocationMap(false);

        if (!alarms || alarms.length === 0) {
            if (this.locations) {
                this.locations
                    .filter((x) => x.alarmingState !== undefined)
                    .forEach((location) => {
                        delete location.alarmingState;
                    });
            }
            if (this.filteredLocations) {
                this.filteredLocations
                    .filter((x) => x.alarmingState !== undefined)
                    .forEach((filteredLoc) => {
                        delete filteredLoc.alarmingState;
                    });
            }
            this.updateAlarmTable = false;
            this.showLocationMap(true);
            return;
        }
        if (this.locations && this.locations.length > 0) {
            this.updateLocationsAlarmingState(alarms, this.locations);
        }

        if (this.filteredLocations && this.filteredLocations.length > 0) {
            this.updateLocationsAlarmingState(alarms, this.filteredLocations);
        }


        this.updateAlarmTable = false;
        this.showLocationMap(true);
    }

    private updateLocationsAlarmingState(alarms: AlarmLiteResponseItem[], locations: Locations[]) {
        const lowerstStatePerLocation: {
            [key: number]: number;
        } = alarms.reduce((acc, alarm) => {
            let state;
            if (acc[alarm.lid] !== undefined) {
                state = Math.min(acc[alarm.lid], alarm.state);
            } else {
                state = alarm.state;
            }

            return {
                ...acc,
                [alarm.lid]: state,
            };
        }, {});

        const updatedLocations: {[key: number]: boolean} = [];
        Object.entries(lowerstStatePerLocation).forEach(([lid, state]) => {
            const location = locations.find((x) => x && x.locationId.toString() === lid);
            if (location) {
                location.alarmingState = state;
                updatedLocations[lid] = true;
            }
        });

        // #23626 Remove alarms that does not exist anymore
        for(const loc of locations) {
            if(!updatedLocations[loc.locationId]) {
                delete loc.alarmingState;
            }
        }


    }
    /**
     * Method for closing a widget
     */
    public closeWidget() {
        this.currentlyDisplayedLocationIds$.next([]);
        this.displayMapRains.overrideTooltip = false;
        this.displayMapRains.customLegend = false;
        this.displayMapRains.whiteLocations$.next(false);
        this.displayMapRains.rains$.next(null);
        this.currentWidget = this.widgetOptions.ALL;
        this.domOperationUtilsService.homePageSelectedWidget = this.widgetOptions.ALL;

        this.showLocationMap(false);
        this.viewableLocationsIds = this.originalLocationsIds;
        if (this.AdsMonitorLayerSource) {
            this.loadMonitorLocations(false);
        }
        this.locations = this.filteredLocations;
        this.uiUtilsService.safeChangeDetection(this.cdr);
        this.toggleWidgetSize(true);
        this.showLocationMap(true);
    }

    public onCumulativeRain(rains: MapRain[]) {
        this.displayMapRains.overrideTooltip = false;
        this.displayMapRains.customLegend = false;
        this.displayMapRains.whiteLocations$.next(false);
        this.displayMapRains.rains$.next(rains);

        const rainsIds = rains.map(r => r.lid);
        this.currentlyDisplayedLocationIds$.next(rainsIds);
        this.viewableLocationsIds = rainsIds;
        this.loadMonitorLocations(false);

        this.olMap.getView().setZoom(this.olMap.getView().getZoom() - 0.5);
    }

    public onGISevent(event: EventModel | null) {
        if (!event || !this.eventsWidget) {
            this.displayMapRains.rains$.next(null);
            this.currentlyDisplayedLocationIds$.next([]);
            this.displayMapRains.overrideTooltip = false;
            this.displayMapRains.customLegend = false;
            this.displayMapRains.whiteLocations$.next(false);
            this.monitorLocationUpdate(false);

            return;
        }

        const allRelatedEvents = this.eventService.getAllRelatedEventsToCurrent(event, this.events, this.eventsWidget.filteredTree);
        const allDisplayedLocationIds: number[] = Array.from(allRelatedEvents.reduce((acc: Set<number>, curr: EventModel) => {
            if (curr.lids && curr.lids.length) {
                curr.lids.forEach(v => acc.add(v));
            }

            return acc;
        }, new Set()));

        this.toggleWidgetSize(true);

        if (event.etype === EventTypes.Rain && event.res) {
            const allRainData: EventRain[] = allRelatedEvents.reduce((acc, curr) => {
                if (!curr.res || !curr.res.locs) return acc;

                return [...acc, ...curr.res.locs];
            }, []);
            this.displayMapRains.rains$.next(allRainData);
        } else {
            this.displayMapRains.rains$.next(null);
        }

        this.displayMapRains.overrideTooltip = true;
        this.displayMapRains.customLegend = true;
        this.displayMapRains.whiteLocations$.next(true);

        this.AdsMonitorLayerSource.clear();
        this.monitorFeatureNamesSet.clear();

        this.currentlyDisplayedLocationIds$.next(allDisplayedLocationIds);
        this.viewableLocationsIds = allDisplayedLocationIds;

        this.monitorsRefreshedSubject.pipe(
            debounceTime(100),
            first()
        ).subscribe(() => {
            const format = new GeoJSON();
            const featuresForExtent = this.AdsMonitorLayerSource.getFeatures()
                .filter(feature => allDisplayedLocationIds.includes(feature.get('LocationID')));

            if (featuresForExtent.length === 0) return;

            const featureCollection = {
                type: FEATURE_COLLECTION,
                features: featuresForExtent.map(feature => format.writeFeatureObject(feature))
            };

            const bbox = turf.bbox(featureCollection);
            const extent: [number, number, number, number] = [bbox[0], bbox[1], bbox[2], bbox[3]];

            this.olMap.getView().fit(extent);
            this.olMap.getView().setZoom(this.olMap.getView().getZoom() - 0.5);
        });

        this.loadMonitorLocations(false);
        allDisplayedLocationIds.length === 1 ? this.zoomToSelectedLID(allDisplayedLocationIds[0]) : this.onGisMultipleMonitors(allDisplayedLocationIds);
    }

    private onGisMultipleMonitors(locationIds: number[]) {
        this.viewableLocationsIds = [...new Set(locationIds)] as Array<number>;

        if (this.AdsMonitorLayerSource) {
            this.loadMonitorLocations(false);
        }

        this.monitorsRefreshedSubject.pipe(filter(v => v === locationIds.length), first())
            .subscribe((v) => {
                this.olMap.getView().fit(this.initialMapExtent);
                this.olMap.getView().setZoom(this.olMap.getView().getZoom() - 0.5);
            });
    }

    /**
     * Method for hiding widgets' filters
     */
    public hideFilters() {
        this.showSearchAlarms(false);
        this.showSearchBatteryStatus(false);
        this.showSearchBlockagePrediction(false);
        this.showSearchAutoReviw(false);
        this.showSearchCollection(false);
        this.uiUtilsService.safeChangeDetection(this.cdr);
    }

    /**
     * Method for resetting a widget to collapsed state
     */
    public resetToggleState() {
        this.toggleState = true;
        this.domOperationUtilsService.isHomePageWidgetToggled = true;
        this.uiUtilsService.safeChangeDetection(this.cdr);
    }

    public loadWidgetDetail(type) {
        if (this.currentWidget == type) {
            const cumulativeRainWidtgetClose = this.currentWidget === WIDGET_PARAM.CUMULATIVE_RAIN;

            this.currentWidget = this.widgetOptions.ALL;
            this.domOperationUtilsService.homePageSelectedWidget = this.widgetOptions.ALL;
            this.closeWidget();
            this.monitorLocationUpdate(false);

            if(cumulativeRainWidtgetClose) {
                this.cumulativeRainInfo = null;
                this.getCumulativeRainTotal();
            }
        } else {
            this.currentWidget = type;
            this.domOperationUtilsService.homePageSelectedWidget = type;
            this.monitorLocationUpdate(false);
        }
    }

    /**
     * Method for showing / hiding the map
     * @param value - show/hide map
     */
    public showLocationMap(value: boolean) {
        this.showMap = value;
        this.uiUtilsService.safeChangeDetection(this.cdr);
    }

    /**
     * Method sets battery alarms search filter to show /hide
     * @param value - show/hide alarms search filters
     */
    public showSearchAlarms(value?: boolean) {
        this.domOperationUtilsService.scrollToTop('#alarmWidgetCardContentId');
        if (value == null) {
            this.showAlarmSearch = !this.showAlarmSearch;
            return;
        }
        this.showAlarmSearch = value;
    }



    private alarmsReload() {
        this.getAlarmsTotal();
    }

    public alarmsClearAll() {
        this.alarmWidgetComponent.first?.alarmsClearAll();
    }

    public alarmsAcknowledgeAll() {
        this.alarmWidgetComponent.first?.alarmsAcknowledgeAll();
    }

    /**
     * Method sets battery status widget search filter to show /hide
     * @param value - show/hide battery status search filters
     */
    public showSearchBatteryStatus(value?: boolean) {
        this.domOperationUtilsService.scrollToTop('#batteryWidgetId');
        if (value == null) {
            this.showBatteryStatusSearch = !this.showBatteryStatusSearch;
            return;
        }
        this.showBatteryStatusSearch = value;
    }

    /**
     * Method sets blockage prediction widget search filter to show /hide
     * @param value - show/hide blockage prediction search filters
     */
    public showSearchBlockagePrediction(value?: boolean) {
        this.domOperationUtilsService.scrollToTop('#blockagePredictionWidgetCardContentId');
        if (value == null) {
            this.showBlockagePredictionSearch = !this.showBlockagePredictionSearch;
            return;
        }
        this.showBlockagePredictionSearch = value;
    }

    /**
     * Method sets colleciton widget search filter to show /hide
     * @param value - show/hide collection search filters
     */
    public showSearchCollection(value?: boolean) {
        this.domOperationUtilsService.scrollToTop('#collectionWidgetCardContentId');
        if (value == null) {
            this.showCollectionSearch = !this.showCollectionSearch;
            return;
        }
        this.showCollectionSearch = value;
    }

    public showEventFilters(value?: boolean) {
        this.domOperationUtilsService.scrollToTop('#eventWidget');
        if (value == null) {
            this.showEventSearch = !this.showEventSearch;
            return;
        }
        this.showEventSearch = value;
    }

    public showCumulativeRainFilters(value?: boolean) {
        this.domOperationUtilsService.scrollToTop('#eventWidget');
        if (value == null) {
            this.showCumulativeRainSearch = !this.showCumulativeRainSearch;
            return;
        }
        this.showCumulativeRainSearch = value;
    }

    /**
     * Method sets auto review search filters to show / hide
     * @param value - show/hide auto review search filters
     */
    public showSearchAutoReviw(value?: boolean) {
        this.domOperationUtilsService.scrollToTop('#autoReviewWidgetId');
        if (value == null) {
            this.showAutoReviwSearch = !this.showAutoReviwSearch;
            return;
        }
        this.showAutoReviwSearch = value;
    }

    /**
     * Method intiates a refresh of anomalies summary for the current customer
     */
    public initiateAnomaliesRefresh() {
        this.autoScrubSummaryService.postAnomaliesRefresh(this.customerID).subscribe(
            (response) => {
                if (response && response === 'Accepted') {
                    this.snackBar.open(this.anamoliesRefreshSuccessMsg, this.dismissBtn, { duration: 10000 });
                } else {
                    this.snackBar.open(this.anamoliesRefreshFailedMsg, this.dismissBtn, { duration: 10000 });
                }
            },
            (error) => {
                this.snackBar.open(this.anamoliesRefreshFailedMsg, this.dismissBtn, {
                    panelClass: 'custom-error-snack-bar',
                });
            },
        );
    }

    // Full screen or within default drawer sizing for widgets
    public toggleWidgetSize(toCollapse: boolean) {
        // toCollapse = true when want to collapse; true when want to expand
        this.showLocationMap(toCollapse);
        this.toggleState = toCollapse;
        this.domOperationUtilsService.isHomePageWidgetToggled = toCollapse;
        this.uiUtilsService.safeChangeDetection(this.cdr);
    }

    public addEvent() {
        const editSubs = this.dialog.open(AddEventDialogComponent, {
            data: {
                customerId: this.customerID,
                includeInactiveLocations: this.includeInactiveLocations,
                locationGroupId: this.locationGroupID,
                events: this.events,
                hasPermission: true
            },
            disableClose: true
        }).afterClosed().subscribe((result: boolean) => {
            if (result) {
                // timeout is needed to unprioritize method call
                setTimeout(() => {
                    // #46043 Get Start and end date from widget
                    const eventOptions: EventRangeFilters = {
                        fromEdit: true
                    };
                    if(this.eventWidgetList.length > 0) {
                        const eventWidget = this.eventWidgetList.first;
                        eventOptions.startDate = eventWidget.filterOptions.startDate;
                        eventOptions.endDate = eventWidget.filterOptions.endDate;
                    }
                    this.getEventsTotal(eventOptions);
                }, 0);
            }
        });

        this.subscriptions.push(editSubs);
    }

    // Functions to adjust map center/zoom
    public getGPSLocation() {
        // When the user wants to zoom to their current location
        const geoPosition = this.geolocation.getPosition();
        if (geoPosition) {
            this.positionFeature.setGeometry(new Point(geoPosition));
            this.olMap.getView().setCenter(geoPosition);
            this.olMap.getView().setZoom(18);
        } else {
            this.dialog.open(LocationStepsGPSComponent, { disableClose: true });
        }
    }
    public zoomIn() {
        this.olMap.getView().setZoom(this.olMap.getView().getZoom() + 1);
    }
    public zoomOut() {
        this.olMap.getView().setZoom(this.olMap.getView().getZoom() - 1);
    }
    public zoomToInital() {
        if (this.initialMapExtent && !this.initialMapExtent.some(x => x === Infinity || x === -Infinity)) {
            this.olMap.getView().fit(this.initialMapExtent);
        }

        this.zoomOut(); // Add a bit of padding around the map by zooming out 1x
    }

    public zoomToLocationIDs(locations: number[]) {
        if (locations === null || locations.length === 0) {
            this.viewableLocationsIds = this.originalLocationsIds;
        } else {
            this.viewableLocationsIds = [...new Set(locations)] as Array<number>;
        }
        if (this.AdsMonitorLayerSource) {
            this.loadMonitorLocations(false);
        }
        this.olMap.getView().fit(this.initialMapExtent);
    }

    public zoomToSelectedFeature(featureOrLayer: featureSelList[] | { name: string }[]) {
        const format = new GeoJSON();
        const selectionFeatureCollection: GeoJSONFeature[] = [];

        const firstItem = featureOrLayer[0];
        if ('feature' in firstItem && firstItem.feature) {
            const geoJsonFeat = format.writeFeatureObject(firstItem.feature);
            selectionFeatureCollection.push(geoJsonFeat);
        } else if ('name' in firstItem) {
            const selectionLayerName = firstItem.name;
            this.SelectionLayerSource.forEachFeature((feature) => {
                const featureLayerName = feature.get('_layername');
                if (featureLayerName === selectionLayerName) {
                    const geoJsonFeat = format.writeFeatureObject(feature);
                    selectionFeatureCollection.push(geoJsonFeat);
                }
            });
        }

        const bbox = turf.bbox({
            type: FEATURE_COLLECTION,
            features: selectionFeatureCollection,
        });
        const bboxExtent: Extent = [bbox[0], bbox[1], bbox[2], bbox[3]];

        this.olMap.getView().fit(bboxExtent, { maxZoom: SAFE_MAX_ZOOM_LEVEL });
        if (selectionFeatureCollection.length > 1) {
            this.zoomOut();
        }
    }

    private zoomToSelectedLID(locationId: number) {
        const thisLocationFeature = this.AdsMonitorLayerSource.getFeatures().find(
            (x) => x.get('LocationID') === locationId,
        );
        if (!thisLocationFeature) {
            return;
        }

        const lonLat = [thisLocationFeature.get('Longitude'), thisLocationFeature.get('Latitude')];
        this.olMap.getView().setZoom(18);
        this.olMap.getView().setCenter(fromLonLat(lonLat));
        this.uiUtilsService.safeChangeDetection(this.cdr);
    }

    public zoomToSelectedLayer(layersList: mapLayerList[]) {
        if (layersList[0].name == MONITOR_LAYER_NAME) {
            this.zoomToInital();
            return;
        }

        const affectedLayer = this.olMap
            .getLayers()
            .getArray()
            .find((x) => x.get('name') === layersList[0].name);

        if (!affectedLayer) {
            return;
        }

        const extentToFit = affectedLayer.get(ESRI_VECTOR_LAYER_EXTENT_PROPERTY);

        if (!extentToFit || isEmpty(extentToFit)) {
            return;
        }

        this.olMap.getView().fit(extentToFit, {
            padding: [50, 50, 50, 50],
            duration: 500,
            maxZoom: 18
        });
    }
    // End functions to adjust map center/zoom

    // Sidebar functions 2
    public openSideBar2(sideBarOpen2: boolean) {
        this.sidebaropen2 = sideBarOpen2;
        if (this.gisUserSetting) {
            this.gisUserSetting.sidebarIsOn2 = sideBarOpen2;
            this.saveSubject.next();
            this.updateMapSize();
            if (this.sidebaropen2) {
                //quick look
                this.featureselected(this.featureclick);
            }
        }
    }

    // Sidebar functions
    public openSideBar(sideBarOpen: boolean) {
        this.sidebaropen = sideBarOpen;
        this.gisUserSetting.sidebarIsOn = sideBarOpen;
        this.saveSubject.next();
        this.updateMapSize();
    }
    public clickOnSidebarTab(tabChangeEvent: MatTabChangeEvent): void {
        this.activeLayersTab = tabChangeEvent.index;
        this.gisUserSetting.activeLayersTabNo = tabChangeEvent.index;
        this.domOperationUtilsService.selectedGisTab.next(this.activeLayersTab);
        this.saveSubject.next();
    }
    // End sidebar functions

    // Measuring functions
    public startMeasure(measureType: GeometryType): void {
        this.stopMeasureDrawing();
        this.measureSelectionEnabled = this.enableSelection;
        this.enableSelection = false;
        this.measureDoubleClickZoom =
            this.olMap
                .getInteractions()
                .getArray()
                .find((interaction): interaction is DoubleClickZoom => interaction instanceof DoubleClickZoom) ?? null;

        if (this.measureDoubleClickZoom) {
            this.olMap.removeInteraction(this.measureDoubleClickZoom);
        }

        const measureDraw = new Draw({
            source: this.measureLayer.getSource(),
            type: measureType,
            style: (feature) => {
                return measureStyle(feature, this.measurementUnit);
            },
        });
        this.measureDraw = measureDraw;
        measureDraw.on('drawend', () => {
            this.olMap.removeInteraction(measureDraw);
            if (this.measureDraw === measureDraw) {
                this.measureDraw = null;
            }
            this.measureRestoreTimeout = setTimeout(() => {
                this.measureRestoreTimeout = null;
                this.restoreMeasureInteractionState();
            });
        });
        this.olMap.addInteraction(measureDraw);
    }

    public clearMeasure(): void {
        this.stopMeasureDrawing();
        this.measureLayer.getSource().clear();
    }

    private stopMeasureDrawing(): void {
        if (this.measureDraw) {
            this.olMap.removeInteraction(this.measureDraw);
            this.measureDraw = null;
        }
        this.restoreMeasureInteractionState();
    }

    private restoreMeasureInteractionState(): void {
        if (this.measureRestoreTimeout !== null) {
            clearTimeout(this.measureRestoreTimeout);
            this.measureRestoreTimeout = null;
        }
        if (
            this.measureDoubleClickZoom &&
            !this.olMap.getInteractions().getArray().includes(this.measureDoubleClickZoom)
        ) {
            this.olMap.addInteraction(this.measureDoubleClickZoom);
        }
        this.measureDoubleClickZoom = null;
        if (this.measureSelectionEnabled !== null) {
            this.enableSelection = this.measureSelectionEnabled;
            this.measureSelectionEnabled = null;
        }
    }
    // End measuring functions

    public resetMap(locationEvent: LocationDetailsModel) {
        if (locationEvent && locationEvent.isRefreshLocations) {
            // if (Number.isInteger(this.currentWidget)) {
            this.onLocationsChange(this.locations.map((x) => x.locationId));
            // } else {
            //     if (this.filteredLocations !== undefined && this.filteredLocations.length > 0) {
            //         this.onLocationsChange(this.filteredLocations.map(x => x.locationId));
            //     }
            // }
            // remove commented as its not refresing the map

            this.getLocations();
            this.customerLocationsLoaded = false;
        }
    }

    private applyRendererToFeature(feature: Feature, renderer: ArcGISRenderer): Style | Style[] {
        if (!renderer) {
            return this.getArcGISLayerStyle('esriGeometryPoint');
        }

        const geometryType = feature.getGeometry()?.getType();
        let symbol = null;

        switch (renderer.type) {
            case ESRI_RENDERER_TYPES.SIMPLE:
                symbol = renderer.symbol;
                break;

            case ESRI_RENDERER_TYPES.UNIQUE_VALUE:
                const value = feature.get(renderer.field1 || renderer.field);
                const uniqueValueInfo = renderer.uniqueValueInfos?.find((info: ArcGISUniqueValueInfo) =>
                    info.value === value || info.value == value
                );
                symbol = uniqueValueInfo?.symbol || renderer.defaultSymbol;
                break;

            case ESRI_RENDERER_TYPES.CLASS_BREAKS:
                const fieldValue = parseFloat(feature.get(renderer.field));
                const classBreakInfo = renderer.classBreakInfos?.find((info: ArcGISClassBreakInfo) =>
                    fieldValue >= (info.classMinValue ?? -Infinity) &&
                    fieldValue < (info.classMaxValue ?? Infinity)
                );
                symbol = classBreakInfo?.symbol || renderer.defaultSymbol;
                break;

            default:
                symbol = renderer.defaultSymbol || renderer.symbol;
        }

        if (!symbol) {
            return this.getArcGISLayerStyle(geometryType);
        }

        return this.convertSymbolToOLStyle(symbol);
    }

    private logGeometryTypeSummary(): void {
        if (this.geometryTypesLoaded.size > 0) {
            const esriTypes = Array.from(this.geometryTypesLoaded).filter(t => t.startsWith('esri'));

            if (esriTypes.length > 0) {
            }

        }
    }

    private getArcGISLayerStyle(geometryType: string): Style | Style[] {
        switch(geometryType) {
            case ESRI_GEOMETRY_TYPES.POINT:
                return new Style({
                    image: new StyleCircle({
                        radius: 6,
                        fill: new Fill({ color: 'rgba(74, 144, 226, 0.8)' }),
                        stroke: new Stroke({ color: '#ffffff', width: 2 })
                    })
                });
            case ESRI_GEOMETRY_TYPES.POLYLINE:
                return new Style({
                    stroke: new Stroke({
                        color: 'rgba(74, 144, 226, 0.9)',
                        width: 3
                    })
                });
            case ESRI_GEOMETRY_TYPES.POLYGON:
                return new Style({
                    fill: new Fill({ color: 'rgba(74, 144, 226, 0.3)' }),
                    stroke: new Stroke({ color: 'rgba(74, 144, 226, 1)', width: 2 })
                });
            default:
                return new Style({
                    image: new StyleCircle({
                        radius: 6,
                        fill: new Fill({ color: 'rgba(156, 39, 176, 0.8)' }),
                        stroke: new Stroke({ color: '#ffffff', width: 2 })
                    })
                });
        }
    }

    private rgbaArrayToString(color: number[]): string {
        if (!color || color.length < 3) {
            return 'rgba(0, 0, 0, 1)';
        }
        const [r, g, b, a = 255] = color;
        return `rgba(${r}, ${g}, ${b}, ${a / 255})`;
    }

    private getLineDashPattern(style: string): number[] | undefined {
        switch (style) {
            case ESRI_LINE_STYLES.DASH:
                return [10, 10];
            case ESRI_LINE_STYLES.DOT:
                return [2, 6];
            case ESRI_LINE_STYLES.DASH_DOT:
                return [10, 6, 2, 6];
            case ESRI_LINE_STYLES.DASH_DOT_DOT:
                return [10, 6, 2, 6, 2, 6];
            default:
                return undefined;
        }
    }

    private determineLabelField(drawingInfo: ArcGISDrawingInfo | null): string | null {
        if (!drawingInfo?.labelingInfo?.length) {
            return null;
        }

        const labelInfo = drawingInfo.labelingInfo[0];

        if (labelInfo.labelExpressionInfo?.expression) {
            const arcadeMatch = labelInfo.labelExpressionInfo.expression.match(
                /\$feature\.(\w+)|\$feature\["([^"]+)"\]/
            );
            if (arcadeMatch) {
                return arcadeMatch[1] || arcadeMatch[2];
            }
        }

        if (labelInfo.labelExpression) {
            const bracketMatch = labelInfo.labelExpression.match(/\[([^\]]+)\]/);
            if (bracketMatch) {
                return bracketMatch[1];
            }
        }

        return null;
    }

    private determineServerShowLabels(drawingInfo: ArcGISDrawingInfo | null): boolean {
        if (!drawingInfo) {
            return false;
        }
        if (typeof drawingInfo.showLabels === 'boolean') {
            return drawingInfo.showLabels;
        }
        return Array.isArray(drawingInfo.labelingInfo) && drawingInfo.labelingInfo.length > 0;
    }

    private createLabelStyle(feature: Feature, labelField: string, geometryType?: string): Style | null {
        const labelText = feature.get(labelField);
        if (labelText === null || labelText === undefined) {
            return null;
        }

        const isPolyline = geometryType === ESRI_GEOMETRY_TYPES.POLYLINE;

        return new Style({
            text: new Text({
                text: String(labelText),
                font: '10px Arial, sans-serif',
                fill: new Fill({ color: '#000000' }),
                overflow: true,
                ...(isPolyline
                    ? { placement: 'line' as const, maxAngle: Math.PI / 4, offsetY: -10, textBaseline: 'bottom' as const }
                    : { offsetY: -15, textAlign: 'center' as const })
            })
        });
    }

    private populateArcGISLegendInfo(renderer: ArcGISRenderer | null): LegendInfo[] {
        const legendInfo: LegendInfo[] = [];

        if (!renderer) {
            return legendInfo;
        }

        switch (renderer.type) {
            case ESRI_RENDERER_TYPES.SIMPLE:
                if (renderer.symbol) {
                    legendInfo.push(this.createLegendFromSymbol(renderer.symbol, ''));
                }
                break;

            case ESRI_RENDERER_TYPES.UNIQUE_VALUE:
                renderer.uniqueValueInfos?.forEach(info => {
                    legendInfo.push(this.createLegendFromSymbol(info.symbol, info.label || String(info.value)));
                });
                if (renderer.defaultSymbol) {
                    legendInfo.push(this.createLegendFromSymbol(renderer.defaultSymbol, renderer.defaultLabel || 'Other'));
                }
                break;

            case ESRI_RENDERER_TYPES.CLASS_BREAKS:
                renderer.classBreakInfos?.forEach(info => {
                    const label = info.label || `${info.classMinValue ?? info.minValue} - ${info.classMaxValue ?? info.maxValue}`;
                    legendInfo.push(this.createLegendFromSymbol(info.symbol, label));
                });
                break;
        }

        return legendInfo;
    }

    private createLegendFromSymbol(symbol: ArcGISSymbol, label: string): LegendInfo {
        if (symbol.type === ESRI_SYMBOL_TYPES.PICTURE_MARKER && symbol.imageData) {
            return {
                label: label,
                url: `data:${symbol.contentType || 'image/png'};base64,${symbol.imageData}`,
                color: null,
                borderColor: null,
                type: LegendType.CIRCLE,
                height: `${symbol.height || 20}px`
            };
        }

        if (symbol.type === ESRI_SYMBOL_TYPES.SIMPLE_MARKER) {
            return {
                label: label,
                url: null,
                color: symbol.color ? this.rgbaArrayToString(symbol.color) : null,
                borderColor: null,
                type: LegendType.CIRCLE,
                height: null
            };
        }

        if (symbol.type === ESRI_SYMBOL_TYPES.SIMPLE_LINE || symbol.type === ESRI_SYMBOL_TYPES.CARTOGRAPHIC_LINE) {
            return {
                label: label,
                url: null,
                color: symbol.color ? this.rgbaArrayToString(symbol.color) : null,
                borderColor: null,
                type: LegendType.LINE,
                height: null
            };
        }

        if (symbol.type === ESRI_SYMBOL_TYPES.SIMPLE_FILL || symbol.type === ESRI_SYMBOL_TYPES.PICTURE_FILL) {
            const fillColor = symbol.color ? this.rgbaArrayToString(symbol.color) : null;
            const outlineColor = symbol.outline?.color ? this.rgbaArrayToString(symbol.outline.color) : null;
            return {
                label: label,
                url: null,
                color: fillColor,
                borderColor: outlineColor,
                type: LegendType.AREA,
                height: null
            };
        }

        return {
            label: label,
            url: null,
            color: 'rgba(0, 0, 0, 1)',
            borderColor: null,
            type: LegendType.CIRCLE,
            height: null
        };
    }

    private createHeatmapRenderer(renderer: ArcGISRenderer): Heatmap {
        const defaultGradient = ['#00f', '#0ff', '#0f0', '#ff0', '#f00'];
        let gradient = defaultGradient;

        if (renderer.colorStops && renderer.colorStops.length > 0) {
            gradient = renderer.colorStops
                .sort((a, b) => a.ratio - b.ratio)
                .map(stop => this.rgbaArrayToString(stop.color));
        }

        return new Heatmap({
            blur: renderer.blurRadius || 15,
            radius: renderer.radius || 10,
            weight: renderer.field || 'weight',
            gradient: gradient
        });
    }

    private createDotDensityRenderer(renderer: ArcGISRenderer): StyleFunction {
        return (feature: Feature) => {
            if (feature.getGeometry()?.getType() !== 'Polygon') {
                return null;
            }

            const styles = [];
            const dotValue = renderer.dotValue || 1;
            const dotSize = renderer.dotSize || 2;

            (renderer.attributes || []).forEach(attr => {
                const value = feature.get(attr.field);
                const dotCount = Math.floor(value / dotValue);
                const color = this.rgbaArrayToString(attr.color || [255, 0, 0, 1]);

                for (let i = 0; i < Math.min(dotCount, 100); i++) {
                    styles.push(new Style({
                        image: new StyleCircle({
                            radius: dotSize,
                            fill: new Fill({ color })
                        })
                    }));
                }
            });

            return styles;
        };
    }

    private applyProportionalSymbols(feature: Feature, sizeInfo: ArcGISVisualVariable, baseSymbol: ArcGISSymbol): Style | Style[] {
        const value = feature.get(sizeInfo.field);
        const minValue = sizeInfo.minDataValue;
        const maxValue = sizeInfo.maxDataValue;
        const minSize = sizeInfo.minSize;
        const maxSize = sizeInfo.maxSize;

        const ratio = (value - minValue) / (maxValue - minValue);
        const size = minSize + (ratio * (maxSize - minSize));

        if (baseSymbol.type === ESRI_SYMBOL_TYPES.SIMPLE_MARKER) {
            return new Style({
                image: new StyleCircle({
                    radius: size / 2,
                    fill: new Fill({
                        color: this.rgbaArrayToString(baseSymbol.color)
                    }),
                    stroke: baseSymbol.outline ? new Stroke({
                        color: this.rgbaArrayToString(baseSymbol.outline.color),
                        width: baseSymbol.outline.width
                    }) : undefined
                })
            });
        }

        const baseStyle = this.convertSymbolToOLStyle(baseSymbol);
        if (Array.isArray(baseStyle)) {
            baseStyle.forEach(style => {
                const image = style.getImage();
                if (image && image instanceof StyleCircle) {
                    image.setRadius(size / 2);
                }
            });
            return baseStyle;
        }

        const image = baseStyle.getImage();
        if (image && image instanceof StyleCircle) {
            image.setRadius(size / 2);
        }

        return baseStyle;
    }

    private createMultilayerSymbol(symbolLayers: CIMSymbolLayer[]): Style[] {
        const styles = [];

        symbolLayers.forEach((layer, index) => {
            const zIndex = index;

            if (layer.type === 'CIMSolidStroke' || layer.type === 'CIMSolidFill') {
                const style = this.convertCIMLayerToStyle(layer);
                if (style) {
                    style.setZIndex(zIndex);
                    styles.push(style);
                }
            }
        });

        return styles;
    }

    private convertCIMLayerToStyle(layer: CIMSymbolLayer): Style | null {
        if (layer.type === 'CIMSolidStroke') {
            const capStyle = (layer['capStyle'] as CanvasLineCap) || 'round';
            const joinStyle = (layer['joinStyle'] as CanvasLineJoin) || 'round';

            return new Style({
                stroke: new Stroke({
                    color: this.rgbaArrayToString(layer.color || [0, 0, 0, 255]),
                    width: layer.width || 1,
                    lineCap: capStyle,
                    lineJoin: joinStyle
                })
            });
        }

        if (layer.type === 'CIMSolidFill') {
            return new Style({
                fill: new Fill({
                    color: this.rgbaArrayToString(layer.color || [128, 128, 128, 255])
                })
            });
        }

        return null;
    }

    private convertSymbolToOLStyle(symbol: ArcGISSymbol): Style | Style[] {
        if (!symbol) {
            return this.getArcGISLayerStyle('default');
        }


        // CIM Symbol (multilayer)
        if (symbol.type === 'CIMSymbolReference' || (symbol.data as CIMSymbolReference)?.type === 'CIMSymbolReference') {
            const symbolData = (symbol.data as CIMSymbolReference) || symbol;
            if (symbolData.symbol?.symbolLayers) {
                return this.createMultilayerSymbol(symbolData.symbol.symbolLayers);
            }
        }

        if (symbol.type === ESRI_SYMBOL_TYPES.PICTURE_MARKER) {
            const iconConfig = {
                src: `data:${symbol.contentType || 'image/png'};base64,${symbol.imageData}`,
                scale: 1.0,
                anchor: [0.5, 0.5],
                anchorXUnits: IconAnchorUnits.FRACTION,
                anchorYUnits: IconAnchorUnits.FRACTION
            };

            if (symbol.url && symbol.url.startsWith('http') && symbol.width && symbol.height) {
                iconConfig.src = symbol.url;
                iconConfig.scale = Math.min(symbol.width, symbol.height) / 64;

                const style = new Style({
                    image: new Icon(iconConfig)
                });

                const img = new Image();
                img.crossOrigin = 'anonymous';
                img.onload = () => {
                    try {
                        const icon = style.getImage();
                        if (icon && img.naturalWidth && img.naturalHeight) {
                            const scaleX = symbol.width / img.naturalWidth;
                            const scaleY = symbol.height / img.naturalHeight;
                            const calculatedScale = Math.min(scaleX, scaleY);
                            icon.setScale(calculatedScale);
                        }
                    } catch (e) {
                    }
                };
                img.onerror = () => {
                };
                img.src = symbol.url;

                return style;
            }

            return new Style({
                image: new Icon(iconConfig)
            });
        }

        if (symbol.type === ESRI_SYMBOL_TYPES.SIMPLE_MARKER) {
            const color = this.rgbaArrayToString(symbol.color);
            const outlineColor = symbol.outline
                ? this.rgbaArrayToString(symbol.outline.color)
                : 'rgba(0, 0, 0, 1)';

            switch (symbol.style) {
                case ESRI_MARKER_STYLES.CIRCLE:
                    return new Style({
                        image: new StyleCircle({
                            radius: (symbol.size || 8) / 2,
                            fill: new Fill({ color }),
                            stroke: new Stroke({
                                color: outlineColor,
                                width: symbol.outline?.width || 1
                            })
                        })
                    });

                case ESRI_MARKER_STYLES.SQUARE:
                    return new Style({
                        image: new RegularShape({
                            points: 4,
                            radius: (symbol.size || 8) / 2,
                            angle: Math.PI / 4,
                            fill: new Fill({ color }),
                            stroke: new Stroke({
                                color: outlineColor,
                                width: symbol.outline?.width || 1
                            })
                        })
                    });

                case ESRI_MARKER_STYLES.DIAMOND:
                    return new Style({
                        image: new RegularShape({
                            points: 4,
                            radius: (symbol.size || 8) / 2,
                            fill: new Fill({ color }),
                            stroke: new Stroke({
                                color: outlineColor,
                                width: symbol.outline?.width || 1
                            })
                        })
                    });

                case ESRI_MARKER_STYLES.CROSS:
                    return new Style({
                        image: new RegularShape({
                            points: 4,
                            radius: (symbol.size || 8) / 2,
                            radius2: 0,
                            angle: 0,
                            stroke: new Stroke({
                                color: color,
                                width: 2
                            })
                        })
                    });

                default:
                    return new Style({
                        image: new StyleCircle({
                            radius: (symbol.size || 8) / 2,
                            fill: new Fill({ color }),
                            stroke: new Stroke({
                                color: outlineColor,
                                width: symbol.outline?.width || 1
                            })
                        })
                    });
            }
        }

        if (symbol.type === ESRI_SYMBOL_TYPES.SIMPLE_LINE) {
            const color = this.rgbaArrayToString(symbol.color);
            const lineStyle = new Style({
                stroke: new Stroke({
                    color: color,
                    width: symbol.width || 2,
                    lineDash: this.getLineDashPattern(symbol.style),
                    lineCap: (symbol.cap || 'round') as CanvasLineCap,
                    lineJoin: (symbol.join || 'round') as CanvasLineJoin
                })
            });

            if (symbol.marker && symbol.marker.style === 'arrow') {
                this.arrowMarkers.set(lineStyle, {
                    style: 'arrow',
                    placement: symbol.marker.placement || 'end',
                    color: symbol.marker.color ? this.rgbaArrayToString(symbol.marker.color) : color,
                    size: symbol.marker.size || (symbol.width || 2) * 5
                });
            }

            return lineStyle;
        }

        if (symbol.type === ESRI_SYMBOL_TYPES.CARTOGRAPHIC_LINE) {
            const color = this.rgbaArrayToString(symbol.color);
            return new Style({
                stroke: new Stroke({
                    color: color,
                    width: symbol.width || 1,
                    lineCap: (symbol.cap || 'round') as CanvasLineCap,
                    lineJoin: (symbol.join || 'round') as CanvasLineJoin,
                    miterLimit: symbol.miterLimit || 10,
                    lineDash: this.getLineDashPattern(symbol.style)
                })
            });
        }

        if (symbol.type === ESRI_SYMBOL_TYPES.SIMPLE_FILL) {
            const fillStyle = symbol.style || ESRI_FILL_STYLES.SOLID;
            const isNullFill = fillStyle === ESRI_FILL_STYLES.NULL || fillStyle === ESRI_FILL_STYLES.HOLLOW;

            const fillColor = isNullFill
                ? undefined
                : (symbol.color ? this.rgbaArrayToString(symbol.color) : 'rgba(0, 0, 0, 0.25)');

            const outlineStroke = symbol.outline ? new Stroke({
                color: symbol.outline.color
                    ? this.rgbaArrayToString(symbol.outline.color)
                    : 'rgba(0, 0, 0, 1)',
                width: symbol.outline.width ?? 1,
                lineDash: this.getLineDashPattern(symbol.outline.style)
            }) : undefined;

            return new Style({
                fill: fillColor ? new Fill({ color: fillColor }) : undefined,
                stroke: outlineStroke
            });
        }

        if (symbol.type === ESRI_SYMBOL_TYPES.PICTURE_FILL) {
            const outlineStroke = symbol.outline ? new Stroke({
                color: symbol.outline.color
                    ? this.rgbaArrayToString(symbol.outline.color)
                    : 'rgba(0, 0, 0, 1)',
                width: symbol.outline.width ?? 1,
                lineDash: this.getLineDashPattern(symbol.outline.style)
            }) : undefined;

            const fallbackFillColor = 'rgba(128, 128, 128, 0.3)';

            return new Style({
                fill: new Fill({ color: fallbackFillColor }),
                stroke: outlineStroke
            });
        }

        return new Style({
            fill: new Fill({ color: 'rgba(128, 128, 128, 0.3)' }),
            stroke: new Stroke({ color: 'rgba(0, 0, 0, 0.8)', width: 1 })
        });
    }

    private createArrowStyleAtEnd(feature: Feature, lineStyle: Style): Style[] | null {
        const geometry = feature.getGeometry();

        if (geometry?.getType() !== 'LineString' && geometry?.getType() !== 'MultiLineString') {
            return null;
        }

        const arrowMarker = this.arrowMarkers.get(lineStyle);
        if (!arrowMarker) {
            return null;
        }

        const lineString = geometry as LineString;
        const coords = lineString.getCoordinates();

        if (coords.length < 2) return null;

        let MAP_MAX_SCALE_PLUS_ONE = 20;
        const mapScale = this.olMap.getView().getZoom();

        if (mapScale + 1 > MAP_MAX_SCALE_PLUS_ONE) {
            MAP_MAX_SCALE_PLUS_ONE = mapScale + 1;
        }

        let scale = MAP_MAX_SCALE_PLUS_ONE - mapScale;
        scale = Math.min(10, scale);

        const arrowWings = 2 * scale;
        const arrowMultiplier = 1 + (scale / MAP_MAX_SCALE_PLUS_ONE);
        const arrowDivider = Math.max(1, 2 - (scale / MAP_MAX_SCALE_PLUS_ONE));

        const start = coords[coords.length - 2];
        const end = coords[coords.length - 1];

        const dx = end[0] - start[0];
        const dy = end[1] - start[1];
        const rotation = Math.atan2(dy, dx);

        let d = Math.abs(dx) + Math.abs(dy);
        if (d > 15) d = d / 10; else d = 2;

        const sx = end[0] - dx / d;
        const sy = end[1] - dy / d;
        const p = [sx, sy];

        const lineStr1 = new LineString([
            p,
            [p[0] - arrowWings * arrowMultiplier, p[1] + arrowWings / arrowDivider]
        ]);
        lineStr1.rotate(rotation, p);

        const lineStr2 = new LineString([
            p,
            [p[0] - arrowWings * arrowMultiplier, p[1] - arrowWings / arrowDivider]
        ]);
        lineStr2.rotate(rotation, p);

        const strokeWidth = arrowMarker.size ? arrowMarker.size / 2 : 3;
        const stroke = new Stroke({
            color: arrowMarker.color,
            width: strokeWidth
        });

        return [
            new Style({
                geometry: lineStr1,
                stroke: stroke
            }),
            new Style({
                geometry: lineStr2,
                stroke: stroke
            })
        ];
    }

    private applyStylesToFeatures(features: Feature[], renderer: ArcGISRenderer): void {
        features.forEach(feature => {
            const baseStyles = this.applyRendererToFeature(feature, renderer);
            const styles = Array.isArray(baseStyles) ? baseStyles : [baseStyles];

            const arrowStyles = this.createArrowStyleAtEnd(feature, styles[0]);
            if (arrowStyles) {
                styles.push(...arrowStyles);
            }

            feature.setStyle(styles);
        });
    }

    private createCachedStyleFunction(
        renderer: ArcGISRenderer | null,
        geometryType: string,
        layerCacheKey: string,
        labelConfig?: { showLabels: boolean; labelField: string | null; labelMinScale: number; labelMaxScale: number }
    ): (feature: Feature, resolution: number) => Style | Style[] {
        if (!this.arcgisLayerStyleCache.has(layerCacheKey)) {
            this.arcgisLayerStyleCache.set(layerCacheKey, new Map());
        }
        const styleCache = this.arcgisLayerStyleCache.get(layerCacheKey)!;

        const addLabelStyle = (feature: Feature, styles: Style[], resolution: number): Style[] => {
            if (labelConfig?.showLabels && labelConfig?.labelField) {
                if (labelConfig.labelMinScale) {
                    const maxResolution = labelConfig.labelMinScale / (ESRI_INCHES_PER_METER * ESRI_DOTS_PER_INCH);
                    if (resolution > maxResolution) {
                        return styles;
                    }
                }
                if (labelConfig.labelMaxScale) {
                    const minResolution = labelConfig.labelMaxScale / (ESRI_INCHES_PER_METER * ESRI_DOTS_PER_INCH);
                    if (resolution < minResolution) {
                        return styles;
                    }
                }
                const labelStyle = this.createLabelStyle(feature, labelConfig.labelField, geometryType);
                if (labelStyle) {
                    return [...styles, labelStyle];
                }
            }
            return styles;
        };

        if (!renderer) {
            const defaultCacheKey = ARCGIS_CONSTANTS.STYLE_CACHE_KEYS.DEFAULT;
            if (!styleCache.has(defaultCacheKey)) {
                styleCache.set(defaultCacheKey, this.getArcGISLayerStyle(geometryType));
            }
            const defaultStyle = styleCache.get(defaultCacheKey)!;
            return (feature: Feature, resolution: number) => {
                const baseStyles = Array.isArray(defaultStyle) ? [...defaultStyle] : [defaultStyle];
                return addLabelStyle(feature, baseStyles, resolution);
            };
        }

        if (renderer.type === ESRI_RENDERER_TYPES.SIMPLE) {
            const simpleCacheKey = ARCGIS_CONSTANTS.STYLE_CACHE_KEYS.SIMPLE;
            if (!styleCache.has(simpleCacheKey)) {
                const style = renderer.symbol
                    ? this.convertSymbolToOLStyle(renderer.symbol)
                    : this.getArcGISLayerStyle(geometryType);
                styleCache.set(simpleCacheKey, style);
            }
            const cachedBaseStyle = styleCache.get(simpleCacheKey)!;

            return (feature: Feature, resolution: number) => {
                const baseStyles = Array.isArray(cachedBaseStyle) ? [...cachedBaseStyle] : [cachedBaseStyle];
                const arrowStyles = this.createArrowStyleAtEnd(feature, baseStyles[0]);
                if (arrowStyles) {
                    baseStyles.push(...arrowStyles);
                }
                return addLabelStyle(feature, baseStyles, resolution);
            };
        }

        if (renderer.type === ESRI_RENDERER_TYPES.UNIQUE_VALUE) {
            const field = renderer.field1 || renderer.field;

            return (feature: Feature, resolution: number) => {
                const value = feature.get(field) as string | number | null;
                const cacheKey = ARCGIS_CONSTANTS.STYLE_CACHE_KEYS.UNIQUE_VALUE_PREFIX + String(value);

                if (!styleCache.has(cacheKey)) {
                    const uniqueValueInfo = renderer.uniqueValueInfos?.find((info: ArcGISUniqueValueInfo) =>
                        info.value === value || info.value == value
                    );
                    const symbol = uniqueValueInfo?.symbol || renderer.defaultSymbol;
                    const style = symbol
                        ? this.convertSymbolToOLStyle(symbol)
                        : this.getArcGISLayerStyle(geometryType);
                    styleCache.set(cacheKey, style);
                }

                const cachedBaseStyle = styleCache.get(cacheKey)!;
                const baseStyles = Array.isArray(cachedBaseStyle) ? [...cachedBaseStyle] : [cachedBaseStyle];
                const arrowStyles = this.createArrowStyleAtEnd(feature, baseStyles[0]);
                if (arrowStyles) {
                    baseStyles.push(...arrowStyles);
                }
                return addLabelStyle(feature, baseStyles, resolution);
            };
        }

        if (renderer.type === ESRI_RENDERER_TYPES.CLASS_BREAKS) {
            const field = renderer.field;

            return (feature: Feature, resolution: number) => {
                const fieldValue = parseFloat(feature.get(field) as string);
                const classBreakInfo = renderer.classBreakInfos?.find((info: ArcGISClassBreakInfo) =>
                    fieldValue >= (info.classMinValue ?? -Infinity) &&
                    fieldValue < (info.classMaxValue ?? Infinity)
                );

                const cacheKey = classBreakInfo
                    ? ARCGIS_CONSTANTS.STYLE_CACHE_KEYS.CLASS_BREAKS_PREFIX + String(classBreakInfo.classMinValue) + '_' + String(classBreakInfo.classMaxValue)
                    : ARCGIS_CONSTANTS.STYLE_CACHE_KEYS.CLASS_BREAKS_DEFAULT;

                if (!styleCache.has(cacheKey)) {
                    const symbol = classBreakInfo?.symbol || renderer.defaultSymbol;
                    const style = symbol
                        ? this.convertSymbolToOLStyle(symbol)
                        : this.getArcGISLayerStyle(geometryType);
                    styleCache.set(cacheKey, style);
                }

                const cachedBaseStyle = styleCache.get(cacheKey)!;
                const baseStyles = Array.isArray(cachedBaseStyle) ? [...cachedBaseStyle] : [cachedBaseStyle];
                const arrowStyles = this.createArrowStyleAtEnd(feature, baseStyles[0]);
                if (arrowStyles) {
                    baseStyles.push(...arrowStyles);
                }
                return addLabelStyle(feature, baseStyles, resolution);
            };
        }

        const fallbackCacheKey = ARCGIS_CONSTANTS.STYLE_CACHE_KEYS.FALLBACK;
        if (!styleCache.has(fallbackCacheKey)) {
            styleCache.set(fallbackCacheKey, this.getArcGISLayerStyle(geometryType));
        }
        const fallbackStyle = styleCache.get(fallbackCacheKey)!;
        return (feature: Feature, resolution: number) => {
            const baseStyles = Array.isArray(fallbackStyle) ? [...fallbackStyle] : [fallbackStyle];
            return addLabelStyle(feature, baseStyles, resolution);
        };
    }

    private clearLayerStyleCache(layerCacheKey: string): void {
        this.arcgisLayerStyleCache.delete(layerCacheKey);
    }

    private convertArcGISRendererToOLStyle(drawingInfo: ArcGISDrawingInfo, geometryType: string): RendererResult {
        if (!drawingInfo || !drawingInfo.renderer) {
            return { type: 'style', style: this.getArcGISLayerStyle(geometryType) };
        }

        const renderer = drawingInfo.renderer;
        const visualVariables = (('visualVariables' in renderer ? renderer.visualVariables : undefined) || ('visualVariables' in drawingInfo ? drawingInfo.visualVariables : undefined)) as ArcGISVisualVariable[] | undefined;

        if (renderer.type === 'simple') {
            const baseStyle = this.convertSymbolToOLStyle(renderer.symbol);

            if (visualVariables && visualVariables.length > 0) {
                const sizeInfo = visualVariables.find(v => v.type === 'sizeInfo');
                if (sizeInfo) {
                    return { type: 'style', style: (feature: Feature) => this.applyProportionalSymbols(feature, sizeInfo, renderer.symbol) };
                }
            }

            return { type: 'style', style: baseStyle };
        }

        if (renderer.type === 'uniqueValue') {
            return {
                type: 'style',
                style: (feature: Feature) => {
                    const value = feature.get(renderer.field1);
                    const info = renderer.uniqueValueInfos?.find((uvi) => uvi.value === value);
                    if (info && info.symbol) {
                        return this.convertSymbolToOLStyle(info.symbol);
                    }
                    return this.convertSymbolToOLStyle(renderer.defaultSymbol);
                }
            };
        }

        if (renderer.type === 'classBreaks') {
            return {
                type: 'style',
                style: (feature: Feature) => {
                    const value = feature.get(renderer.field);
                    const classBreakInfo = renderer.classBreakInfos?.find((cbi: ArcGISClassBreakInfo) => {
                        return value >= cbi.classMinValue && value <= cbi.classMaxValue;
                    });
                    if (classBreakInfo && classBreakInfo.symbol) {
                        return this.convertSymbolToOLStyle(classBreakInfo.symbol);
                    }
                    return this.convertSymbolToOLStyle(renderer.defaultSymbol);
                }
            };
        }

        if (renderer.type === 'heatmap') {
            return { type: 'heatmap', layer: this.createHeatmapRenderer(renderer) };
        }

        if (renderer.type === 'dotDensity') {
            return { type: 'style', style: this.createDotDensityRenderer(renderer) };
        }

        return { type: 'style', style: this.getArcGISLayerStyle(geometryType) };
    }

    public async changeShownAssetLayer(layerId: string) {
        const selectedLayerId = parseInt(layerId);
        this.activeAssetLayerId = selectedLayerId;
        
        this.arcgisAssetLayers.forEach((layer, id) => {
            if (id !== selectedLayerId) {
                this.olMap.removeLayer(layer);
                const layerIndex = this.mapLayerLists.findIndex(m => m.name === `${LayerNameOpts.arcgisAssets}_${id}`);
                if (layerIndex > -1) {
                    this.mapLayerLists.splice(layerIndex, 1);
                }
            }
        });
        
        const selectedLayer = this.arcgisFeatureLayers.find(layer => layer.id.toString() === selectedLayerId.toString());
        
        if (selectedLayer) {
            if (this.arcgisAssetLayers.has(selectedLayerId)) {
                const existingLayer = this.arcgisAssetLayers.get(selectedLayerId);
                existingLayer.setVisible(true);
                return;
            }
            
            try {
                const allFeatures = await this.arcgisLayerCache.getFeatures(
                    selectedLayer.serviceUrl,
                    parseInt(selectedLayer.id)
                );

                if (!allFeatures || allFeatures.length === 0) {
                    this.snackBar.open('No features found in this layer', 'Close', {
                        duration: 3000
                    });
                    return;
                }

                const data = {
                    features: allFeatures,
                    spatialReference: allFeatures[0]?.geometry?.spatialReference
                };

                if (data.spatialReference) {
                }
                
                let dataProjection = 'EPSG:4326'; // Default to WGS84
                
                if (data.spatialReference?.wkid === 102100 || data.spatialReference?.wkid === 3857) {
                    dataProjection = 'EPSG:3857'; // Web Mercator
                } else if (data.spatialReference?.wkid === 4326) {
                    dataProjection = 'EPSG:4326'; // WGS84
                } else if (data.spatialReference?.wkid) {
                    dataProjection = `EPSG:${data.spatialReference.wkid}`;
                } else if (data.features && data.features.length > 0 && data.features[0].geometry) {
                    // Fallback: check coordinate values to guess projection
                    const firstGeom = data.features[0].geometry;
                    if (firstGeom.x !== undefined && firstGeom.y !== undefined) {
                        // Point geometry
                        if (Math.abs(firstGeom.x) > 180 || Math.abs(firstGeom.y) > 90) {
                            dataProjection = 'EPSG:3857'; // Likely Web Mercator
                        }
                    } else if (firstGeom.rings || firstGeom.paths) {
                        // Polygon or polyline
                        const coords = firstGeom.rings?.[0]?.[0] || firstGeom.paths?.[0]?.[0];
                        if (coords && (Math.abs(coords[0]) > 180 || Math.abs(coords[1]) > 90)) {
                            dataProjection = 'EPSG:3857'; // Likely Web Mercator
                        }
                    }
                }
                                
                const features = esrijsonFormat.readFeatures(data, {
                    dataProjection: dataProjection,
                    featureProjection: this.olMap.getView().getProjection()
                });

                if (selectedLayer.geometryType) {
                    this.geometryTypesLoaded.add(selectedLayer.geometryType);
                }
                features.forEach(feature => {
                    const geomType = feature.getGeometry()?.getType();
                    if (geomType) {
                        this.geometryTypesLoaded.add(`OL_${geomType}`);
                    }
                });

                const vectorSource = new VectorSource({
                    features: features
                });


                const drawingInfo = await this.arcgisLayerCache.getDrawingInfo(selectedLayer.serviceUrl || selectedLayer.url, parseInt(selectedLayer.id), null);

                const rendererResult = drawingInfo
                    ? this.convertArcGISRendererToOLStyle(drawingInfo, selectedLayer.geometryType || 'esriGeometryPoint')
                    : { type: 'style' as const, style: this.getArcGISLayerStyle(selectedLayer.geometryType || 'esriGeometryPoint') };

                let layerToAdd: VectorLayer | Heatmap;

                if (rendererResult.type === 'heatmap') {
                    const heatmapLayer = rendererResult.layer;
                    heatmapLayer.setSource(vectorSource);
                    heatmapLayer.set('name', `${LayerNameOpts.arcgisAssets}_${selectedLayerId}`);
                    heatmapLayer.setVisible(true);
                    heatmapLayer.setZIndex(1000);
                    layerToAdd = heatmapLayer;
                } else {
                    layerToAdd = new VectorLayer({
                        name: `${LayerNameOpts.arcgisAssets}_${selectedLayerId}`,
                        source: vectorSource,
                        style: rendererResult.style,
                        visible: true,
                        zIndex: 1000
                    });
                }

                this.arcgisAssetSources.set(selectedLayerId, vectorSource);
                this.arcgisAssetLayers.set(selectedLayerId, layerToAdd);

                this.olMap.addLayer(layerToAdd);
                
                this.mapLayerLists.push({
                    name: `${LayerNameOpts.arcgisAssets}_${selectedLayerId}`,
                    checked: true,
                    selection: true,
                    showLegend: false,
                    legendInfo: [{
                        label: selectedLayer.name || selectedLayer.title,
                        url: selectedLayer.thumbnail || ''
                    }],
                    opacity: 1,
                    child: []
                });
                
                if (this.layerList) {
                    this.layerList.loaddata(this.mapLayerLists);
                }
                
                
                const extent = vectorSource.getExtent();
                
                if (extent && !isEmpty(extent)) {
                    this.olMap.getView().fit(extent, {
                        padding: [100, 100, 100, 100],
                        duration: 1000
                    });
                }
                
                this.snackBar.open(`Loaded ${features.length} features from ${selectedLayer.name || selectedLayer.title}`, 'Close', {
                    duration: 3000
                });

                this.logGeometryTypeSummary();
                
            } catch (error) {
                this.snackBar.open('Failed to load ArcGIS layer', 'Close', {
                    duration: 3000
                });
            }
        }
    }

    public changeShownBaseMap(newActiveId: string) {
        const newActiveMap = this.baseMapOptions.find((x) => x.baseMapId === newActiveId);
        const newActiveMapName = newActiveMap.name;
        this.activeBaseMapId = newActiveId;
        this.gisUserSetting.baseMapId = newActiveId;

        this.baseLayers.getLayers().forEach((layer) => {
            const layerName = layer.get('name');
            if (layerName === newActiveMapName) {
                layer.setVisible(true);
            } else {
                layer.setVisible(false);
            }
        });

        const dynamicBasemapNames = new Set(
            this.baseMapOptions.filter(v => v.url.includes('token')).map(v => v.name)
        );

        let activeDynamicLayerFound = false;
        const allLayers = [...this.olMap.getLayers().getArray()];
        for (const layer of allLayers) {
            const layerName = layer.get('name');
            if (!layerName) {
                this.olMap.removeLayer(layer);
                continue;
            }
            if (layer instanceof LayerGroup && layer !== this.baseLayers) {
                this.olMap.removeLayer(layer);
                continue;
            }
            if (!dynamicBasemapNames.has(layerName)) {
                continue;
            }
            if (layerName === newActiveMapName) {
                layer.setVisible(true);
                activeDynamicLayerFound = true;
            } else {
                this.olMap.removeLayer(layer);
            }
        }

        if (newActiveMap.url.includes('token') && !activeDynamicLayerFound) {
            this.applyDynamicBasemap(newActiveMap.url, newActiveMap.name);
        }

        this.setMapAttributionText();
        this.saveSubject.next();
        this.generateOverviewMap();
    }
    /*
     * Search Loaction
     */
    public SortByName(x, y) {
        return x.name == y.name ? 0 : x.name > y.name ? 1 : -1;
    }

    // sort search items by type, locations go first, then features
    public sortByType(a, b) {
        if (a.type === 'location') {
            return -1;
        } else if (b.type === 'location') {
            return 1;
        }

        return 0;
    }

    public locationSearchDisplay(obj): string {
        return obj && obj.name.length > 0 ? obj.name : '';
    }

    public loadingLocSearchData(filterValue: string) {
        const locations: MapAutocompleteItem[] = [];
        this.prismLayerList.forEach((layer) => {
            const layerName = layer.name;
            const layers = this.gisService.layerToFeaturesRelation.get(layerName);

            if (layers) {
                const filteredFeatures = Array.from(layers.keys()).filter(v => String(v).toLowerCase().includes(filterValue));
                filteredFeatures.forEach(v => {
                    const searchItem = {
                        name: v,
                        type: MapAutocompleteItemType.feature,
                        layerName,
                        feat: layers.get(v),
                        unchecked: !layer.checked
                    };

                    locations.push(searchItem);
                });
            }
        });

        if (this.AdsMonitorLayerSource) {
            const monitorLayer = this.mapLayerLists.find(v => v.name === MONITOR_LAYER_NAME);
            const isMonitorLayerSelected = monitorLayer && monitorLayer.checked;

            const monitorFeature = this.AdsMonitorLayerSource.getFeatures();
            if (monitorFeature.length > 0) {
                monitorFeature.forEach((feat) => {
                    const prop = feat.getProperties();
                    if (prop.Name.toLowerCase().includes(filterValue) && prop.CustomerID === this.customerID) {
                        locations.push({
                            name: prop.Name,
                            id: prop.LocationID,
                            feat: feat,
                            type: MapAutocompleteItemType.location,
                            layerName: LayerNameOpts.monitor,
                            unchecked: !isMonitorLayerSelected
                        });
                    }
                });
            }
        }

        locations.sort(this.SortByName);
        locations.sort(this.sortByType);
        return locations;
    }

    public locationFilter(value) {
        // TODO AMP: why is this sometimes an object and sometimes a string?!
        let filteredValue = value;
        if (typeof value === 'object') {
            filteredValue = value.name;
        }

        filteredValue = String(filteredValue).toLowerCase();
        return this.loadingLocSearchData(filteredValue);
    }

    public getLocationSearchobj(obj: { name: string, type: 'location' | 'feature', feat: Feature, layerName?: string }) {
        this.zoomToSelectedFeature([{ ...obj, layername: obj.layerName, feature: obj.feat }]);
        this.clearSelection();

        if (obj.type === 'location') {
            this.featSelList.feat_database.feat_dataChange.pipe(skip(1), debounceTime(1000), first()).subscribe((data) => {
                const node = data.find((v) => v.item === LayerNameOpts.monitor).children[0];

                if (!node) return;

                this.featSelList.nodeClick(node, 0);
                const treeNode = this.featSelList.feat_treeControl.dataNodes.find(
                    (v) => v.item === LayerNameOpts.monitor && v.level === 0,
                );
                this.featSelList.feat_treeControl.expand(treeNode);
            });

            this.addingToSelection(obj.feat, LayerNameOpts.monitor);
        } else {
            this.addingToSelection(obj.feat, obj.layerName);
        }
        this.activeLayersTab = 2;
        this.domOperationUtilsService.selectedGisTab.next(this.activeLayersTab);
        this.featSelList.feat_loaddata(this.selectionListing);
    }

    /*LocationNameDisplay(locationoptions : locationSearchOption){
        return locationoptions && locationoptions.name ? locationoptions.name : '';
    }
    */
    /*
     *Selection
     *Selection /
     */
    clearSelection() {
        this.selectionListing = {};
        if (this.SelectionLayerSource) this.SelectionLayerSource.clear();
        if (this.HighlightLayerSource) this.HighlightLayerSource.clear();
        if (this.featSelList) this.featSelList.feat_loaddata(this.selectionListing);
        this.propertyItemList = [];
        this.activeMonitor = null;
    }

    startsSelection(type: GeometryType) {
        this.clearSelection();
        if (this.selectBoxInteraction) {
            this.olMap.removeInteraction(this.selectBoxInteraction);
        }

        if (this.selectDrawInteraction) {
            this.olMap.removeInteraction(this.selectDrawInteraction);
        }

        if (type === GeometryType.POINT) {
            this.enableSelection = true;
            this.selectBoxInteraction = new DragBox({
                condition: platformModifierKeyOnly,
            });
            this.olMap.addInteraction(this.selectBoxInteraction);
            this.selectBoxInteraction.on('boxend', (e) => {
                this.enableSelection = false;
                const feature = new Feature({
                    geometry: new Polygon(this.selectBoxInteraction.getGeometry().getCoordinates()),
                });
                this.layerFeatureSelection(feature, type);
            });
        } else if (type === GeometryType.POLYGON || type === GeometryType.CIRCLE) {
            //this.selectInteraction  = new Select();

            // Disable double click zoom while drawing
            this.enableSelection = false;
            let dblClickInteraction;
            this.olMap
                .getInteractions()
                .getArray()
                .forEach(function (interaction) {
                    if (interaction instanceof DoubleClickZoom) {
                        dblClickInteraction = interaction;
                    }
                });
            this.olMap.removeInteraction(dblClickInteraction);

            this.selectDrawInteraction = new Draw({
                type: type,
            });
            this.selectDrawInteraction.on('drawend', (e) => {
                this.layerFeatureSelection(e.feature, type);
                // Re-enable double click zoom when drawing is finished
                // use a time out to prevent the double click which ended the drawing from zooming in
                setTimeout(
                    function () {
                        if (dblClickInteraction) { this.olMap.addInteraction(dblClickInteraction); }
                        this.enableSelection = true;
                    }.bind(this),
                    1000,
                );
            });
            this.olMap.addInteraction(this.selectDrawInteraction);
        }
    }

    private getCurrentLayersAtrributes() {
        const currentLayersAtrributes = {};
        for (const item of this.prismLayerList) {
            currentLayersAtrributes[item.name] = item;
        }
        for (const item of this.mapLayerLists) {
            if (item.name) {
                currentLayersAtrributes[item.name] = item;
            }
            if (item.child) {
                for (const child of item.child) {
                    if (child.name) {
                        currentLayersAtrributes[child.name] = child;
                    }
                }
            }
        }
        return currentLayersAtrributes;
    }

    async layerFeatureSelection(selectionarea: Feature<Geometry>, type: GeometryType) {
        const format = new GeoJSON();
        let geojsonCouldBeACircleWhoCaresSelectionArea: GeoJSONFeature<GeoJSONPolygon> | GeoJSONPolygon;
        let geojsonSelectionArea: GeoJSONFeature<GeoJSONPolygon> | GeoJSONPolygon;

        if (type === GeometryType.CIRCLE) {
            const selectionareaGeometry = selectionarea.getGeometry() as GeomCircle;
            const selectionareaGeometryfromCircle = fromCircle(selectionareaGeometry);

            geojsonCouldBeACircleWhoCaresSelectionArea = format.writeGeometryObject(selectionareaGeometryfromCircle) as GeoJSONPolygon;
            geojsonSelectionArea = format.writeGeometryObject(selectionareaGeometryfromCircle) as GeoJSONPolygon;
        } else {
            geojsonCouldBeACircleWhoCaresSelectionArea = format.writeFeatureObject(selectionarea) as GeoJSONFeature<GeoJSONPolygon>;
            geojsonSelectionArea = format.writeFeatureObject(selectionarea) as GeoJSONFeature<GeoJSONPolygon>;
        }

        const extent = turf.bbox(geojsonSelectionArea).join();
        switch (type) {
            case GeometryType.POINT:
                break;
            case GeometryType.POLYGON:
                this.olMap.removeInteraction(this.selectDrawInteraction);
                break;
            case GeometryType.CIRCLE:
                this.olMap.removeInteraction(this.selectDrawInteraction);
                break;
        }

        const currentLayersAtrributes = this.getCurrentLayersAtrributes();

        if (
            currentLayersAtrributes[MONITOR_LAYER_NAME].selection === true &&
            currentLayersAtrributes[MONITOR_LAYER_NAME].checked === true
        ) {
            this.AdsMonitorLayerSource.forEachFeature((feat) => {
                const featParsed = format.writeGeometry(feat.getGeometry());
                const coord = JSON.parse(featParsed).coordinates;

                const containPoint = turf.inside(coord, geojsonCouldBeACircleWhoCaresSelectionArea);
                const layernames = LayerNameOpts.monitor;
                if (containPoint) {
                    this.addingToSelection(feat, layernames);
                }
            });
        }

        this.featSelList.feat_loaddata(this.selectionListing);

        const avoidLayers = ['basemap', 'measurement', 'selectionlayer', 'locations', MONITOR_LAYER_NAME, 'esriTileLayer'];

        const mapLayersArray = this.olMap.getLayers().getArray();
        mapLayersArray.forEach((lyr) => {
            const layername = lyr.get('name');

            if (avoidLayers.includes(layername) === false) {
                if (
                    currentLayersAtrributes[layername] &&
                    currentLayersAtrributes[layername].selection === true &&
                    currentLayersAtrributes[layername].checked === true
                ) {
                    if (!(lyr instanceof VectorLayer || lyr instanceof VectorImageLayer)) {
                        return;
                    }
                    const source = lyr.getSource();
                    if (!(source instanceof VectorSource)) {
                        return;
                    }
                    source.forEachFeature((feat) => {
                        const geoJsonFromFeat = format.writeFeatureObject(feat);
                        const geoJsonFeature = geoJsonFromFeat.geometry;

                        if (geoJsonFeature.type === 'LineString'
                            || geoJsonFeature.type === 'MultiPolygon'
                            || geoJsonFeature.type === 'Polygon') {
                            const selectionareaGeometry = geoJsonFeature;

                            // check line intersection
                            const intersect = turf.lineIntersect(
                                selectionareaGeometry,
                                geojsonCouldBeACircleWhoCaresSelectionArea,
                            );
                            if (intersect.features.length > 0) {
                                this.addingToSelection(feat, layername);
                            } else {
                                // check line contained
                                const featPoint = turf.explode(geoJsonFeature).features[0].geometry;
                                const containPoint = turf.inside(featPoint, geojsonCouldBeACircleWhoCaresSelectionArea);
                                if (containPoint) {
                                    this.addingToSelection(feat, layername);
                                }
                            }
                        } else if (geoJsonFeature.type === 'Point') {
                            const coord = geoJsonFeature.coordinates;
                            const containPoint = turf.inside(coord, geojsonCouldBeACircleWhoCaresSelectionArea);
                            if (containPoint) {
                                this.addingToSelection(feat, layername);
                            }
                        } else {
                            // TODO: We do have more of shapes we eventualy want to handle, they was not implemented so far. If any of them happens, implement them !
                        }
                    });
                    this.featSelList.feat_loaddata(this.selectionListing);
                }
            }
        });

        await this.identifyArcGISImageLayersByArea(selectionarea, type);
        this.featSelList.feat_loaddata(this.selectionListing);
    }

    getWMSFeatureSelection(layer: TileLayer, polygon: GeoJSONFeature<GeoJSONPolygon>, extent: string) {
        const urls = (layer.getSource() as TileWMS).getUrls();
        const param = (layer.getSource() as TileWMS).getParams();
        const url =
            urls[0] +
            '?&INFO_FORMAT=application/json&' +
            'REQUEST=GetFeatureInfo&EXCEPTIONS=application/vnd.ogc.se_xml&SERVICE=WMS&VERSION=1.1.1&BBOX=' +
            extent +
            '&' +
            'LAYERS=' +
            param.LAYERS +
            '&QUERY_LAYERS=' +
            param.LAYERS +
            '&FEATURE_COUNT=100000&X=1&Y=1&CRS=' +
            OLMAPPROJECTION +
            '&STYLES=&WIDTH=1&HEIGHT=1';
        fetch(url, {
            method: 'GET',
            headers: {
                'Content-type': 'application/json',
                Authorization: 'Basic SURFWDprM1IqdjJMeHEjRkQ=',
            },
        })
            .then(function (response) {
                return response.text();
            })
            .then((res) => {
                const response = JSON.parse(res);
                const features = new GeoJSON().readFeatures(response);
                features.forEach((feat) => {
                    const feat1 = new GeoJSON().writeFeatureObject(feat) as GeoJSONFeature<GeoJSONPolygon>;
                    const intersect = turf.intersect(feat1, polygon);

                    if (intersect) {
                        this.addingToSelection(feat, param.LAYERS);
                    }
                });
                this.featSelList.feat_loaddata(this.selectionListing);
            });
    }

    addingToSelection(feat: Feature<Geometry>, layerName: LayerNameOpts | string) {
        if (!feat.set) return;

        const name = this.gisService.getFeatureNameProp(feat);
        feat.set('name', name);
        feat.set('_layername', layerName);
        const forSelection = feat.clone();
        this.SelectionLayerSource.addFeature(forSelection);
        this.highlightFeature(forSelection, layerName, false);
        if (this.selectionListing[layerName]) {
            const markers = this.selectionListing[layerName];
            // This is a patch, there is a bug causing features to be loaded multiple times
            // The real solution is to fix that but for now we just make sure the same
            // feature does not get added more than once to the selection
            // The problem is most likely on the arcgis side, features have no featureId
            // see:  https://github.com/openlayers/openlayers/issues/9819

            for (const item of markers.child) {
                if (item.name === name) {
                    return;
                }
            }
            markers.child.push({
                name: name,
                layername: layerName,
                feature: feat,
                child: [],
            });
        } else {
            this.selectionListing[layerName] = {
                name: layerName,
                layername: null,
                feature: null,
                child: [
                    {
                        name: name,
                        feature: feat,
                        layername: layerName,
                        child: [],
                    },
                ],
            };
        }
    }

    private getSelectableArcGISImageLayerNodes(): Array<{ node: ArcGISTreeNode; layerData: ArcGISLayerData }> {
        const currentLayersAtrributes = this.getCurrentLayersAtrributes();
        const result: Array<{ node: ArcGISTreeNode; layerData: ArcGISLayerData }> = [];

        this.arcgisLayerTreeNodes.forEach((parentNode) => {
            if (!parentNode.child) return;
            parentNode.child.forEach((childNode) => {
                if (childNode.assetType !== 'map-service') return;
                if (!childNode.checked || !childNode.selection) return;

                const layerData = childNode.layerData as ArcGISLayerData;
                if (!layerData?.serviceUrl) return;

                const attrs = currentLayersAtrributes[childNode.name];
                if (!attrs || !attrs.selection || !attrs.checked) return;

                const uniqueLayerKey = this.getUniqueLayerKey(layerData.serviceUrl, layerData.id);
                if (!this.arcgisImageLayers.has(uniqueLayerKey)) return;

                result.push({ node: childNode, layerData });
            });
        });

        return result;
    }

    private buildIdentifyParams(geometry: string, geometryType: string, layerId: number | string): ArcGISIdentifyParams {
        const mapView = this.olMap.getView();
        const mapExtent = mapView.calculateExtent(this.olMap.getSize());
        const mapSize = this.olMap.getSize();

        return {
            geometry: geometry,
            geometryType: geometryType,
            sr: ARCGIS_CONSTANTS.SPATIAL_REFERENCE.WEB_MERCATOR,
            layers: 'all:' + layerId.toString(),
            tolerance: '5',
            mapExtent: mapExtent.join(','),
            imageDisplay: mapSize[0] + ',' + mapSize[1] + ',96',
            returnGeometry: 'true',
            f: ARCGIS_CONSTANTS.FORMAT.JSON
        };
    }

    private convertIdentifyResultToFeature(result: ArcGISIdentifyResult): Feature<Geometry> | null {
        if (!result.geometry) return null;

        const esriFeature: ArcGISFeature = {
            attributes: result.attributes,
            geometry: result.geometry
        };

        return esrijsonFormat.readFeature(esriFeature, {
            featureProjection: 'EPSG:3857'
        }) as Feature<Geometry>;
    }

    private async identifyArcGISImageLayerFeatures(coordinate: number[]): Promise<boolean> {
        const imageLayerNodes = this.getSelectableArcGISImageLayerNodes();
        if (imageLayerNodes.length === 0) return false;

        const pointGeometry = JSON.stringify({ x: coordinate[0], y: coordinate[1] });
        let foundAny = false;

        const identifyPromises = imageLayerNodes.map(({ node, layerData }) => {
            const tokenContext = this.buildTokenContextFromTreeNode(node, layerData.serviceUrl);
            const params = this.buildIdentifyParams(pointGeometry, ESRI_GEOMETRY_TYPES.POINT, layerData.id);

            return this.arcgisLayerCache.identify(layerData.serviceUrl, params, tokenContext)
                .then(results => {
                    for (const result of results) {
                        const feature = this.convertIdentifyResultToFeature(result);
                        if (feature) {
                            this.addingToSelection(feature, node.name);
                            foundAny = true;
                        }
                    }
                })
                .catch(error => {
                    if ((error as DOMException).name !== ARCGIS_CONSTANTS.ABORT_ERROR.NAME) {
                        console.error('Identify failed for ' + node.name, error);
                    }
                });
        });

        await Promise.all(identifyPromises);
        return foundAny;
    }

    private async identifyArcGISImageLayersByArea(selectionarea: Feature<Geometry>, type: GeometryType): Promise<void> {
        const imageLayerNodes = this.getSelectableArcGISImageLayerNodes();
        if (imageLayerNodes.length === 0) return;

        const writeOptions = { dataProjection: 'EPSG:3857', featureProjection: 'EPSG:3857' };
        let esriGeometry: string;
        if (type === GeometryType.CIRCLE) {
            const circleGeom = selectionarea.getGeometry() as GeomCircle;
            const polygonGeom = fromCircle(circleGeom);
            esriGeometry = esrijsonFormat.writeGeometry(polygonGeom, writeOptions);
        } else {
            esriGeometry = esrijsonFormat.writeGeometry(selectionarea.getGeometry(), writeOptions);
        }

        const identifyPromises = imageLayerNodes.map(({ node, layerData }) => {
            const tokenContext = this.buildTokenContextFromTreeNode(node, layerData.serviceUrl);
            const params = this.buildIdentifyParams(esriGeometry, ESRI_GEOMETRY_TYPES.POLYGON, layerData.id);

            return this.arcgisLayerCache.identify(layerData.serviceUrl, params, tokenContext)
                .then(results => {
                    for (const result of results) {
                        const feature = this.convertIdentifyResultToFeature(result);
                        if (feature) {
                            this.addingToSelection(feature, node.name);
                        }
                    }
                })
                .catch(error => {
                    if ((error as DOMException).name !== ARCGIS_CONSTANTS.ABORT_ERROR.NAME) {
                        console.error('Identify by area failed for ' + node.name, error);
                    }
                });
        });

        await Promise.all(identifyPromises);
    }

    private updateSelectedFeatures() {
        if(this.selectionListing[LayerNameOpts.monitor]) {
            const layer = this.selectionListing[LayerNameOpts.monitor];
            for(const layerChild of layer.child) {
                const feature = layerChild.feature;
                // #23626 This being copied somewhere else results in it is not feature anymore.
                // #23626 So now cannot call get() and have to access private API .values_. which is bad
                // #23626 TODO: Define proper model for it and refactor all of the old code
                const lid = (feature as Feature<Geometry> & { values_: Record<string, unknown> }).values_.LocationID;
                const location = this.locations.find(l => l.locationId === lid);

                if(!location) continue;

                const AlarmId = location.alarmingState > 0;
                const AcknowledgedBy = location.alarmingState === 1;
                feature.set('AlarmId', AlarmId);
                feature.set('AcknowledgedBy', AcknowledgedBy);
            }
        }

        this.featSelList.feat_loaddata(this.selectionListing);
    }

    private highlightFeature(feature: Feature<Geometry>, layerName: LayerNameOpts | string, isSelected: boolean) {
        const feat = isSelected ? feature.clone() : feature;
        const type = feat.getGeometry().getType();
        let style: Style | Style[];
        if (layerName === LayerNameOpts.monitor) {
            const labelColor = this.pickMapMonitorColor(feat);
            style = monitorLocation(feat, labelColor, this.gisService.gisUserSettingsSubject$, this.displayMapRains.rains$.getValue(), isSelected ? 'purple' : 'blue');
        } else if (type === 'LineString' || type === 'Point') {
            style = highlightLineOrPoint(feat, this.measurementUnit, isSelected ? 'purple' : 'blue');
        } else if (isSelected) {
            this.HighlightLayerSource.clear();
            return;
        } else {
            return;
        }

        feat.setStyle(style);
        if (isSelected) {
            this.HighlightLayerSource.clear();
            this.HighlightLayerSource.addFeature(feat);
        }
    }

    featureselected(featureclick: featureSelList[]) {
        this.propertyItemList = [];

        if (!featureclick) {
            return;
        }

        const feat = featureclick[0].feature;
        const prop = feat.getProperties();
        let selectedname = feat.get('name');
        if (!selectedname && featureclick && featureclick[0] && featureclick[0].feature) {
            selectedname = featureclick[0].feature.get('Name');
        }
        this.locationId = feat.get('LocationID');
        this.featureclick = featureclick;
        if (this.sidebaropen2) {
            this.activeMonitor = selectedname;
            setTimeout(() => {
                this.gisQuickLook.locationChange(featureclick);
            }, 100);
        }

        const layerName = feat.get('_layername');
        this.highlightFeature(feat, layerName, true);
        this.SelectionLayerSource.forEachFeature((feat) => {
            if (feat.get('name') == selectedname) {
                this.selectInteraction.getFeatures().clear();
                this.selectInteraction.getFeatures().push(feat);
                /*this.selectInteraction.features_ =[feat];
                this.selectInteraction.applySelectedStyle_(feat);*/
            }
        });
        Object.keys(prop).forEach((key) => {
            if (key != 'geometry') {
                this.propertyItemList.push({
                    name: key,
                    value: prop[key],
                });
            }
        });
    }

    private updateMonitorLayerOnEdit() {
        const subs = this.locationService.updateMonitorLayerSource.pipe(skip(1)).subscribe(() => {
            this.monitorFeatureNamesSet = new Set();
            this.AdsMonitorLayerSource.refresh();
        });

        this.subscriptions.push(subs);
    }

    featureLocationEdit(featureEdit: featureSelList) {
        const feat = featureEdit[0].feature;
        const properties = feat.getProperties();
        this.activeMonitor = properties.name;
        this.addEditLocation(true, properties.LocationID, properties.CustomerID, properties.LocationTypeID);
    }

    /*
     * Side bar
     */

    private updateMapSize(): void {
        this.hideMapTooltip();
        // Multiple timeouts to resize right away but catch the correct resize
        // if the rest of the DOM takes a bit to update first
        setTimeout(() => {
            this.olMap.updateSize();
        }, 10);
        setTimeout(() => {
            this.olMap.updateSize();
        }, 500);
        setTimeout(() => {
            this.olMap.updateSize();
        }, 1000);
    }

    public createPrintMap() {
        this.generateImageOfMap().subscribe((resultingMap) => {
            const htmlComponent = <HTMLImageElement>document.getElementById('print-map-dashboard');
            htmlComponent.src = resultingMap.toDataURL();
        })
    }

    public downloadMap() {
        this.generateImageOfMap().subscribe((resultingMap) => {
            const link = <HTMLAnchorElement>document.getElementById('image-download');
            link.href = resultingMap.toDataURL();
            link.click();
        });
    }

    private generateImageOfMap(): Observable<HTMLCanvasElement> {
        const mapSize = this.olMap.getSize();
        const mapCanvas = <HTMLCanvasElement>document.getElementById('imageCanvas');
        const mapContext = mapCanvas.getContext('2d');

        mapCanvas.width = mapSize[0];
        mapCanvas.height = mapSize[1];

        // Draw the map layers first
        Array.prototype.forEach.call(document.querySelectorAll('.ol-layer canvas'), (canvas) => {
            if (canvas.width > 0) {
                const opacity = canvas.parentNode.style.opacity;
                mapContext.globalAlpha = opacity === '' ? 1 : Number(opacity);
                const transform = canvas.style.transform;
                const matrix = transform
                    .match(/^matrix\(([^\(]*)\)$/)[1]
                    .split(',')
                    .map(Number);

                mapContext.save();
                mapContext.setTransform(...matrix);
                mapContext.drawImage(canvas, 0, 0);
                mapContext.restore();
            }
        });

        const scaleBarElement = document.querySelector('#scaleline') as HTMLDivElement;
        const attributionElement = document.querySelector('.map-attribution') as HTMLDivElement;

        const scaleBarCanvasObservable = from(
            html2canvas(scaleBarElement, {
                backgroundColor: null // transparent background
            })
        );

        const attributionCanvasObservable = from(
            html2canvas(attributionElement, {
                backgroundColor: null // transparent background
            })
        );

        return forkJoin([scaleBarCanvasObservable, attributionCanvasObservable]).pipe(
            tap(([scaleCanvas, attributionCanvas]) => {
                const attributionHeight = attributionCanvas.height;
                const scaleHeight = scaleCanvas.height;
                const scaleWidth = scaleCanvas.width;

                // Calculate scaling factor based on the canvas size
                const scalingFactor = Math.min(mapCanvas.width / window.innerWidth, mapCanvas.height / window.innerHeight);

                // Adjust dimensions based on the scaling factor
                const adjustedAttributionHeight = attributionHeight * scalingFactor;
                const adjustedScaleWidth = scaleWidth * scalingFactor;
                const adjustedScaleHeight = scaleHeight * scalingFactor;

                // Calculate relative positions
                const attributionY = mapCanvas.height - adjustedAttributionHeight;
                const scaleX = mapCanvas.width - adjustedScaleWidth - 15;
                const scaleY = attributionY - adjustedScaleHeight - 10;

                // Draw attribution at the bottom with adjusted dimensions
                mapContext.drawImage(attributionCanvas, 0, attributionY, mapCanvas.width, adjustedAttributionHeight);

                // Draw scaleline at the bottom right, above the attribution with adjusted dimensions
                mapContext.drawImage(scaleCanvas, scaleX, scaleY, adjustedScaleWidth, adjustedScaleHeight);
            }),
            map(() => mapCanvas)
        );
    }

    // #23600 updates Any Layer Selected state
    public updateAnyLayerSelectedStatus() {
        this.isAnyLayerSelected = this.mapLayerLists.some(
            x => (x.checked && (!x.child || x.child.length === 0))
                || (x.child.length > 0 && x.child.some(c => c.checked))
        );
    }

    public async layersTabLayerAdjust(layersSelected: mapLayerList[], saveSettings: boolean): Promise<void> {
        const plotPromises: Promise<void>[] = [];
        const plottedLayers: { layerKey: string; opacity: number }[] = [];

        for (const layer of layersSelected) {
            if (layer.isArcGIS) {
                if (layer.child && layer.child.length > 0) {
                    for (const childLayer of layer.child) {
                        if (childLayer.layerData) {
                            const childLayerData = childLayer.layerData as ArcGISLayerData;
                            const layerKey = this.getUniqueLayerKey(childLayerData.serviceUrl, childLayerData.id);
                            if (childLayer.checked) {
                                const childWithAssetType: mapLayerList = { ...childLayer, assetType: layer.assetType };
                                plotPromises.push(this.plotLayerWithTimeSlicing(childWithAssetType));
                                plottedLayers.push({
                                    layerKey: layerKey,
                                    opacity: childLayer.opacity || 0.8
                                });
                            } else {
                                this.removeArcGISLayerFromMap(layerKey);
                                this.updateArcGISLayerProperties(layerKey, childLayer.checked, childLayer.opacity);
                            }
                        }
                    }
                } else if (layer.layerData) {
                    const layerDataCast = layer.layerData as ArcGISLayerData;
                    const layerKey = this.getUniqueLayerKey(layerDataCast.serviceUrl, layerDataCast.id);
                    if (layer.checked) {
                        plotPromises.push(this.plotLayerWithTimeSlicing(layer));
                        plottedLayers.push({
                            layerKey: layerKey,
                            opacity: layer.opacity || 0.8
                        });
                    } else {
                        this.removeArcGISLayerFromMap(layerKey);
                        this.updateArcGISLayerProperties(layerKey, layer.checked, layer.opacity);
                    }
                }
                continue;
            }
        }

        if (plotPromises.length > 0) {
            await Promise.all(plotPromises);

            for (const plottedLayer of plottedLayers) {
                this.updateArcGISLayerProperties(plottedLayer.layerKey, true, plottedLayer.opacity);
            }

            this.ngZone.run(() => {
                this.olMap.render();
                this.cdr.detectChanges();
            });
        }

        const mapLayers = this.olMap.getLayers();
        const nameToLayerMap = new Map<string, BaseLayer>(
            flatMap(
                mapLayers.getArray().map((layer) => {
                    const layerName = layer.get('name');
                    if (layerName === LayerNameOpts.networkMap) {
                        const sublayers = (layer as LayerGroup).getLayers();
                        return sublayers.getArray().map((sub) => [sub.get('name'), sub]);
                    } else if (layerName && layerName.startsWith(LayerNameOpts.arcgisAssets)) {
                        return [[layerName, layer]];
                    } else {
                        return [[layerName, layer]];
                    }
                }),
            ),
        );

        for (const layer of layersSelected) {
            if (layer.isArcGIS) continue;
            const mapLayer = nameToLayerMap.get(layer.name);
            if (mapLayer) {
                mapLayer.setVisible(layer.checked);
                mapLayer.setOpacity(layer.opacity !== null ? layer.opacity : 1);
            }
            const esriLayerId = this.layerNameToEsriLayerId[layer.name];

            if (layer.checked === true) {
                this.checkedLayersList.add(esriLayerId);
            } else {
                this.checkedLayersList.delete(esriLayerId);
            }

            const itmlayer = {
                name: layer.name,
                isSelectable: layer.selection,
                isVisible: layer.checked
            };

            for (const item of this.prismLayerList) {
                if (item.name === layer.name) {
                    item.selection = layer.selection;
                    item.checked = layer.checked;
                    item.opacity = layer.opacity ? layer.opacity : 1;
                    break;
                }
            }

            for (const item of this.mapLayerLists) {
                if (item.name === layer.name) {
                    item.selection = layer.selection;
                    item.checked = layer.checked;
                    item.opacity = layer.opacity ? layer.opacity : 1;
                    break;
                }
            }

            if (saveSettings) {
                // Update the user settings if you're going to save
                const currentCustomer = this.gisUserSetting.customerSettings.find((x) => x.cid === this.customerID);
                const currentIndex = currentCustomer.layers.findIndex((x) => x.name === itmlayer.name);
                if (currentIndex === -1) {
                    currentCustomer.layers.push(itmlayer);
                } else {
                    currentCustomer.layers[currentIndex] = itmlayer;
                }
            }
        }

        this.updateAnyLayerSelectedStatus();

        this.searchControl.setValue(this.searchControl.value, {emitEvent: true});

        if (this.esriTileSource) {
            const filteredLayersList = Array.from(this.checkedLayersList).filter(function (el) {
                return el != null;
            });

            const esriTileSourceParams = this.esriTileSource.getParams();
            if (esriTileSourceParams.LAYERS.startsWith('show:')) {
                esriTileSourceParams.LAYERS = 'show:' + filteredLayersList.toString();
            } else {
                esriTileSourceParams.LAYERS = filteredLayersList.toString();
            }

            this.esriTileSource.updateParams(esriTileSourceParams);

            if (filteredLayersList.length > 0) {
                this.esriTileLayer.setVisible(true);
            } else {
                this.esriTileLayer.setVisible(false);
            }
        }

        if (saveSettings) {
            this.saveSubject.next();
        }

        const hasArcGISLayers = layersSelected.some(layer => layer.isArcGIS);
        if (hasArcGISLayers) {
            this.saveCurrentSelection();
        }
    }

    public updateMap() {
        this.updateLocationsList();
    }

    public addEditLocation(isEditMode = false, locationid: number, customerid: number, locTypeId: number) {
        if (locTypeId === 1) {
            //public addEditLocation(isEditMode = false, locationDetails = {}) {
            // ensure that rain gauge collection is present -locationid -customerid
            combineLatest(
                this.gisService.gisUserSettingsSubject$,
                this.mapService.getMarkerLocationDetails(locationid, customerid),
            )
                .pipe(first())
                .subscribe(
                    ([userSettings, result]) => {
                        if (userSettings) {
                            this.activeBaseMapId = userSettings.baseMapId;
                        }
                        if (result) {
                            this.isLoading = false;
                            this.uiUtilsService.safeChangeDetection(this.cdr);
                            const locationDetails: LocationDetails = {
                                series: result.series,
                                serialNumber: result.serialNumber,
                                status: result.status,
                                modem: result.modem,
                                description: result.description,
                                manholeAddress: result.manholeAddress,
                                coordinate: { latitude: result.latitude, longitude: result.longitude, elevation: 1 },
                                locationID: result.locationID,
                                locationName: result.locationName,
                                assignedRainGaugeLocationId: result.assignedRainGaugeLocationId,
                                installationHeight: result.height,
                                installationWidth: result.width,
                                installationType: result.installationType,
                                installationId: result.installationID,
                                depthUnit: result.depthUnit,
                                flowUnit: result.flowUnit,
                                locationType: result.components ? 3 : 1,
                                components: result.components,
                                installationShape: result.installationShape,
                                ipaddress: result.connectionString,
                                range: result.range,
                                capacity: result.capacity,
                                width: result.width,
                                installationShapeTypeID: result.installationShapeTypeID,
                                manholedepth: result.manholeDepth,
                                length: result.length,
                                breadth: result.breadth,
                                coefficient: result.coefficient,
                                assignedRainGaugeLocationName: result.assignedRainGaugeLocationName,
                                entries: result.entries,
                                lastCollectedDate: '',
                            };

                            this.setupRainGaugeLocations();
                            const dialogOptions: MatDialogConfig = {
                                disableClose: true,
                                data: {
                                    isFromCustomerEditor: false,
                                    rainGaugeLocations: this.allRainLocations,
                                    customerId: this.customerID,
                                    editMode: isEditMode,
                                    locationDetails: locationDetails,
                                    enableSelectOnMap: true
                                },
                                hasBackdrop: false,
                            };

                            if (this.gisService.locationCardPosition) {
                                dialogOptions.position = this.locationCardService.checkLocationCardPosition(true, this.gisService.locationCardPosition);
                            } else if (
                                userSettings &&
                                userSettings.locationPositionX &&
                                userSettings.locationPositionY
                            ) {
                                dialogOptions.position = this.locationCardService.getLocationCardPosition(true, userSettings);
                            }

                            if (this.mapService.addEditLocationDialog) {
                                this.mapService.addEditLocationDialog.close();
                            }

                            this.mapService.addEditLocationDialog = this.dialog.open<LocationCardContainerDialogComponent, LocationCardData>(
                                LocationCardContainerDialogComponent,
                                dialogOptions,
                            );

                            this.mapService.addEditLocationDialog
                                .afterClosed()
                                .pipe(first())
                                .subscribe((result: boolean) => {
                                    this.mapService.addEditLocationDialog = null;
                                    if (result) {
                                        this.getAllLocations();
                                        this.monitorLocationUpdate(false);
                                    }
                                });
                        }
                    },
                    (error) => {
                        this.isLoading = false;
                    },
                );
        } else if (locTypeId === 3) {
            this.customerLocationService.getLocationSummary(this.customerID, this.includeInactiveLocations).subscribe((items: APIDataLocationsGetLocations | null) => {
                let locations = new Array<CustomerLocationDetail>();
                if (items) {
                    locations = items.listCutomerLocations;
                }
                combineLatest(
                    this.gisService.gisUserSettingsSubject$,
                    this.mapService.getMarkerLocationDetails(locationid, this.customerID),
                )
                    .pipe(first())
                    .subscribe(
                        ([userSettings, result]) => {
                            if (result) {
                                this.isLoading = false;
                                this.uiUtilsService.safeChangeDetection(this.cdr);
                                const locationDetails: LocationDetails = {
                                    locationID: result.locationID,
                                    locationName: result.locationName,
                                    description: result.description,
                                    manholeAddress: result.manholeAddress,
                                    coordinate: {
                                        latitude: result.latitude,
                                        longitude: result.longitude,
                                        elevation: 1,
                                    },
                                    status: result.status,
                                    modem: result.modem,
                                    series: result.series,
                                    serialNumber: result.serialNumber,
                                    ipaddress: result.ipaddress,
                                    lastCollectedDate: undefined,
                                    components: result.components,
                                    enableSelectOnMap: true
                                };

                                const data: CompositeLocEditInput = {
                                    customerId: this.customerID,
                                    locationDetails,
                                    locations,
                                    enableSelectOnMap: true,
                                };
                                const dialogOptions: MatDialogConfig<CompositeLocComponentInput> = {
                                    disableClose: true,
                                    data,
                                    hasBackdrop: false,
                                };

                                if (this.gisService.locationCardPosition) {
                                    dialogOptions.position = this.locationCardService.checkLocationCardPosition(false, this.gisService.locationCardPosition);
                                } else if (
                                    userSettings &&
                                    userSettings.locationPositionX &&
                                    userSettings.locationPositionY
                                ) {
                                    dialogOptions.position = this.locationCardService.getLocationCardPosition(false, userSettings);
                                }

                                if (this.compositeLocationDialog) {
                                    this.compositeLocationDialog.close();
                                }
                                this.compositeLocationDialog = this.dialog.open<
                                    CompositeLocComponent,
                                    CompositeLocComponentInput,
                                    IComponentModalResult
                                >(CompositeLocComponent, dialogOptions);

                                this.compositeLocationDialog.afterClosed().subscribe((result) => {
                                    if (result && result.success) {
                                        // this.locationIdEdited = location.locationId;
                                        this.getAllLocations();

                                        this.monitorLocationUpdate(false);
                                        this.uiUtilsService.safeChangeDetection(this.cdr);
                                    }
                                });
                            }
                        },
                        (error) => {
                            this.isLoading = false;
                        },
                    );
            });
        }
    }
    private setupRainGaugeLocations() {
        // check if rain guage locations are already filled and if so exit immediately
        if (this.assignedRainGauge && this.assignedRainGauge.length > 0) {
            return;
        }

        // check if locations exist
        if (this.locations) {
            // make the filtered array for assignedRainGauge.
            this.assignedRainGauge = this.locations.filter((location) => {
                if (location && location.series && location.series.toLowerCase().indexOf('rainalert') > -1) {
                    return location;
                }
            });
        }
    }

    public LocationDashboard() {
        const customerId = isNaN(this.customerID) ? 0 : this.customerID;
        this.router.navigate(['/pages/menuDashboard/viewData'], {
            queryParams: {
                c: customerId,
                lg: this.locationGroupID,
                lid: this.locationId,
            },
            relativeTo: this.activatedRoute,
        });
    }

    public openTurnOffWidgetsDialog() {
        this.dialog
        .open(TurnOffWidgetsDialogComponent, {
            disableClose: true,
        })
        .afterClosed()
        .subscribe((result) => {
        });
    }

    public onAssetsMenuOpened(): void {
        if (this.arcgisAssetsDropdown) {
            this.arcgisAssetsDropdown.resetFilter();
            this.arcgisAssetsDropdown.focusSearchInput();
        }
    }

    public onAssetsMenuClosed(): void {
        if (this.arcgisAssetsDropdown) {
            this.arcgisAssetsDropdown.applyPreSelection();
        }
    }

    public closeAssetsMenu(): void {
        if (this.assetsMenuTrigger) {
            this.assetsMenuTrigger.closeMenu();
        }
    }

    public async onAssetsSelectedAndCloseMenu(event: AssetsSelectionEvent) {
        this.closeAssetsMenu();
        await this.onAssetsSelected(event.assets, event.autoPlot);
    }

    public async onAssetsSelected(selectedAssets: AssetItem[], autoPlot: boolean = true, savedStates?: LayerTreeState[]): Promise<void> {
        this.showAssetsDropdown = false;

        try {
            this.clearArcGISLayersFromTree();

            this.updateSelectedArcgisAssetsMap(map => {
                map.clear();
                selectedAssets.forEach(asset => map.set(asset.id, asset));
            });

            for (const asset of selectedAssets) {
                if (this.arcgisLayerTreeNodes.has(asset.id)) {
                    continue;
                }

                const internalLayers = await this.fetchAssetInternalLayers(asset);

                if (internalLayers === null) {
                    this.updateSelectedArcgisAssetsMap(map => map.delete(asset.id));
                    continue;
                }

                const savedAssetState = savedStates?.find(s => s.assetId === asset.id);
                const assetIndex = selectedAssets.findIndex(a => a.id === asset.id);
                const assetTokenContext = this.buildTokenContextForAsset(asset);

                const childLayersPromises = (internalLayers || []).map(async (layer, layerIndex) => {
                    const layerId = layer.id.toString();
                    const savedLayerState = savedAssetState?.layers.find(l => l.id === layerId);

                    let layerMetadata = null;
                    let drawingInfo = null;
                    if (layer.serviceUrl) {
                        layerMetadata = await this.arcgisLayerCache.getLayerMetadata(
                            layer.serviceUrl,
                            layer.id,
                            assetTokenContext
                        );
                        drawingInfo = await this.arcgisLayerCache.getDrawingInfo(
                            layer.serviceUrl,
                            layer.id,
                            layer.webMapId || null,
                            assetTokenContext
                        );
                    }

                    const labelField = this.determineLabelField(drawingInfo);
                    const serverShowLabels = this.determineServerShowLabels(drawingInfo);
                    const labelMinScale = drawingInfo?.labelingInfo?.[0]?.minScale ?? 0;
                    const labelMaxScale = drawingInfo?.labelingInfo?.[0]?.maxScale ?? 0;

                    const enrichedLayer: ArcGISLayerData = {
                        ...layer,
                        layerPositionInAsset: layerIndex,
                        totalLayersInAsset: internalLayers.length,
                        assetIndex: assetIndex,
                        minScale: layerMetadata?.minScale ?? layer.minScale,
                        maxScale: layerMetadata?.maxScale ?? layer.maxScale,
                        labelField: labelField,
                        showLabels: serverShowLabels,
                        labelMinScale: labelMinScale,
                        labelMaxScale: labelMaxScale
                    };

                    const legendInfo = drawingInfo?.renderer
                        ? this.populateArcGISLegendInfo(drawingInfo.renderer)
                        : [];

                    const childLayer: ArcGISTreeNode = {
                        name: enrichedLayer.name,
                        checked: savedLayerState?.checked ?? autoPlot,
                        showLegend: false,
                        selection: true,
                        opacity: savedLayerState?.opacity ?? 1,
                        legendInfo: legendInfo,
                        isArcGIS: true,
                        id: `${asset.id}_${enrichedLayer.id}`,
                        parentId: asset.id,
                        level: 1,
                        assetType: asset.type,
                        layerData: enrichedLayer,
                        child: [],
                        showLabels: savedLayerState?.showLabels ?? serverShowLabels,
                        labelField: labelField
                    };

                    return childLayer;
                });

                const childLayers = await Promise.all(childLayersPromises);

                const treeNode: ArcGISTreeNode = {
                    name: asset.name,
                    checked: autoPlot,
                    showLegend: false,
                    selection: true,
                    opacity: 1,
                    legendInfo: [],
                    isArcGIS: true,
                    id: asset.id,
                    level: 0,
                    assetType: asset.type,
                    child: childLayers
                };

                this.arcgisLayerTreeNodes.set(asset.id, treeNode);

                const mapLayerItem: mapLayerList = {
                    name: asset.name,
                    checked: autoPlot,
                    showLegend: false,
                    selection: true,
                    opacity: 1,
                    legendInfo: [],
                    isArcGIS: true,
                    assetId: asset.id,
                    assetType: asset.type,
                    child: childLayers as mapLayerList[]
                };

                const monitorIndex = this.mapLayerLists.findIndex(node =>
                    node.name === LayerNameOpts.monitor || node.name === MONITOR_LAYER_NAME
                );

                let insertIndex: number;
                if (monitorIndex >= 0) {
                    // MONITOR_LAYER exists → insert after it
                    insertIndex = monitorIndex + 1;
                } else {
                    // MONITOR_LAYER not yet loaded → insert at end
                    // It will be moved to front when MONITOR loads with unshift()
                    insertIndex = this.mapLayerLists.length;
                }

                this.mapLayerLists.splice(insertIndex, 0, mapLayerItem);
            }

            this.layersDatabase.dataupdate(this.mapLayerLists);

            const checkedLayers = [];

            for (const treeNode of this.mapLayerLists) {
                if (treeNode.isArcGIS) {
                    if (treeNode.checked) {
                        checkedLayers.push(treeNode);
                    }

                    if (treeNode.child && treeNode.child.length > 0) {
                        for (const child of treeNode.child) {
                            if (child.checked && child.layerData) {
                                checkedLayers.push(child);
                            }
                        }
                    }
                }
            }

            if (checkedLayers.length > 0) {
                await this.layersTabLayerAdjust(checkedLayers, false);
            }

            this.saveCurrentSelection();

        } catch (error) {
            this.snackBar.open('Error loading ArcGIS assets', 'Close', {
                duration: 5000
            });
        }
    }

    private setupSelectionRestoration(): void {
        if (this.selectionRestorationSubscription) {
            this.selectionRestorationSubscription.unsubscribe();
            this.selectionRestorationSubscription = null;
        }

        this.selectionRestorationSubscription = this.arcgisUserService.organizationContentChanged
            .pipe(
                filter(content => !!content),
                first()
            )
            .subscribe(async () => {
                const username = sessionStorage.getItem(ARCGIS_USERNAME);

                if (!username || !this.customerID) {
                    return;
                }

                const savedState = this.arcgisSelectionPersistence.loadSelection(
                    this.customerID,
                    username
                );

                if (savedState) {
                    await this.applyRestoredSelection(savedState);
                }
            });
    }

    private async applyRestoredSelection(state: ArcGISSelectionState): Promise<void> {
        const assetsToSelect: AssetItem[] = state.selectedAssets.map(asset => ({
            id: asset.id,
            name: asset.name,
            type: asset.type,
            typeLabel: this.getAssetTypeLabel(asset.type),
            url: asset.url,
            selected: true,
            owner: asset.owner,
            modified: asset.modified,
            access: asset.access,
            contentStatus: asset.contentStatus,
            origin: asset.origin
        }));

        this.updateSelectedArcgisAssetsMap(map => {
            map.clear();
            assetsToSelect.forEach(asset => map.set(asset.id, asset));
        });

        await this.onAssetsSelected(assetsToSelect, true, state.layerTreeState);
    }

    private getAssetTypeLabel(type: 'feature-service' | 'web-map' | 'map-service'): string {
        const labels: Record<string, string> = {
            'feature-service': 'Feature Service',
            'web-map': 'Web Map',
            'map-service': 'Map Service'
        };
        return labels[type] || type;
    }

    private saveCurrentSelection() {
        const username = sessionStorage.getItem(ARCGIS_USERNAME);

        if (!username || !this.customerID) {
            return;
        }

        const selectedAssets: SelectedAsset[] = [];

        this.selectedArcgisAssetsMap.forEach(asset => {
            selectedAssets.push({
                id: asset.id,
                name: asset.name,
                type: asset.type,
                url: asset.url,
                owner: asset.owner,
                modified: asset.modified,
                access: asset.access,
                contentStatus: asset.contentStatus,
                origin: asset.origin
            });
        });

        const layerTreeState = [];

        this.arcgisLayerTreeNodes.forEach((treeNode, assetId) => {
            const layers = [];

            if (treeNode.child && treeNode.child.length > 0) {
                treeNode.child.forEach(childLayer => {
                    if (childLayer.layerData) {
                        layers.push({
                            id: childLayer.layerData.id.toString(),
                            name: childLayer.name,
                            url: childLayer.layerData.url,
                            checked: childLayer.checked,
                            opacity: childLayer.opacity || 0.8,
                            showLabels: childLayer.showLabels ?? false
                        });
                    }
                });
            }

            if (layers.length > 0) {
                layerTreeState.push({
                    assetId: assetId,
                    assetName: treeNode.name,
                    assetType: treeNode.assetType,
                    layers: layers
                });
            }
        });

        this.arcgisSelectionPersistence.saveSelection(
            this.customerID,
            username,
            selectedAssets,
            layerTreeState
        );
    }

    private findAssetById(assetId) {
        return this.arcgisFeatureLayers.find(a => a.id === assetId) ||
               this.arcgisWebMaps.find(a => a.id === assetId) ||
               this.arcgisMapServices.find(a => a.id === assetId);
    }

    private determineAssetType(asset) {
        if (asset.type === 'Feature Service') return 'feature-service';
        if (asset.type === 'Web Map') return 'web-map';
        if (asset.type === 'Map Service') return 'map-service';
        return 'feature-service';
    }

    private async fetchAssetInternalLayers(asset: AssetItem): Promise<ArcGISInternalLayer[] | null> {
        const internalLayers: ArcGISInternalLayer[] = [];
        const tokenContext = this.buildTokenContextForAsset(asset);

        try {
            if (asset.type === ARCGIS_CONSTANTS.ASSET_TYPES.FEATURE_SERVICE) {
                const response = await this.arcgisTokenManager.fetchWithAuthRetry(
                    force => this.arcgisTokenManager.buildUrlWithToken(asset.url, tokenContext, force)
                );
                const data = await response.json();

                if (data.error) {
                    if (this.isAuthFailureCode(data.error.code)) {
                        this.showAccessDeniedDialog(asset.name);
                        return null;
                    }
                    return internalLayers;
                }

                if (data.layers && data.layers.length > 0) {
                    for (const layer of data.layers) {
                        internalLayers.push({
                            id: layer.id,
                            name: layer.name,
                            url: asset.url + '/' + layer.id.toString(),
                            serviceUrl: asset.url,
                            parentId: asset.id,
                            parentName: asset.name,
                            parentType: ARCGIS_CONSTANTS.ASSET_TYPES.FEATURE_SERVICE,
                            checked: true,
                            geometryType: layer.geometryType,
                            minScale: layer.minScale,
                            maxScale: layer.maxScale,
                            defaultVisibility: layer.defaultVisibility !== false,
                            capabilities: layer.capabilities,
                            fields: layer.fields,
                            drawingInfo: layer.drawingInfo
                        });
                    }
                }

            } else if (asset.type === ARCGIS_CONSTANTS.ASSET_TYPES.WEB_MAP) {
                const webMapData = await this.arcgisUserService.fetchWebMapData(asset.id);

                if (webMapData && webMapData.operationalLayers) {
                    for (const layer of webMapData.operationalLayers) {
                        const serviceUrl = layer.url ? layer.url.substring(0, layer.url.lastIndexOf('/')) : null;
                        internalLayers.push({
                            id: layer.id,
                            name: layer.title || layer.id,
                            url: layer.url,
                            serviceUrl: serviceUrl,
                            webMapId: asset.id,
                            parentId: asset.id,
                            parentName: asset.name,
                            parentType: ARCGIS_CONSTANTS.ASSET_TYPES.WEB_MAP,
                            checked: true,
                            layerType: layer.layerType,
                            opacity: layer.opacity ?? 1,
                            visibility: layer.visibility !== false,
                            layerDefinition: layer.layerDefinition,
                            popupInfo: layer.popupInfo,
                            featureCollection: layer.featureCollection,
                            minScale: layer.layerDefinition?.minScale ?? layer.minScale,
                            maxScale: layer.layerDefinition?.maxScale ?? layer.maxScale
                        });
                    }
                }

            } else if (asset.type === ARCGIS_CONSTANTS.ASSET_TYPES.MAP_SERVICE) {
                const response = await this.arcgisTokenManager.fetchWithAuthRetry(
                    force => this.arcgisTokenManager.buildUrlWithToken(asset.url, tokenContext, force)
                );
                const data = await response.json();

                if (data.error) {
                    if (this.isAuthFailureCode(data.error.code)) {
                        this.showAccessDeniedDialog(asset.name);
                        return null;
                    }
                    return internalLayers;
                }

                if (data.layers && data.layers.length > 0) {
                    for (const layer of data.layers) {
                        internalLayers.push({
                            id: layer.id,
                            name: layer.name,
                            url: asset.url + '/' + layer.id.toString(),
                            serviceUrl: asset.url,
                            parentId: asset.id,
                            parentName: asset.name,
                            parentType: ARCGIS_CONSTANTS.ASSET_TYPES.MAP_SERVICE,
                            checked: true,
                            geometryType: layer.geometryType,
                            minScale: layer.minScale,
                            maxScale: layer.maxScale,
                            defaultVisibility: layer.defaultVisibility !== false
                        });
                    }
                }
            }

        } catch (error) {
            console.error('Error fetching internal layers for:', asset.name, error);
        }

        return internalLayers;
    }

    private showAccessDeniedDialog(layerName: string): void {
        this.dialog.open(ConfirmationDialogComponent, {
            data: {
                title: this.translate.instant('HOME.ARCGIS.UNABLE_TO_ADD_LAYER', { layerName: layerName }),
                message: this.translate.instant('HOME.ARCGIS.NOT_AUTHORIZED_TO_ACCESS'),
                cancelText: '',
                okText: this.translate.instant('COMMON.OK')
            }
        });
    }

    private isAuthFailureCode(code: number): boolean {
        return code === ARCGIS_CONSTANTS.ERROR_CODES.FORBIDDEN
            || code === ARCGIS_CONSTANTS.ERROR_CODES.TOKEN_REQUIRED
            || code === ARCGIS_CONSTANTS.ERROR_CODES.INVALID_TOKEN;
    }

    private buildTokenContextForAsset(asset: AssetItem): ServiceTokenContext {
        return {
            serviceUrl: asset.url,
            access: asset.access,
            contentStatus: asset.contentStatus,
            origin: asset.origin
        };
    }

    private findFullAssetData(assetId: string): ArcGISFeatureService | ArcGISWebMap | ArcGISMapService | null {
        const featureService = this.arcgisFeatureLayers.find(a => a.id === assetId);
        if (featureService) {
            return featureService;
        }

        const webMap = this.arcgisWebMaps.find(a => a.id === assetId);
        if (webMap) {
            return webMap;
        }

        const mapService = this.arcgisMapServices.find(a => a.id === assetId);
        if (mapService) {
            return mapService;
        }

        return null;
    }

    private buildTokenContextFromTreeNode(treeNode: ArcGISTreeNode, serviceUrl: string): ServiceTokenContext {
        const parentAssetId = treeNode.parentId || (treeNode.layerData as ArcGISLayerData)?.itemId;
        if (parentAssetId) {
            const selectedAsset = this.selectedArcgisAssetsMap.get(parentAssetId);
            if (selectedAsset) {
                return {
                    serviceUrl: serviceUrl,
                    access: selectedAsset.access,
                    contentStatus: selectedAsset.contentStatus,
                    origin: selectedAsset.origin
                };
            }
        }

        return {
            serviceUrl: serviceUrl
        };
    }

    private clearArcGISLayersFromTree(): void {
        if (this.olMap) {
            this.arcgisMapLayers.forEach((layer, id) => {
                layer.setSource(null);
                this.olMap.removeLayer(layer);
                layer.dispose();
            });
            this.arcgisMapLayers.clear();

            this.arcgisImageLayers.forEach((layer, id) => {
                layer.setSource(null);
                this.olMap.removeLayer(layer);
                layer.dispose();
            });
            this.arcgisImageLayers.clear();
        }

        this.mapLayerLists = this.mapLayerLists.filter(node => !node.isArcGIS);

        this.arcgisLayerTreeNodes.clear();
        this.inFlightLayerPlots.clear();
        this.arcgisLayerStyleCache.clear();

        this.layersDatabase.dataupdate(this.mapLayerLists);
    }

    private cleanupAllArcGISContent(): void {
        if (this.olMap) {
            this.arcgisMapLayers.forEach((layer) => {
                const source = layer.getSource();
                if (source && 'getFeatures' in source) {
                    const vectorSource = source as VectorSource;
                    const features = vectorSource.getFeatures();
                    features.forEach((feature: Feature) => {
                        feature.setStyle(null);
                    });
                    vectorSource.clear();
                }
                this.olMap.removeLayer(layer);
                layer.setSource(null);
                layer.dispose();
            });
            this.arcgisMapLayers.clear();

            this.arcgisImageLayers.forEach((layer) => {
                this.olMap.removeLayer(layer);
                layer.setSource(null);
                layer.dispose();
            });
            this.arcgisImageLayers.clear();

            this.arcgisAssetLayers.forEach((layer) => {
                const source = layer.getSource();
                if (source && 'getFeatures' in source) {
                    const vectorSource = source as VectorSource;
                    const features = vectorSource.getFeatures();
                    features.forEach((feature: Feature) => {
                        feature.setStyle(null);
                    });
                    vectorSource.clear();
                }
                this.olMap.removeLayer(layer);
                layer.setSource(null);
                layer.dispose();
            });
            this.arcgisAssetLayers.clear();
            this.arcgisAssetSources.clear();
        }

        this.mapLayerLists = this.mapLayerLists.filter(node => !node.isArcGIS);

        this.arcgisLayerTreeNodes.clear();
        this.inFlightLayerPlots.clear();
        this.arcgisLayerStyleCache.clear();

        this.updateSelectedArcgisAssetsMap(map => map.clear());
        this.showAssetsDropdown = false;
        this.activeAssetLayerId = null;

        this.arcgisFeatureLayers = [];
        this.arcgisWebMaps = [];
        this.arcgisMapServices = [];
        this.filteredArcgisAssets = [];
        this.arcgisOrganizationContent = null;
        this.arcgisOrganizationName = '';

        this.layersDatabase.dataupdate(this.mapLayerLists);

        if (this.olMap) {
            this.olMap.render();
        }
    }

    private async cleanupAllArcGISContentAsync(): Promise<void> {
        if (!this.olMap) {
            return;
        }

        this.olSubscriptions.forEach(key => {
            unByKey(key);
        });
        this.olSubscriptions = [];

        const layersToRemove: (VectorLayer | VectorImageLayer | ImageLayer)[] = [];

        this.arcgisMapLayers.forEach((layer) => {
            layersToRemove.push(layer);
        });

        this.arcgisImageLayers.forEach((layer) => {
            layersToRemove.push(layer);
        });

        this.arcgisAssetLayers.forEach((layer) => {
            layersToRemove.push(layer);
        });

        layersToRemove.forEach(layer => {
            this.olMap.removeLayer(layer);
        });

        await new Promise<void>(resolve => {
            requestAnimationFrame(() => {
                requestAnimationFrame(() => resolve());
            });
        });

        layersToRemove.forEach(layer => {
            try {
                const source = layer.getSource();
                if (source && 'getFeatures' in source) {
                    const vectorSource = source as VectorSource;
                    const features = vectorSource.getFeatures();
                    features.forEach((feature: Feature) => {
                        feature.setStyle(null);
                    });
                    vectorSource.clear();
                }
                layer.setSource(null);
                layer.dispose();
            } catch (error) {
                console.debug('Layer disposal error during cleanup:', error);
            }
        });

        this.arcgisMapLayers.clear();
        this.arcgisImageLayers.clear();
        this.arcgisAssetLayers.clear();
        this.arcgisAssetSources.clear();

        this.mapLayerLists = this.mapLayerLists.filter(node => !node.isArcGIS);
        this.arcgisLayerTreeNodes.clear();
        this.arcgisLayerStyleCache.clear();
        this.updateSelectedArcgisAssetsMap(map => map.clear());
        this.showAssetsDropdown = false;
        this.activeAssetLayerId = null;

        this.arcgisFeatureLayers = [];
        this.arcgisWebMaps = [];
        this.arcgisMapServices = [];
        this.filteredArcgisAssets = [];
        this.arcgisOrganizationContent = null;
        this.arcgisOrganizationName = '';

        this.layersDatabase.dataupdate(this.mapLayerLists);
        this.olMap.render();
    }

    private convertToArcGISTreeNode(layer: mapLayerList): ArcGISTreeNode {
        return {
            name: layer.name,
            checked: layer.checked,
            showLegend: layer.showLegend,
            selection: layer.selection,
            level: 0,
            isArcGIS: layer.isArcGIS || false,
            id: layer.assetId || layer.name,
            layerData: layer.layerData,
            child: layer.child ? layer.child.map(c => this.convertToArcGISTreeNode(c)) : undefined,
            assetType: layer.assetType as 'feature-service' | 'web-map' | 'map-service',
            opacity: layer.opacity,
            visible: layer.checked,
            showLabels: layer.showLabels,
            labelField: layer.labelField
        };
    }

    private plotLayerWithTimeSlicing(layer: mapLayerList): Promise<void> {
        return this.ngZone.runOutsideAngular(() => {
            return new Promise<void>((resolve) => {
                const processLayer = () => {
                    requestAnimationFrame(async () => {
                        const arcgisNode = this.convertToArcGISTreeNode(layer);
                        await this.plotArcGISLayerFromTree(arcgisNode);
                        resolve();
                    });
                };
                processLayer();
            });
        });
    }

    private isArcGISWebMap(layerData: ArcGISLayerData | ArcGISFeatureLayer | ArcGISWebMap): layerData is ArcGISWebMap {
        return (layerData as ArcGISWebMap).type === 'Web Map';
    }

    private getLayerName(layerData: ArcGISLayerData | ArcGISFeatureLayer | ArcGISWebMap): string {
        if (this.isArcGISWebMap(layerData)) {
            return layerData.title;
        }
        return (layerData as ArcGISLayerData | ArcGISFeatureLayer).name;
    }

    private isArcGISLayerData(layerData: ArcGISLayerData | ArcGISFeatureLayer | ArcGISWebMap): layerData is ArcGISLayerData {
        return 'assetIndex' in layerData && 'totalLayersInAsset' in layerData && 'layerPositionInAsset' in layerData;
    }

    private filterValidGeometryFeatures(features: ArcGISFeature[]): ArcGISFeature[] {
        return features.filter(feature => this.hasValidGeometry(feature.geometry));
    }

    private hasValidGeometry(geometry: ArcGISGeometry | undefined): boolean {
        if (!geometry) {
            return false;
        }

        if (geometry.x !== undefined || geometry.y !== undefined) {
            return typeof geometry.x === 'number' && typeof geometry.y === 'number' &&
                   !Number.isNaN(geometry.x) && !Number.isNaN(geometry.y);
        }

        if (geometry.points !== undefined) {
            return Array.isArray(geometry.points) && geometry.points.length > 0;
        }

        if (geometry.paths !== undefined) {
            return Array.isArray(geometry.paths) && geometry.paths.length > 0;
        }

        if (geometry.rings !== undefined) {
            return Array.isArray(geometry.rings) && geometry.rings.length > 0;
        }

        return false;
    }

    private getUniqueLayerKey(serviceUrl: string, layerId: number | string): string {
        return serviceUrl + '/' + layerId.toString();
    }

    private async plotArcGISLayerFromTree(treeNode: ArcGISTreeNode): Promise<void> {
        const sessionIdAtStart = this.arcgisLayerCache.getSessionId();
        const layerData = treeNode.layerData;

        if (!layerData || this.isArcGISWebMap(layerData)) {
            return;
        }

        const layerDataCast = layerData as ArcGISLayerData;
        const serviceUrl = layerDataCast.serviceUrl;
        const layerId = layerDataCast.id;

        if (!serviceUrl) {
            return;
        }

        const uniqueLayerKey = this.getUniqueLayerKey(serviceUrl, layerId);

        if (this.arcgisMapLayers.has(uniqueLayerKey) || this.arcgisImageLayers.has(uniqueLayerKey)) {
            return;
        }

        if (this.inFlightLayerPlots.has(uniqueLayerKey)) {
            return;
        }

        this.inFlightLayerPlots.add(uniqueLayerKey);

        try {
            if (treeNode.assetType === 'map-service') {
                await this.plotMapServiceLayer(treeNode, serviceUrl, layerId, sessionIdAtStart);
                return;
            }

            const tokenContext = this.buildTokenContextFromTreeNode(treeNode, serviceUrl);

            const drawingInfo = await this.arcgisLayerCache.getDrawingInfo(serviceUrl, layerId, layerData.webMapId, tokenContext);

            if (!this.arcgisLayerCache.isSessionValid(sessionIdAtStart)) {
                return;
            }

            const features = await this.arcgisLayerCache.getFeatures(serviceUrl, layerId, tokenContext);

            if (!this.arcgisLayerCache.isSessionValid(sessionIdAtStart)) {
                return;
            }

            if (!features || features.length === 0) {
                this.snackBar.open(`No features found in ${layerData.name}`, 'Close', {
                    duration: 3000
                });
                return;
            }

            const validFeatures = this.filterValidGeometryFeatures(features);

            if (validFeatures.length === 0) {
                this.snackBar.open(`No valid geometries found in ${layerData.name}`, 'Close', {
                    duration: 3000
                });
                return;
            }

            const esriData = {
                features: validFeatures,
                geometryType: layerData.geometryType
            };

            const readFeatures = esrijsonFormat.readFeatures(esriData, {
                featureProjection: 'EPSG:3857'
            });

            if (layerData.geometryType) {
                this.geometryTypesLoaded.add(layerData.geometryType);
                this.arcgisLayerCache.setGeometryType(serviceUrl, layerId, layerData.geometryType);
            }
            readFeatures.forEach(feature => {
                const geomType = feature.getGeometry()?.getType();
                if (geomType) {
                    this.geometryTypesLoaded.add(`OL_${geomType}`);
                }
            });

            const layerDataCasted = layerData as ArcGISLayerData;
            const styleFunction = this.createCachedStyleFunction(
                drawingInfo?.renderer || null,
                layerData.geometryType || 'esriGeometryPoint',
                uniqueLayerKey,
                {
                    showLabels: treeNode.showLabels ?? false,
                    labelField: treeNode.labelField || layerDataCasted.labelField || null,
                    labelMinScale: layerDataCasted.labelMinScale ?? 0,
                    labelMaxScale: layerDataCasted.labelMaxScale ?? 0
                }
            );

            const vectorSource = new VectorSource({
                features: readFeatures
            });

            let minResolution = layerData.maxScale ? layerData.maxScale / (ESRI_INCHES_PER_METER * ESRI_DOTS_PER_INCH) : undefined;
            let maxResolution = layerData.minScale ? layerData.minScale / (ESRI_INCHES_PER_METER * ESRI_DOTS_PER_INCH) : undefined;

            if (minResolution !== undefined && maxResolution !== undefined && minResolution === maxResolution) {
                if (minResolution === 0) {
                    maxResolution = undefined;
                } else {
                    minResolution = 0;
                }
            }

            const zIndex = this.calculateArcGISLayerZIndex(layerData);

            const vectorLayer = new VectorImageLayer({
                source: vectorSource,
                style: styleFunction,
                visible: true,
                opacity: treeNode.opacity || 1,
                zIndex: zIndex,
                imageRatio: 2,
                minResolution: minResolution,
                maxResolution: maxResolution
            });

            vectorLayer.set('name', this.getLayerName(layerData));

            const extent = vectorSource.getExtent();
            if (extent && !isEmpty(extent)) {
                vectorLayer.set('esriExtent', extent);
            }

            if (!this.arcgisLayerCache.isSessionValid(sessionIdAtStart)) {
                vectorSource.clear();
                vectorLayer.setSource(null);
                vectorLayer.dispose();
                return;
            }

            if (this.arcgisMapLayers.has(uniqueLayerKey)) {
                vectorSource.clear();
                vectorLayer.setSource(null);
                vectorLayer.dispose();
                return;
            }

            this.arcgisMapLayers.set(uniqueLayerKey, vectorLayer);
            this.olMap.addLayer(vectorLayer);

            treeNode.checked = true;
            this.logGeometryTypeSummary();

        } catch (error) {
            if ((error as DOMException).name === ARCGIS_CONSTANTS.ABORT_ERROR.NAME) {
                return;
            }
            console.error('Error plotting ArcGIS layer:', uniqueLayerKey, error);
            this.snackBar.open(`Error loading ${this.getLayerName(layerData)}`, 'Close', {
                duration: 5000
            });
            treeNode.checked = false;
        } finally {
            this.inFlightLayerPlots.delete(uniqueLayerKey);
        }
    }

    private calculateArcGISLayerZIndex(layerData: ArcGISLayerData | ArcGISFeatureLayer | ArcGISWebMap): number {
        const baseZIndex = 1100;
        if (this.isArcGISLayerData(layerData)) {
            const assetBaseZIndex = (layerData.assetIndex || 0) * 100;
            const layerOffset = (layerData.totalLayersInAsset || 1) - (layerData.layerPositionInAsset || 0) - 1;
            return baseZIndex + assetBaseZIndex + layerOffset;
        }
        return baseZIndex;
    }

    private async plotMapServiceLayer(treeNode: ArcGISTreeNode, serviceUrl: string, layerId: number | string, sessionIdAtStart: string | null): Promise<void> {
        const layerData = treeNode.layerData;

        if (!layerData || this.isArcGISWebMap(layerData)) {
            return;
        }

        const tokenContext = this.buildTokenContextFromTreeNode(treeNode, serviceUrl);
        const token = this.arcgisTokenManager.getTokenForService(serviceUrl, tokenContext);

        let minResolution = layerData.maxScale ? layerData.maxScale / (ESRI_INCHES_PER_METER * ESRI_DOTS_PER_INCH) : undefined;
        let maxResolution = layerData.minScale ? layerData.minScale / (ESRI_INCHES_PER_METER * ESRI_DOTS_PER_INCH) : undefined;

        if (minResolution !== undefined && maxResolution !== undefined && minResolution === maxResolution) {
            if (minResolution === 0) {
                maxResolution = undefined;
            } else {
                minResolution = 0;
            }
        }

        const imageLayer = new ImageLayer({
            source: new ImageArcGISRest({
                url: serviceUrl,
                params: {
                    'LAYERS': 'show:' + layerId.toString(),
                    'FORMAT': 'PNG32',
                    'TRANSPARENT': true
                },
                ratio: 1.5,
                projection: 'EPSG:3857'
            }),
            opacity: treeNode.opacity || 1,
            visible: true,
            zIndex: this.calculateArcGISLayerZIndex(layerData),
            minResolution: minResolution,
            maxResolution: maxResolution
        });

        if (token) {
            const source = imageLayer.getSource() as ImageArcGISRest;
            if (source) {
                const params = source.getParams();
                params[ARCGIS_CONSTANTS.QUERY_PARAMS.TOKEN] = token;
                source.updateParams(params);
            }
        }

        imageLayer.set('name', this.getLayerName(layerData));

        try {
            const extent = await this.arcgisLayerCache.getLayerExtent(serviceUrl, layerId, tokenContext);
            if (extent && !isEmpty(extent)) {
                imageLayer.set('esriExtent', extent);
            }
        } catch (error) {
            if ((error as DOMException).name === ARCGIS_CONSTANTS.ABORT_ERROR.NAME) {
                imageLayer.setSource(null);
                imageLayer.dispose();
                return;
            }
        }

        if (!this.arcgisLayerCache.isSessionValid(sessionIdAtStart)) {
            imageLayer.setSource(null);
            imageLayer.dispose();
            return;
        }

        const uniqueLayerKey = this.getUniqueLayerKey(serviceUrl, layerId);

        if (this.arcgisImageLayers.has(uniqueLayerKey)) {
            imageLayer.setSource(null);
            imageLayer.dispose();
            return;
        }

        this.arcgisImageLayers.set(uniqueLayerKey, imageLayer);
        this.olMap.addLayer(imageLayer);
        treeNode.checked = true;
    }

    private updateArcGISLayerProperties(layerKey: string, visible: boolean, opacity: number): void {
        const vectorLayer = this.arcgisMapLayers.get(layerKey);
        const imageLayer = this.arcgisImageLayers.get(layerKey);

        if (vectorLayer) {
            vectorLayer.setVisible(visible);
            if (opacity !== null && opacity !== undefined) {
                vectorLayer.setOpacity(opacity);
            }
        }

        if (imageLayer) {
            imageLayer.setVisible(visible);
            if (opacity !== null && opacity !== undefined) {
                imageLayer.setOpacity(opacity);
            }
        }

        this.arcgisLayerTreeNodes.forEach((treeNode) => {
            if (treeNode.child && treeNode.child.length > 0) {
                treeNode.child.forEach(childLayer => {
                    if (childLayer.layerData) {
                        const layerDataCast = childLayer.layerData as ArcGISLayerData;
                        const childLayerKey = this.getUniqueLayerKey(layerDataCast.serviceUrl, layerDataCast.id);
                        if (childLayerKey === layerKey) {
                            childLayer.checked = visible;
                            if (opacity !== null && opacity !== undefined) {
                                childLayer.opacity = opacity;
                            }
                        }
                    }
                });
            }
        });
    }

    private removeArcGISLayerFromMap(layerKey: string): void {
        const vectorLayer = this.arcgisMapLayers.get(layerKey);
        const imageLayer = this.arcgisImageLayers.get(layerKey);

        if (vectorLayer) {
            this.olMap.removeLayer(vectorLayer);
            this.arcgisMapLayers.delete(layerKey);
            this.clearLayerStyleCache(layerKey);
        }

        if (imageLayer) {
            this.olMap.removeLayer(imageLayer);
            this.arcgisImageLayers.delete(layerKey);
        }
    }

    public async onArcGISLabelsChanged(layer: mapLayerList): Promise<void> {
        if (!layer.layerData || !layer.isArcGIS) return;

        const layerData = layer.layerData as ArcGISLayerData;
        const uniqueLayerKey = this.getUniqueLayerKey(layerData.serviceUrl, layerData.id);

        let matchedTreeChild: ArcGISTreeNode | null = null;
        this.arcgisLayerTreeNodes.forEach(treeNode => {
            if (treeNode.child) {
                const childNode = treeNode.child.find(c =>
                    c.layerData && (c.layerData as ArcGISLayerData).id === layerData.id &&
                    (c.layerData as ArcGISLayerData).serviceUrl === layerData.serviceUrl
                );
                if (childNode) {
                    childNode.showLabels = layer.showLabels;
                    matchedTreeChild = childNode;
                }
            }
        });

        for (const mapLayer of this.mapLayerLists) {
            if (mapLayer.child) {
                const child = mapLayer.child.find(c =>
                    c.layerData && (c.layerData as ArcGISLayerData).id === layerData.id &&
                    (c.layerData as ArcGISLayerData).serviceUrl === layerData.serviceUrl
                );
                if (child) {
                    child.showLabels = layer.showLabels;
                    break;
                }
            }
        }

        const vectorLayer = this.arcgisMapLayers.get(uniqueLayerKey);
        if (vectorLayer && layer.checked) {
            this.clearLayerStyleCache(uniqueLayerKey);

            const labelsTokenContext = matchedTreeChild
                ? this.buildTokenContextFromTreeNode(matchedTreeChild, layerData.serviceUrl)
                : undefined;

            const drawingInfo = await this.arcgisLayerCache.getDrawingInfo(
                layerData.serviceUrl,
                layerData.id,
                layerData.webMapId,
                labelsTokenContext
            );

            const labelMinScale = drawingInfo?.labelingInfo?.[0]?.minScale ?? layerData.labelMinScale ?? 0;
            const labelMaxScale = drawingInfo?.labelingInfo?.[0]?.maxScale ?? layerData.labelMaxScale ?? 0;

            const styleFunction = this.createCachedStyleFunction(
                drawingInfo?.renderer || null,
                layerData.geometryType || 'esriGeometryPoint',
                uniqueLayerKey,
                {
                    showLabels: layer.showLabels ?? false,
                    labelField: layer.labelField || layerData.labelField || null,
                    labelMinScale: labelMinScale,
                    labelMaxScale: labelMaxScale
                }
            );

            vectorLayer.setStyle(styleFunction);
        }

        this.saveCurrentSelection();
    }

    public removeArcGISAssetFromMap(layerInfo: mapLayerList): void {
        try {
            if (layerInfo.child && layerInfo.child.length > 0) {
                for (const childLayer of layerInfo.child) {
                    if (childLayer.layerData && childLayer.layerData.id !== null && childLayer.layerData.id !== undefined) {
                        const layerDataCast = childLayer.layerData as ArcGISLayerData;
                        const layerKey = this.getUniqueLayerKey(layerDataCast.serviceUrl, layerDataCast.id);
                        this.removeArcGISLayerFromMap(layerKey);
                    }
                }
            }

            if (layerInfo.assetId) {
                this.arcgisLayerTreeNodes.delete(layerInfo.assetId);
                this.updateSelectedArcgisAssetsMap(map => map.delete(layerInfo.assetId));
            }

            const indexToRemove = this.mapLayerLists.findIndex(
                node => node.isArcGIS &&
                        node.name === layerInfo.name &&
                        node.assetId === layerInfo.assetId
            );

            if (indexToRemove !== -1) {
                this.mapLayerLists.splice(indexToRemove, 1);
            }

            this.layerList.loaddata(this.mapLayerLists);

            this.saveCurrentSelection();
        } catch (error) {
            this.snackBar.open('Error removing layer', 'Close', { duration: 3000 });
        }
    }

    public closeArcgisAssetsOverlay() {
        this.showArcgisAssetsOverlay = false;
        this.arcgisAssetsSearchTerm = '';
        this.filteredArcgisAssets = [...this.arcgisFeatureLayers, ...this.arcgisWebMaps];
    }

    public filterArcgisAssets() {
        const searchTerm = this.arcgisAssetsSearchTerm.toLowerCase().trim();
        if (!searchTerm) {
            this.filteredArcgisAssets = [...this.arcgisFeatureLayers, ...this.arcgisWebMaps];
            return;
        }

        const featureLayerResults = this.arcgisFeatureLayers.filter((layer: ArcGISFeatureService) =>
            layer.title?.toLowerCase().includes(searchTerm) ||
            layer.url?.toLowerCase().includes(searchTerm) ||
            layer.type?.toLowerCase().includes(searchTerm)
        );
        const webMapResults = this.arcgisWebMaps.filter((map: ArcGISWebMap) =>
            map.title?.toLowerCase().includes(searchTerm) ||
            map.url?.toLowerCase().includes(searchTerm)
        );
        this.filteredArcgisAssets = [...featureLayerResults, ...webMapResults];
    }

    public selectAllArcgisAssets() {
        this.updateSelectedArcgisAssetsMap(map => {
            this.filteredArcgisAssets.forEach(layer => {
                const assetItem = this.convertRawAssetToAssetItem(layer);
                map.set(layer.id.toString(), assetItem);
            });
        });
    }

    public selectNoneArcgisAssets() {
        this.updateSelectedArcgisAssetsMap(map => {
            this.filteredArcgisAssets.forEach(layer => map.delete(layer.id.toString()));
        });
    }

    public toggleArcgisAssetSelection(layerId: string, isSelected: boolean) {
        if (isSelected) {
            const asset = this.findAssetById(layerId);
            if (asset) {
                const assetItem = this.convertRawAssetToAssetItem(asset);
                this.updateSelectedArcgisAssetsMap(map => map.set(layerId.toString(), assetItem));
            }
        } else {
            this.updateSelectedArcgisAssetsMap(map => map.delete(layerId.toString()));
        }
    }

    private convertRawAssetToAssetItem(asset: ArcGISFeatureService | ArcGISWebMap | ArcGISMapService): AssetItem {
        let assetType: typeof ARCGIS_CONSTANTS.ASSET_TYPES[keyof typeof ARCGIS_CONSTANTS.ASSET_TYPES];
        let typeLabel: string;

        if (asset.type === ARCGIS_CONSTANTS.SERVICE_TYPES.FEATURE_SERVICE) {
            assetType = ARCGIS_CONSTANTS.ASSET_TYPES.FEATURE_SERVICE;
            typeLabel = ARCGIS_CONSTANTS.ASSET_TYPE_LABELS.FEATURE_SERVICE;
        } else if (asset.type === ARCGIS_CONSTANTS.SERVICE_TYPES.WEB_MAP) {
            assetType = ARCGIS_CONSTANTS.ASSET_TYPES.WEB_MAP;
            typeLabel = ARCGIS_CONSTANTS.ASSET_TYPE_LABELS.WEB_MAP;
        } else if (asset.type === ARCGIS_CONSTANTS.SERVICE_TYPES.MAP_SERVICE) {
            assetType = ARCGIS_CONSTANTS.ASSET_TYPES.MAP_SERVICE;
            typeLabel = ARCGIS_CONSTANTS.ASSET_TYPE_LABELS.MAP_SERVICE;
        } else {
            assetType = ARCGIS_CONSTANTS.ASSET_TYPES.FEATURE_SERVICE;
            typeLabel = ARCGIS_CONSTANTS.ASSET_TYPE_LABELS.FEATURE_SERVICE;
        }

        return {
            id: asset.id,
            name: asset.title,
            type: assetType,
            typeLabel: typeLabel,
            url: asset.url,
            selected: true,
            owner: asset.owner,
            modified: asset.modified,
            access: asset.access,
            contentStatus: asset.contentStatus,
            origin: asset.origin
        };
    }

    private async loadArcgisAssetLayer(layer: ArcGISFeatureLayer) {
        if (this.arcgisAssetLayers.has(layer.id)) {
            const existingLayer = this.arcgisAssetLayers.get(layer.id);
            existingLayer.setVisible(true);
            return;
        }

        try {
            const drawingInfo = await this.arcgisLayerCache.getDrawingInfo(layer.serviceUrl, layer.id, layer.webMapId);

            const allFeatures = await this.arcgisLayerCache.getFeatures(
                layer.serviceUrl,
                layer.id
            );

            if (!allFeatures || allFeatures.length === 0) {
                this.snackBar.open(`No features found in layer: ${layer.name}`, 'Close', {
                    duration: 3000
                });
                return;
            }

            const data = {
                features: allFeatures,
                spatialReference: allFeatures[0]?.geometry?.spatialReference
            };

            let dataProjection = 'EPSG:4326';

            if (data.spatialReference?.wkid === 102100 || data.spatialReference?.wkid === 3857) {
                dataProjection = 'EPSG:3857';
            } else if (data.spatialReference?.wkid === 4326) {
                dataProjection = 'EPSG:4326';
            } else if (data.spatialReference?.wkid) {
                dataProjection = `EPSG:${data.spatialReference.wkid}`;
            }

            const esriFeatures = data.features.map(feature => {
                return esrijsonFormat.readFeature(feature, {
                    dataProjection: dataProjection,
                    featureProjection: this.projection
                });
            });

            if (layer.geometryType) {
                this.geometryTypesLoaded.add(layer.geometryType);
            }
            esriFeatures.forEach(feature => {
                const geomType = feature.getGeometry()?.getType();
                if (geomType) {
                    this.geometryTypesLoaded.add(`OL_${geomType}`);
                }
            });

            const vectorSource = new VectorSource({
                features: esriFeatures
            });

            // Apply exact symbology from drawingInfo or fallback to default
            let styleFunction: StyleFunction;

            if (drawingInfo && drawingInfo.renderer) {
                styleFunction = (feature: Feature) => {
                    return this.applyRendererToFeature(feature, drawingInfo.renderer);
                };
            } else {
                const layerStyle = this.createArcgisAssetLayerStyle(layer);
                styleFunction = () => layerStyle;
            }

            const vectorLayer = new VectorLayer({
                source: vectorSource,
                style: styleFunction,
                name: `${LayerNameOpts.arcgisAssets}_${layer.id}`,
                zIndex: 200
            });

            this.arcgisAssetLayers.set(layer.id, vectorLayer);
            this.arcgisAssetSources.set(layer.id, vectorSource);
            this.olMap.addLayer(vectorLayer);

            this.mapLayerLists.push({
                checked: true,
                name: `${LayerNameOpts.arcgisAssets}_${layer.id}`,
                selection: false,
                showLegend: false,
                legendInfo: [],
                opacity: this.defaultOpacity
            });

            this.logGeometryTypeSummary();

        } catch (error) {
            this.snackBar.open(`Error loading layer: ${layer.name}`, 'Close', {
                duration: 3000
            });
        }
    }

    private removeArcgisAssetLayer(layerId: number) {
        const layer = this.arcgisAssetLayers.get(layerId);
        if (layer) {
            this.olMap.removeLayer(layer);
            this.arcgisAssetLayers.delete(layerId);
            this.arcgisAssetSources.delete(layerId);

            const layerIndex = this.mapLayerLists.findIndex(m => m.name === `${LayerNameOpts.arcgisAssets}_${layerId}`);
            if (layerIndex > -1) {
                this.mapLayerLists.splice(layerIndex, 1);
            }
        }
    }

    private createArcgisAssetLayerStyle(layer: ArcGISFeatureLayer) {
        return new Style({
            fill: new Fill({
                color: 'rgba(255, 165, 0, 0.2)'
            }),
            stroke: new Stroke({
                color: '#FF8C00',
                width: 2
            }),
            image: new StyleCircle({
                radius: 6,
                fill: new Fill({
                    color: '#FF8C00'
                }),
                stroke: new Stroke({
                    color: '#FFF',
                    width: 2
                })
            })
        });
    }

    private clearAllArcgisAssets(): void {
        this.cleanupAllArcGISContent();
    }
}
